import React from 'react';

const Trope1: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-1 prefix__trope-decor"
      transform="translate(100, 215)"
    >
      <g>
        <g>
          <g>
            <g>
              <path
                d="M42.57,161.22c5.23-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.65.31,2.65,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,42.57,161.22Z"
                fill="#2f6840"
              />
              <path
                d="M42,160.81c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.8A17.65,17.65,0,0,1,42,160.81Z"
                fill="#3ba525"
              />
              <path
                d="M42.86,160.78a2.45,2.45,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.13,1.13,0,0,1,42.86,160.78Z"
                fill="#2f6840"
              />
              <path
                d="M47,159.84c-.31,0-.59,0-.86.11a5.22,5.22,0,0,0-.8.21,13.7,13.7,0,0,0-1.59.62,2.81,2.81,0,0,1,1.46-1A2.46,2.46,0,0,1,47,159.84Z"
                fill="#2f6840"
              />
              <path
                d="M45.36,163.63a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.57,2.57,0,0,1,1.44.65,2.13,2.13,0,0,1,.47.67A1.13,1.13,0,0,1,45.36,163.63Z"
                fill="#2f6840"
              />
              <path
                d="M43,161.32c-.29.07-.56.1-.82.19a3.44,3.44,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.36,2.36,0,0,1,43,161.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M39.43,171.54c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,4-3.55,3-2.67-2.69-2.46-2.8A17.12,17.12,0,0,1,39.43,171.54Z"
                fill="#2f6840"
              />
              <path
                d="M38.83,171.13c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.2,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.52,17.52,0,0,1,38.83,171.13Z"
                fill="#3ba525"
              />
              <path
                d="M39.72,171.1a2.51,2.51,0,0,0-.94-1.11c-.38-.32-.83-.54-1.27-.87a2.71,2.71,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,39.72,171.1Z"
                fill="#2f6840"
              />
              <path
                d="M43.83,170.16c-.3,0-.58.05-.86.11a4.49,4.49,0,0,0-.8.21,13.31,13.31,0,0,0-1.59.62,3,3,0,0,1,1.47-1A2.48,2.48,0,0,1,43.83,170.16Z"
                fill="#2f6840"
              />
              <path
                d="M42.21,174a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,42.21,174Z"
                fill="#2f6840"
              />
              <path
                d="M39.9,171.64c-.29.07-.56.1-.83.19a3.44,3.44,0,0,0-.76.27,10.94,10.94,0,0,0-1.48.76,2.65,2.65,0,0,1,1.32-1.15A2.36,2.36,0,0,1,39.9,171.64Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M33.1,165.68c5.23-.3-5.12.54-5.14-.73s5.14-3.1,6.24-2.9.31,2.66.31,2.66S36,161.43,38,162.16s4.29,4.21,3.14,4.07-5.56.06-5.56.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,33.1,165.68Z"
                fill="#2f6840"
              />
              <path
                d="M32.5,165.27c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.29,3.46-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,32.5,165.27Z"
                fill="#3ba525"
              />
              <path
                d="M33.39,165.23a2.47,2.47,0,0,0-.94-1.1c-.38-.32-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,33.39,165.23Z"
                fill="#2f6840"
              />
              <path
                d="M37.5,164.29c-.3.05-.58.06-.85.12a4.28,4.28,0,0,0-.8.21,12.11,12.11,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.53,2.53,0,0,1,37.5,164.29Z"
                fill="#2f6840"
              />
              <path
                d="M35.89,168.09a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,35.89,168.09Z"
                fill="#2f6840"
              />
              <path
                d="M33.57,165.78c-.29.07-.56.1-.82.19a4,4,0,0,0-.76.26,11.63,11.63,0,0,0-1.48.77,2.7,2.7,0,0,1,1.31-1.16A2.41,2.41,0,0,1,33.57,165.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M23.24,161.69c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.43,17.43,0,0,1,23.24,161.69Z"
                fill="#2f6840"
              />
              <path
                d="M22.64,161.28c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56,0-5.56,0,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.4,17.4,0,0,1,22.64,161.28Z"
                fill="#3ba525"
              />
              <path
                d="M23.53,161.25a2.51,2.51,0,0,0-.94-1.11c-.38-.31-.83-.54-1.27-.87a2.71,2.71,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,23.53,161.25Z"
                fill="#2f6840"
              />
              <path
                d="M27.64,160.31c-.3,0-.58.05-.85.11a5.34,5.34,0,0,0-.81.21c-.53.15-1,.4-1.59.62a2.88,2.88,0,0,1,1.47-1A2.43,2.43,0,0,1,27.64,160.31Z"
                fill="#2f6840"
              />
              <path
                d="M26,164.1a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.59-1.15-1a2.5,2.5,0,0,1,1.43.64,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,26,164.1Z"
                fill="#2f6840"
              />
              <path
                d="M23.71,161.79c-.29.07-.56.11-.83.19a4.89,4.89,0,0,0-.76.27,12.23,12.23,0,0,0-1.48.76A2.65,2.65,0,0,1,22,161.86,2.41,2.41,0,0,1,23.71,161.79Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M40.62,180c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9S42,179,42,179s1.47-3.28,3.47-2.55,4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2S41.25,181,41.25,181s-1.07,3.94-3.55,3-2.67-2.69-2.45-2.8A17.65,17.65,0,0,1,40.62,180Z"
                fill="#2f6840"
              />
              <path
                d="M40,179.59c5.24-.29-5.11.54-5.14-.72s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.82-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.79A17.21,17.21,0,0,1,40,179.59Z"
                fill="#3ba525"
              />
              <path
                d="M40.91,179.56a2.5,2.5,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.62,2.62,0,0,1,1.51.54,2.08,2.08,0,0,1,.56.62A1.13,1.13,0,0,1,40.91,179.56Z"
                fill="#2f6840"
              />
              <path
                d="M45,178.62a7.13,7.13,0,0,0-.86.12,4.26,4.26,0,0,0-.8.2,15.77,15.77,0,0,0-1.59.62,2.87,2.87,0,0,1,1.46-1A2.46,2.46,0,0,1,45,178.62Z"
                fill="#2f6840"
              />
              <path
                d="M43.41,182.42a2.32,2.32,0,0,0-.78-1.18c-.34-.34-.75-.59-1.15-1a2.62,2.62,0,0,1,1.44.64,2.18,2.18,0,0,1,.47.68A1.13,1.13,0,0,1,43.41,182.42Z"
                fill="#2f6840"
              />
              <path
                d="M41.09,180.1c-.29.07-.56.11-.82.19a4.89,4.89,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.68,2.68,0,0,1,1.31-1.15A2.41,2.41,0,0,1,41.09,180.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M24.71,173.42c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,4-3.55,3-2.66-2.69-2.45-2.8A17,17,0,0,1,24.71,173.42Z"
                fill="#2f6840"
              />
              <path
                d="M24.12,173c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66S27,168.77,29,169.5s4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.34,17.34,0,0,1,24.12,173Z"
                fill="#3ba525"
              />
              <path
                d="M25,173a2.53,2.53,0,0,0-1-1.11c-.38-.32-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.23,2.23,0,0,1,.55.63A1.19,1.19,0,0,1,25,173Z"
                fill="#2f6840"
              />
              <path
                d="M29.12,172c-.31,0-.59.05-.86.11a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.51,2.51,0,0,1,29.12,172Z"
                fill="#2f6840"
              />
              <path
                d="M27.5,175.83a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.57,2.57,0,0,1,1.44.65,2.13,2.13,0,0,1,.47.67A1.13,1.13,0,0,1,27.5,175.83Z"
                fill="#2f6840"
              />
              <path
                d="M25.19,173.52a8.5,8.5,0,0,0-.83.19,3.44,3.44,0,0,0-.76.27,10.38,10.38,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.38,2.38,0,0,1,25.19,173.52Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M26.4,184.89c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.2,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2S27,185.93,27,185.93s-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.85,17.85,0,0,1,26.4,184.89Z"
                fill="#2f6840"
              />
              <path
                d="M25.8,184.48c5.23-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55S35,185.18,33.81,185s-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.67-2.69-2.45-2.79A17.21,17.21,0,0,1,25.8,184.48Z"
                fill="#3ba525"
              />
              <path
                d="M26.69,184.45a2.56,2.56,0,0,0-.94-1.11c-.38-.31-.83-.54-1.27-.87A2.69,2.69,0,0,1,26,183a2.25,2.25,0,0,1,.56.63A1.18,1.18,0,0,1,26.69,184.45Z"
                fill="#2f6840"
              />
              <path
                d="M30.8,183.51a7.25,7.25,0,0,0-.85.12,4.36,4.36,0,0,0-.81.2c-.53.15-1,.4-1.59.62a2.88,2.88,0,0,1,1.47-1A2.43,2.43,0,0,1,30.8,183.51Z"
                fill="#2f6840"
              />
              <path
                d="M29.19,187.3a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.59-1.15-.95a2.56,2.56,0,0,1,1.43.64,2.11,2.11,0,0,1,.48.67A1.13,1.13,0,0,1,29.19,187.3Z"
                fill="#2f6840"
              />
              <path
                d="M26.87,185c-.29.07-.56.11-.82.19a5.41,5.41,0,0,0-.77.27,12.12,12.12,0,0,0-1.47.76,2.68,2.68,0,0,1,1.31-1.15A2.41,2.41,0,0,1,26.87,185Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M23.26,195.21c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.34,17.34,0,0,1,23.26,195.21Z"
                fill="#2f6840"
              />
              <path
                d="M22.66,194.8c5.23-.29-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.31,17.31,0,0,1,22.66,194.8Z"
                fill="#3ba525"
              />
              <path
                d="M23.55,194.77a2.47,2.47,0,0,0-.95-1.11c-.38-.31-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.27,2.27,0,0,1,.56.63A1.18,1.18,0,0,1,23.55,194.77Z"
                fill="#2f6840"
              />
              <path
                d="M27.66,193.83c-.3,0-.58,0-.86.11a5.54,5.54,0,0,0-.8.21,16.76,16.76,0,0,0-1.59.62,2.85,2.85,0,0,1,1.46-1A2.46,2.46,0,0,1,27.66,193.83Z"
                fill="#2f6840"
              />
              <path
                d="M26,197.62a2.24,2.24,0,0,0-.78-1.17c-.33-.34-.75-.59-1.14-.95a2.53,2.53,0,0,1,1.43.64,2,2,0,0,1,.47.67A1.08,1.08,0,0,1,26,197.62Z"
                fill="#2f6840"
              />
              <path
                d="M23.73,195.31c-.29.07-.57.11-.83.19a4.89,4.89,0,0,0-.76.27,12.23,12.23,0,0,0-1.48.76A2.65,2.65,0,0,1,22,195.38,2.41,2.41,0,0,1,23.73,195.31Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M16.93,189.35c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.29,3.46-2.56,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,4-3.55,3-2.67-2.69-2.46-2.8A17.21,17.21,0,0,1,16.93,189.35Z"
                fill="#2f6840"
              />
              <path
                d="M16.33,188.94c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.2,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.15,2S17,190,17,190s-1.08,3.94-3.55,3-2.67-2.69-2.45-2.8A17.65,17.65,0,0,1,16.33,188.94Z"
                fill="#3ba525"
              />
              <path
                d="M17.22,188.91a2.51,2.51,0,0,0-.94-1.11c-.38-.31-.83-.54-1.27-.87a2.69,2.69,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,17.22,188.91Z"
                fill="#2f6840"
              />
              <path
                d="M21.33,188c-.3,0-.58.05-.85.11a5.34,5.34,0,0,0-.81.21c-.53.15-1,.4-1.59.62a2.88,2.88,0,0,1,1.47-1A2.43,2.43,0,0,1,21.33,188Z"
                fill="#2f6840"
              />
              <path
                d="M19.71,191.76a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,19.71,191.76Z"
                fill="#2f6840"
              />
              <path
                d="M17.4,189.45c-.29.07-.56.1-.82.19a3.35,3.35,0,0,0-.77.27,12.23,12.23,0,0,0-1.48.76,2.7,2.7,0,0,1,1.32-1.15A2.36,2.36,0,0,1,17.4,189.45Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M7.07,185.36c5.23-.29-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2S7.7,186.4,7.7,186.4s-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.22,17.22,0,0,1,7.07,185.36Z"
                fill="#2f6840"
              />
              <path
                d="M6.47,185c5.23-.3-5.12.54-5.15-.73s5.14-3.1,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2S7.1,186,7.1,186,6,189.94,3.55,189s-2.67-2.69-2.46-2.8A17.12,17.12,0,0,1,6.47,185Z"
                fill="#3ba525"
              />
              <path
                d="M7.36,184.92a2.44,2.44,0,0,0-1-1.1c-.38-.32-.83-.55-1.26-.88a2.75,2.75,0,0,1,1.52.54,2.37,2.37,0,0,1,.56.62A1.19,1.19,0,0,1,7.36,184.92Z"
                fill="#2f6840"
              />
              <path
                d="M11.47,184a7.74,7.74,0,0,0-.86.12,4.46,4.46,0,0,0-.8.2,16.76,16.76,0,0,0-1.59.62,3,3,0,0,1,1.46-1A2.46,2.46,0,0,1,11.47,184Z"
                fill="#2f6840"
              />
              <path
                d="M9.85,187.78a2.2,2.2,0,0,0-.78-1.17c-.33-.34-.75-.6-1.14-1a2.59,2.59,0,0,1,1.43.64,2,2,0,0,1,.47.68A1.08,1.08,0,0,1,9.85,187.78Z"
                fill="#2f6840"
              />
              <path
                d="M7.54,185.47c-.29.06-.57.1-.83.18a4.89,4.89,0,0,0-.76.27,11,11,0,0,0-1.48.77,2.67,2.67,0,0,1,1.32-1.16A2.4,2.4,0,0,1,7.54,185.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M24.45,203.67c5.23-.29-5.12.54-5.15-.72s5.15-3.1,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56.06-5.56.06,7.12,1,4.71,1.82-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.4,17.4,0,0,1,24.45,203.67Z"
                fill="#2f6840"
              />
              <path
                d="M23.85,203.27c5.23-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.91.31,2.66.31,2.66,1.47-3.28,3.47-2.55S33,204,31.86,203.83s-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,23.85,203.27Z"
                fill="#3ba525"
              />
              <path
                d="M24.74,203.23a2.48,2.48,0,0,0-.94-1.1c-.38-.32-.83-.54-1.27-.88a2.7,2.7,0,0,1,1.52.54,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,24.74,203.23Z"
                fill="#2f6840"
              />
              <path
                d="M28.85,202.29c-.3.05-.58.06-.85.12a5.33,5.33,0,0,0-.81.2,15.4,15.4,0,0,0-1.59.63,3,3,0,0,1,1.47-1A2.48,2.48,0,0,1,28.85,202.29Z"
                fill="#2f6840"
              />
              <path
                d="M27.24,206.09a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,27.24,206.09Z"
                fill="#2f6840"
              />
              <path
                d="M24.92,203.78c-.29.07-.56.1-.82.18a5.41,5.41,0,0,0-.77.27,10.94,10.94,0,0,0-1.47.77,2.65,2.65,0,0,1,1.31-1.16A2.41,2.41,0,0,1,24.92,203.78Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M8.54,197.09c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.67-2.69-2.45-2.8A17.33,17.33,0,0,1,8.54,197.09Z"
                fill="#2f6840"
              />
              <path
                d="M7.94,196.68c5.24-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3S2.36,198,2.57,197.94A17.21,17.21,0,0,1,7.94,196.68Z"
                fill="#3ba525"
              />
              <path
                d="M8.83,196.65a2.45,2.45,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.13,1.13,0,0,1,8.83,196.65Z"
                fill="#2f6840"
              />
              <path
                d="M12.94,195.71c-.3,0-.58,0-.85.11a5.22,5.22,0,0,0-.8.21,15.77,15.77,0,0,0-1.59.62,2.81,2.81,0,0,1,1.46-1A2.43,2.43,0,0,1,12.94,195.71Z"
                fill="#2f6840"
              />
              <path
                d="M11.33,199.5a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.59-1.15-1a2.5,2.5,0,0,1,1.43.64,2,2,0,0,1,.48.67A1.13,1.13,0,0,1,11.33,199.5Z"
                fill="#2f6840"
              />
              <path
                d="M9,197.19c-.29.07-.56.11-.82.19a4.89,4.89,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.41,2.41,0,0,1,9,197.19Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M50.07,207.92c5.23-.3-5.12.54-5.15-.73s5.15-3.1,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2S50.7,209,50.7,209s-1.08,4-3.55,3-2.67-2.69-2.46-2.8A17.21,17.21,0,0,1,50.07,207.92Z"
                fill="#2f6840"
              />
              <path
                d="M49.47,207.51c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.65.31,2.65,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.08-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,4-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,49.47,207.51Z"
                fill="#3ba525"
              />
              <path
                d="M50.36,207.47a2.54,2.54,0,0,0-.94-1.1c-.38-.32-.83-.54-1.27-.87a2.69,2.69,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,50.36,207.47Z"
                fill="#2f6840"
              />
              <path
                d="M54.47,206.53c-.3.05-.58.06-.85.12a4.38,4.38,0,0,0-.81.21,13.31,13.31,0,0,0-1.59.62,3,3,0,0,1,1.47-1A2.53,2.53,0,0,1,54.47,206.53Z"
                fill="#2f6840"
              />
              <path
                d="M52.86,210.33a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,52.86,210.33Z"
                fill="#2f6840"
              />
              <path
                d="M50.54,208c-.29.07-.56.1-.82.18a5,5,0,0,0-.77.27,11.68,11.68,0,0,0-1.48.77,2.77,2.77,0,0,1,1.32-1.16A2.41,2.41,0,0,1,50.54,208Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M46.93,218.23c5.23-.29-5.12.54-5.15-.72s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.82-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.22,17.22,0,0,1,46.93,218.23Z"
                fill="#2f6840"
              />
              <path
                d="M46.33,217.83c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.34-5.16,2S47,218.86,47,218.86s-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17.12,17.12,0,0,1,46.33,217.83Z"
                fill="#3ba525"
              />
              <path
                d="M47.22,217.79a2.56,2.56,0,0,0-.95-1.1c-.38-.32-.83-.54-1.26-.88a2.75,2.75,0,0,1,1.52.54,2.09,2.09,0,0,1,.55.63A1.11,1.11,0,0,1,47.22,217.79Z"
                fill="#2f6840"
              />
              <path
                d="M51.33,216.85c-.3.05-.58.06-.86.12a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.51,2.51,0,0,1,51.33,216.85Z"
                fill="#2f6840"
              />
              <path
                d="M49.71,220.65a2.24,2.24,0,0,0-.78-1.17c-.33-.34-.75-.6-1.14-1a2.54,2.54,0,0,1,1.43.65,1.89,1.89,0,0,1,.47.67A1.08,1.08,0,0,1,49.71,220.65Z"
                fill="#2f6840"
              />
              <path
                d="M47.4,218.34c-.29.07-.57.1-.83.18a4.89,4.89,0,0,0-.76.27,11,11,0,0,0-1.48.77,2.67,2.67,0,0,1,1.32-1.16A2.4,2.4,0,0,1,47.4,218.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M40.6,212.37c5.23-.29-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.31,17.31,0,0,1,40.6,212.37Z"
                fill="#2f6840"
              />
              <path
                d="M40,212c5.23-.3-5.12.54-5.15-.73s5.15-3.1,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56.06-5.56.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2S40.63,213,40.63,213s-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17.21,17.21,0,0,1,40,212Z"
                fill="#3ba525"
              />
              <path
                d="M40.89,211.93a2.48,2.48,0,0,0-.94-1.1c-.38-.32-.83-.55-1.27-.88a2.72,2.72,0,0,1,1.52.54,2.21,2.21,0,0,1,.56.62A1.19,1.19,0,0,1,40.89,211.93Z"
                fill="#2f6840"
              />
              <path
                d="M45,211a7.74,7.74,0,0,0-.86.12,4.46,4.46,0,0,0-.8.2c-.53.15-1,.4-1.59.62a3,3,0,0,1,1.47-1A2.43,2.43,0,0,1,45,211Z"
                fill="#2f6840"
              />
              <path
                d="M43.38,214.79a2.18,2.18,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.56,2.56,0,0,1,1.43.64,2,2,0,0,1,.48.68A1.08,1.08,0,0,1,43.38,214.79Z"
                fill="#2f6840"
              />
              <path
                d="M41.07,212.48c-.29.06-.56.1-.83.18a4.89,4.89,0,0,0-.76.27,11,11,0,0,0-1.48.77,2.67,2.67,0,0,1,1.32-1.16A2.4,2.4,0,0,1,41.07,212.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M30.74,208.39c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.9,2.34-5.15,2-1.37-3.43-1.37-3.43-1.08,4-3.55,3-2.67-2.69-2.46-2.8A17,17,0,0,1,30.74,208.39Z"
                fill="#2f6840"
              />
              <path
                d="M30.14,208c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66S33,203.74,35,204.47s4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2S30.77,209,30.77,209s-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.43,17.43,0,0,1,30.14,208Z"
                fill="#3ba525"
              />
              <path
                d="M31,208a2.47,2.47,0,0,0-1-1.11c-.38-.32-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.27,2.27,0,0,1,.56.63A1.18,1.18,0,0,1,31,208Z"
                fill="#2f6840"
              />
              <path
                d="M35.14,207c-.3,0-.58.05-.86.11a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.93,2.93,0,0,1,1.46-1A2.51,2.51,0,0,1,35.14,207Z"
                fill="#2f6840"
              />
              <path
                d="M33.52,210.8a2.24,2.24,0,0,0-.78-1.17c-.33-.34-.75-.6-1.14-1a2.54,2.54,0,0,1,1.43.65,2,2,0,0,1,.47.67A1.08,1.08,0,0,1,33.52,210.8Z"
                fill="#2f6840"
              />
              <path
                d="M31.21,208.49c-.29.07-.57.1-.83.19a3.44,3.44,0,0,0-.76.27,10.94,10.94,0,0,0-1.48.76,2.65,2.65,0,0,1,1.32-1.15A2.36,2.36,0,0,1,31.21,208.49Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M48.12,226.7c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66S51,222.45,53,223.18s4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,4-3.55,3-2.67-2.69-2.46-2.8A17.21,17.21,0,0,1,48.12,226.7Z"
                fill="#2f6840"
              />
              <path
                d="M47.52,226.29c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.2,3.13,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.67-2.69-2.45-2.8A17.65,17.65,0,0,1,47.52,226.29Z"
                fill="#3ba525"
              />
              <path
                d="M48.41,226.26a2.51,2.51,0,0,0-.94-1.11c-.38-.31-.83-.54-1.27-.87a2.69,2.69,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,48.41,226.26Z"
                fill="#2f6840"
              />
              <path
                d="M52.52,225.32c-.3,0-.58.05-.85.11a5.34,5.34,0,0,0-.81.21,15.26,15.26,0,0,0-1.59.62,2.88,2.88,0,0,1,1.47-1A2.43,2.43,0,0,1,52.52,225.32Z"
                fill="#2f6840"
              />
              <path
                d="M50.91,229.11a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.13,1.13,0,0,1,50.91,229.11Z"
                fill="#2f6840"
              />
              <path
                d="M48.59,226.8c-.29.07-.56.1-.82.19a3.52,3.52,0,0,0-.77.27,13,13,0,0,0-1.48.76,2.7,2.7,0,0,1,1.32-1.15A2.36,2.36,0,0,1,48.59,226.8Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M32.21,220.11c5.23-.29-5.12.54-5.14-.72s5.14-3.1,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.07-5.56.06-5.56.06,7.12,1,4.71,1.82-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.08,3.94-3.55,3-2.67-2.69-2.45-2.79A17.21,17.21,0,0,1,32.21,220.11Z"
                fill="#2f6840"
              />
              <path
                d="M31.61,219.71c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3S26,221.07,26.24,221A17,17,0,0,1,31.61,219.71Z"
                fill="#3ba525"
              />
              <path
                d="M32.5,219.67a2.47,2.47,0,0,0-.94-1.1c-.38-.32-.83-.54-1.26-.88a2.69,2.69,0,0,1,1.51.54,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,32.5,219.67Z"
                fill="#2f6840"
              />
              <path
                d="M36.61,218.73c-.3.05-.58.06-.85.12a4.28,4.28,0,0,0-.8.21,12.11,12.11,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.48,2.48,0,0,1,36.61,218.73Z"
                fill="#2f6840"
              />
              <path
                d="M35,222.53a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,35,222.53Z"
                fill="#2f6840"
              />
              <path
                d="M32.68,220.22c-.29.07-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,10.47,10.47,0,0,0-1.48.77,2.65,2.65,0,0,1,1.31-1.16A2.41,2.41,0,0,1,32.68,220.22Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M82,218.17c5.24-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.65,17.65,0,0,1,82,218.17Z"
                fill="#2f6840"
              />
              <path
                d="M81.4,217.76c5.23-.29-5.12.54-5.15-.72s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2S82,218.8,82,218.8s-1.08,3.95-3.55,3-2.67-2.7-2.46-2.8A17.22,17.22,0,0,1,81.4,217.76Z"
                fill="#3ba525"
              />
              <path
                d="M82.29,217.73a2.58,2.58,0,0,0-1-1.11c-.38-.31-.83-.54-1.26-.87a2.75,2.75,0,0,1,1.52.54,2.19,2.19,0,0,1,.55.62A1.14,1.14,0,0,1,82.29,217.73Z"
                fill="#2f6840"
              />
              <path
                d="M86.4,216.79a7.74,7.74,0,0,0-.86.12,4.46,4.46,0,0,0-.8.2,16.76,16.76,0,0,0-1.59.62,2.87,2.87,0,0,1,1.46-1A2.46,2.46,0,0,1,86.4,216.79Z"
                fill="#2f6840"
              />
              <path
                d="M84.78,220.59a2.32,2.32,0,0,0-.78-1.18c-.33-.34-.75-.59-1.14-.95a2.63,2.63,0,0,1,1.43.64,2,2,0,0,1,.47.68A1.13,1.13,0,0,1,84.78,220.59Z"
                fill="#2f6840"
              />
              <path
                d="M82.47,218.27c-.29.07-.57.11-.83.19a4.89,4.89,0,0,0-.76.27,12.23,12.23,0,0,0-1.48.76,2.7,2.7,0,0,1,1.32-1.15A2.41,2.41,0,0,1,82.47,218.27Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M78.85,228.49c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.2,3.13,4.07-5.56,0-5.56,0,7.12,1,4.71,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.08,3.94-3.55,3-2.67-2.69-2.45-2.8A17.65,17.65,0,0,1,78.85,228.49Z"
                fill="#2f6840"
              />
              <path
                d="M78.25,228.08c5.24-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.67-2.69-2.45-2.79A17.21,17.21,0,0,1,78.25,228.08Z"
                fill="#3ba525"
              />
              <path
                d="M79.14,228.05a2.5,2.5,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.25,2.25,0,0,1,.56.63A1.18,1.18,0,0,1,79.14,228.05Z"
                fill="#2f6840"
              />
              <path
                d="M83.25,227.11a7.25,7.25,0,0,0-.85.12,4.26,4.26,0,0,0-.8.2,15.77,15.77,0,0,0-1.59.62,2.87,2.87,0,0,1,1.46-1A2.43,2.43,0,0,1,83.25,227.11Z"
                fill="#2f6840"
              />
              <path
                d="M81.64,230.9a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.59-1.15-.95a2.56,2.56,0,0,1,1.43.64,2.11,2.11,0,0,1,.48.67A1.13,1.13,0,0,1,81.64,230.9Z"
                fill="#2f6840"
              />
              <path
                d="M79.32,228.59c-.29.07-.56.11-.82.19a4.89,4.89,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.68,2.68,0,0,1,1.31-1.15A2.41,2.41,0,0,1,79.32,228.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M72.52,222.63c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.29,3.46-2.55,4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.8A17.33,17.33,0,0,1,72.52,222.63Z"
                fill="#2f6840"
              />
              <path
                d="M71.93,222.22c5.23-.29-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.22,17.22,0,0,1,71.93,222.22Z"
                fill="#3ba525"
              />
              <path
                d="M72.82,222.19a2.53,2.53,0,0,0-.95-1.11c-.38-.31-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.23,2.23,0,0,1,.55.63A1.19,1.19,0,0,1,72.82,222.19Z"
                fill="#2f6840"
              />
              <path
                d="M76.93,221.25c-.31,0-.59.05-.86.11a5.54,5.54,0,0,0-.8.21,16.76,16.76,0,0,0-1.59.62,2.81,2.81,0,0,1,1.46-1A2.46,2.46,0,0,1,76.93,221.25Z"
                fill="#2f6840"
              />
              <path
                d="M75.31,225a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.59-1.15-1a2.56,2.56,0,0,1,1.44.64,2.13,2.13,0,0,1,.47.67A1.13,1.13,0,0,1,75.31,225Z"
                fill="#2f6840"
              />
              <path
                d="M73,222.73c-.3.07-.57.11-.83.19a4.89,4.89,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.38,2.38,0,0,1,73,222.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M62.66,218.64c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.08,3.94-3.55,3-2.67-2.69-2.45-2.79A17.21,17.21,0,0,1,62.66,218.64Z"
                fill="#2f6840"
              />
              <path
                d="M62.06,218.24c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.66-2.69-2.45-2.8A17,17,0,0,1,62.06,218.24Z"
                fill="#3ba525"
              />
              <path
                d="M63,218.2a2.42,2.42,0,0,0-.94-1.1c-.38-.32-.83-.54-1.26-.88a2.69,2.69,0,0,1,1.51.54,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,63,218.2Z"
                fill="#2f6840"
              />
              <path
                d="M67.06,217.26c-.3.05-.58.06-.85.12a4.26,4.26,0,0,0-.8.2,13.8,13.8,0,0,0-1.59.63,2.89,2.89,0,0,1,1.46-1A2.48,2.48,0,0,1,67.06,217.26Z"
                fill="#2f6840"
              />
              <path
                d="M65.45,221.06a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,65.45,221.06Z"
                fill="#2f6840"
              />
              <path
                d="M63.13,218.75c-.29.07-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,10.47,10.47,0,0,0-1.48.77,2.65,2.65,0,0,1,1.31-1.16A2.41,2.41,0,0,1,63.13,218.75Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M80,237c5.24-.3-5.11.54-5.14-.73s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.83-3.91,2.34-5.15,2S80.68,238,80.68,238s-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17,17,0,0,1,80,237Z"
                fill="#2f6840"
              />
              <path
                d="M79.45,236.55c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.29,3.46-2.56,4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17,17,0,0,1,79.45,236.55Z"
                fill="#3ba525"
              />
              <path
                d="M80.34,236.51a2.56,2.56,0,0,0-1-1.1c-.38-.32-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.23,2.23,0,0,1,.55.63A1.12,1.12,0,0,1,80.34,236.51Z"
                fill="#2f6840"
              />
              <path
                d="M84.45,235.57c-.3.05-.58.06-.86.12a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.56,2.56,0,0,1,84.45,235.57Z"
                fill="#2f6840"
              />
              <path
                d="M82.83,239.37a2.3,2.3,0,0,0-.78-1.17c-.33-.34-.75-.6-1.14-1a2.57,2.57,0,0,1,1.43.65,1.89,1.89,0,0,1,.47.67A1.13,1.13,0,0,1,82.83,239.37Z"
                fill="#2f6840"
              />
              <path
                d="M80.52,237.06c-.3.07-.57.1-.83.18a4.89,4.89,0,0,0-.76.27,11,11,0,0,0-1.48.77,2.72,2.72,0,0,1,1.32-1.16A2.4,2.4,0,0,1,80.52,237.06Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M64.14,230.37c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66S67,226.13,69,226.86s4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.66,17.66,0,0,1,64.14,230.37Z"
                fill="#2f6840"
              />
              <path
                d="M63.54,230c5.23-.29-5.12.54-5.15-.72s5.14-3.11,6.25-2.9S65,229,65,229s1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.35-5.16,2S64.17,231,64.17,231s-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.31,17.31,0,0,1,63.54,230Z"
                fill="#3ba525"
              />
              <path
                d="M64.43,229.93a2.52,2.52,0,0,0-1-1.11c-.38-.31-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.41,2.41,0,0,1,.56.63A1.18,1.18,0,0,1,64.43,229.93Z"
                fill="#2f6840"
              />
              <path
                d="M68.54,229a7.74,7.74,0,0,0-.86.12,4.46,4.46,0,0,0-.8.2,16.76,16.76,0,0,0-1.59.62,2.91,2.91,0,0,1,1.46-1A2.46,2.46,0,0,1,68.54,229Z"
                fill="#2f6840"
              />
              <path
                d="M66.92,232.78a2.24,2.24,0,0,0-.78-1.17c-.33-.34-.75-.59-1.14-1a2.59,2.59,0,0,1,1.43.64,2.08,2.08,0,0,1,.47.67A1.08,1.08,0,0,1,66.92,232.78Z"
                fill="#2f6840"
              />
              <path
                d="M64.61,230.47c-.29.07-.57.11-.83.19a4.89,4.89,0,0,0-.76.27,12.23,12.23,0,0,0-1.48.76,2.7,2.7,0,0,1,1.32-1.15A2.41,2.41,0,0,1,64.61,230.47Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M113.46,230c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.91.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,4-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,113.46,230Z"
                fill="#2f6840"
              />
              <path
                d="M112.86,229.6c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.8A17.65,17.65,0,0,1,112.86,229.6Z"
                fill="#3ba525"
              />
              <path
                d="M113.75,229.57a2.45,2.45,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.13,1.13,0,0,1,113.75,229.57Z"
                fill="#2f6840"
              />
              <path
                d="M117.87,228.63c-.31,0-.59.05-.86.11a4.28,4.28,0,0,0-.8.21,12.11,12.11,0,0,0-1.59.62,2.81,2.81,0,0,1,1.46-1A2.46,2.46,0,0,1,117.87,228.63Z"
                fill="#2f6840"
              />
              <path
                d="M116.25,232.42a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.13,1.13,0,0,1,116.25,232.42Z"
                fill="#2f6840"
              />
              <path
                d="M113.93,230.11c-.29.07-.56.1-.82.19a3.44,3.44,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.36,2.36,0,0,1,113.93,230.11Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M110.32,240.33c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17.12,17.12,0,0,1,110.32,240.33Z"
                fill="#2f6840"
              />
              <path
                d="M109.72,239.92c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.29,3.46-2.55,4.29,4.2,3.13,4.07-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.52,17.52,0,0,1,109.72,239.92Z"
                fill="#3ba525"
              />
              <path
                d="M110.61,239.89a2.51,2.51,0,0,0-.94-1.11c-.38-.32-.83-.54-1.27-.87a2.71,2.71,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,110.61,239.89Z"
                fill="#2f6840"
              />
              <path
                d="M114.72,239c-.3,0-.58.05-.86.11a4.49,4.49,0,0,0-.8.21,13.31,13.31,0,0,0-1.59.62,2.91,2.91,0,0,1,1.47-1A2.48,2.48,0,0,1,114.72,239Z"
                fill="#2f6840"
              />
              <path
                d="M113.1,242.74a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,113.1,242.74Z"
                fill="#2f6840"
              />
              <path
                d="M110.79,240.43c-.29.07-.56.1-.83.19a3.44,3.44,0,0,0-.76.27,10.94,10.94,0,0,0-1.48.76A2.65,2.65,0,0,1,109,240.5,2.36,2.36,0,0,1,110.79,240.43Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M104,234.47c5.23-.3-5.12.54-5.14-.73s5.14-3.1,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56.06-5.56.06,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,104,234.47Z"
                fill="#2f6840"
              />
              <path
                d="M103.39,234.06c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.29,3.47-2.56,4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,103.39,234.06Z"
                fill="#3ba525"
              />
              <path
                d="M104.28,234a2.54,2.54,0,0,0-.94-1.1c-.38-.32-.83-.54-1.27-.87a2.69,2.69,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,104.28,234Z"
                fill="#2f6840"
              />
              <path
                d="M108.39,233.08c-.3,0-.58.06-.85.12a4.38,4.38,0,0,0-.81.21,12.56,12.56,0,0,0-1.58.62,2.89,2.89,0,0,1,1.46-1A2.53,2.53,0,0,1,108.39,233.08Z"
                fill="#2f6840"
              />
              <path
                d="M106.78,236.88a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,106.78,236.88Z"
                fill="#2f6840"
              />
              <path
                d="M104.46,234.57c-.29.07-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,11.63,11.63,0,0,0-1.48.77,2.7,2.7,0,0,1,1.31-1.16A2.41,2.41,0,0,1,104.46,234.57Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M94.13,230.48c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66S97,226.23,99,227s4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.43,17.43,0,0,1,94.13,230.48Z"
                fill="#2f6840"
              />
              <path
                d="M93.53,230.07c5.23-.29-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.4,17.4,0,0,1,93.53,230.07Z"
                fill="#3ba525"
              />
              <path
                d="M94.42,230a2.51,2.51,0,0,0-.94-1.11c-.38-.31-.83-.54-1.27-.87a2.71,2.71,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,94.42,230Z"
                fill="#2f6840"
              />
              <path
                d="M98.53,229.1c-.3,0-.58.05-.86.11a5.54,5.54,0,0,0-.8.21c-.53.15-1,.4-1.59.62a2.88,2.88,0,0,1,1.47-1A2.43,2.43,0,0,1,98.53,229.1Z"
                fill="#2f6840"
              />
              <path
                d="M96.91,232.89a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.59-1.15-.95a2.5,2.5,0,0,1,1.43.64,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,96.91,232.89Z"
                fill="#2f6840"
              />
              <path
                d="M94.6,230.58c-.29.07-.56.11-.83.19A4.89,4.89,0,0,0,93,231a12.23,12.23,0,0,0-1.48.76,2.65,2.65,0,0,1,1.32-1.15A2.36,2.36,0,0,1,94.6,230.58Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M111.51,248.79c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.2,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.67-2.69-2.45-2.8A17.65,17.65,0,0,1,111.51,248.79Z"
                fill="#2f6840"
              />
              <path
                d="M110.91,248.38c5.24-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.79A17.21,17.21,0,0,1,110.91,248.38Z"
                fill="#3ba525"
              />
              <path
                d="M111.8,248.35a2.5,2.5,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.25,2.25,0,0,1,.56.63A1.13,1.13,0,0,1,111.8,248.35Z"
                fill="#2f6840"
              />
              <path
                d="M115.91,247.41a7.25,7.25,0,0,0-.85.12,4.26,4.26,0,0,0-.8.2,15.77,15.77,0,0,0-1.59.62,2.87,2.87,0,0,1,1.46-1A2.43,2.43,0,0,1,115.91,247.41Z"
                fill="#2f6840"
              />
              <path
                d="M114.3,251.2a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.59-1.15-.95a2.56,2.56,0,0,1,1.43.64,2.11,2.11,0,0,1,.48.67A1.13,1.13,0,0,1,114.3,251.2Z"
                fill="#2f6840"
              />
              <path
                d="M112,248.89c-.29.07-.56.11-.82.19a4.89,4.89,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.68,2.68,0,0,1,1.31-1.15A2.41,2.41,0,0,1,112,248.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M95.6,242.21c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.66-2.69-2.45-2.8A17,17,0,0,1,95.6,242.21Z"
                fill="#2f6840"
              />
              <path
                d="M95,241.8c5.23-.3-5.12.54-5.15-.72S95,238,96.1,238.18s.32,2.66.32,2.66,1.46-3.29,3.46-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.9,2.35-5.15,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.34,17.34,0,0,1,95,241.8Z"
                fill="#3ba525"
              />
              <path
                d="M95.9,241.77a2.53,2.53,0,0,0-1-1.11c-.38-.32-.83-.54-1.26-.87a2.74,2.74,0,0,1,1.52.53,2.23,2.23,0,0,1,.55.63A1.19,1.19,0,0,1,95.9,241.77Z"
                fill="#2f6840"
              />
              <path
                d="M100,240.83c-.31,0-.59,0-.86.11a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.51,2.51,0,0,1,100,240.83Z"
                fill="#2f6840"
              />
              <path
                d="M98.39,244.62a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.57,2.57,0,0,1,1.44.65,2.13,2.13,0,0,1,.47.67A1.13,1.13,0,0,1,98.39,244.62Z"
                fill="#2f6840"
              />
              <path
                d="M96.07,242.31c-.29.07-.56.1-.82.19a3.44,3.44,0,0,0-.76.27,10.38,10.38,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.36,2.36,0,0,1,96.07,242.31Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M142.48,247.05c5.23-.3-5.12.54-5.14-.73s5.14-3.1,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,142.48,247.05Z"
                fill="#2f6840"
              />
              <path
                d="M141.88,246.64c5.24-.3-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.65.32,2.65,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,4-3.55,3-2.66-2.69-2.45-2.8A17,17,0,0,1,141.88,246.64Z"
                fill="#3ba525"
              />
              <path
                d="M142.77,246.6a2.47,2.47,0,0,0-.94-1.1c-.38-.32-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.11,1.11,0,0,1,142.77,246.6Z"
                fill="#2f6840"
              />
              <path
                d="M146.89,245.66c-.31.05-.59.06-.86.12a4.28,4.28,0,0,0-.8.21,12.11,12.11,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.56,2.56,0,0,1,146.89,245.66Z"
                fill="#2f6840"
              />
              <path
                d="M145.27,249.46a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.13,1.13,0,0,1,145.27,249.46Z"
                fill="#2f6840"
              />
              <path
                d="M143,247.15c-.29.07-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,10.47,10.47,0,0,0-1.48.77,2.7,2.7,0,0,1,1.31-1.16A2.41,2.41,0,0,1,143,247.15Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M139.34,257.36c5.23-.29-5.12.54-5.15-.72s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.47-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.12,1,4.71,1.82-3.91,2.35-5.16,2S140,258.4,140,258.4s-1.08,3.94-3.55,3-2.67-2.69-2.46-2.79A17.31,17.31,0,0,1,139.34,257.36Z"
                fill="#2f6840"
              />
              <path
                d="M138.74,257c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.91.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.13,4.08-5.55.05-5.55.05,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17.21,17.21,0,0,1,138.74,257Z"
                fill="#3ba525"
              />
              <path
                d="M139.63,256.92a2.54,2.54,0,0,0-.94-1.1c-.38-.32-.83-.54-1.27-.88a2.72,2.72,0,0,1,1.52.54,2.12,2.12,0,0,1,.56.63A1.16,1.16,0,0,1,139.63,256.92Z"
                fill="#2f6840"
              />
              <path
                d="M143.74,256c-.3,0-.58.06-.86.12a4.49,4.49,0,0,0-.8.21,13.31,13.31,0,0,0-1.59.62,2.91,2.91,0,0,1,1.47-1A2.48,2.48,0,0,1,143.74,256Z"
                fill="#2f6840"
              />
              <path
                d="M142.12,259.78a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,1.91,1.91,0,0,1,.48.67A1.08,1.08,0,0,1,142.12,259.78Z"
                fill="#2f6840"
              />
              <path
                d="M139.81,257.47c-.29.07-.56.1-.83.18a4.89,4.89,0,0,0-.76.27,11,11,0,0,0-1.48.77,2.67,2.67,0,0,1,1.32-1.16A2.4,2.4,0,0,1,139.81,257.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M133,251.5c5.23-.29-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.21,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.45-2.79A17.21,17.21,0,0,1,133,251.5Z"
                fill="#2f6840"
              />
              <path
                d="M132.41,251.1c5.23-.3-5.11.54-5.14-.73s5.14-3.1,6.24-2.9.31,2.66.31,2.66,1.47-3.28,3.47-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.83-3.91,2.34-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,132.41,251.1Z"
                fill="#3ba525"
              />
              <path
                d="M133.3,251.06a2.48,2.48,0,0,0-.94-1.1c-.38-.32-.83-.55-1.27-.88a2.7,2.7,0,0,1,1.52.54,2.21,2.21,0,0,1,.56.62A1.19,1.19,0,0,1,133.3,251.06Z"
                fill="#2f6840"
              />
              <path
                d="M137.41,250.12a7.25,7.25,0,0,0-.85.12,4.36,4.36,0,0,0-.81.2,16.6,16.6,0,0,0-1.58.62,2.93,2.93,0,0,1,1.46-1A2.43,2.43,0,0,1,137.41,250.12Z"
                fill="#2f6840"
              />
              <path
                d="M135.8,253.92a2.25,2.25,0,0,0-.78-1.17c-.34-.34-.76-.6-1.15-1a2.56,2.56,0,0,1,1.43.64,2,2,0,0,1,.48.68A1.13,1.13,0,0,1,135.8,253.92Z"
                fill="#2f6840"
              />
              <path
                d="M133.48,251.61c-.29.06-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,10.47,10.47,0,0,0-1.48.77,2.65,2.65,0,0,1,1.31-1.16A2.41,2.41,0,0,1,133.48,251.61Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M123.15,247.52c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66S126,243.27,128,244s4.28,4.21,3.13,4.08-5.55,0-5.55,0,7.12,1,4.71,1.83-3.91,2.34-5.16,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17.12,17.12,0,0,1,123.15,247.52Z"
                fill="#2f6840"
              />
              <path
                d="M122.55,247.11c5.23-.3-5.12.54-5.15-.72s5.15-3.11,6.25-2.9.31,2.66.31,2.66,1.47-3.28,3.46-2.55,4.29,4.2,3.14,4.07-5.56.05-5.56.05,7.12,1,4.71,1.83-3.91,2.35-5.16,2-1.37-3.43-1.37-3.43-1.08,3.94-3.55,3-2.67-2.69-2.46-2.8A17.52,17.52,0,0,1,122.55,247.11Z"
                fill="#3ba525"
              />
              <path
                d="M123.44,247.08a2.51,2.51,0,0,0-.94-1.11c-.38-.32-.83-.54-1.27-.87a2.71,2.71,0,0,1,1.52.53,2.12,2.12,0,0,1,.56.63A1.18,1.18,0,0,1,123.44,247.08Z"
                fill="#2f6840"
              />
              <path
                d="M127.55,246.14c-.3,0-.58.05-.86.11a4.49,4.49,0,0,0-.8.21,13.31,13.31,0,0,0-1.59.62,2.91,2.91,0,0,1,1.47-1A2.48,2.48,0,0,1,127.55,246.14Z"
                fill="#2f6840"
              />
              <path
                d="M125.93,249.93a2.22,2.22,0,0,0-.77-1.17c-.34-.34-.76-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.08,1.08,0,0,1,125.93,249.93Z"
                fill="#2f6840"
              />
              <path
                d="M123.62,247.62c-.29.07-.56.1-.83.19a3.44,3.44,0,0,0-.76.27,10.94,10.94,0,0,0-1.48.76,2.65,2.65,0,0,1,1.32-1.15A2.36,2.36,0,0,1,123.62,247.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M140.53,265.83c5.23-.3-5.12.54-5.14-.72s5.14-3.11,6.24-2.9.31,2.66.31,2.66,1.47-3.29,3.47-2.56,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.95-3.55,3-2.67-2.69-2.45-2.8A17,17,0,0,1,140.53,265.83Z"
                fill="#2f6840"
              />
              <path
                d="M139.93,265.42c5.24-.29-5.11.54-5.14-.72s5.14-3.11,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.2,3.13,4.07-5.55,0-5.55,0,7.11,1,4.7,1.83-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.8A17.65,17.65,0,0,1,139.93,265.42Z"
                fill="#3ba525"
              />
              <path
                d="M140.82,265.39a2.45,2.45,0,0,0-.94-1.11c-.38-.31-.83-.54-1.26-.87a2.68,2.68,0,0,1,1.51.53,2.12,2.12,0,0,1,.56.63A1.13,1.13,0,0,1,140.82,265.39Z"
                fill="#2f6840"
              />
              <path
                d="M144.93,264.45c-.3,0-.58.05-.85.11a5.22,5.22,0,0,0-.8.21,15.77,15.77,0,0,0-1.59.62,2.81,2.81,0,0,1,1.46-1A2.43,2.43,0,0,1,144.93,264.45Z"
                fill="#2f6840"
              />
              <path
                d="M143.32,268.24a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.51,2.51,0,0,1,1.43.65,2,2,0,0,1,.48.67A1.13,1.13,0,0,1,143.32,268.24Z"
                fill="#2f6840"
              />
              <path
                d="M141,265.93c-.29.07-.56.1-.82.19a3.44,3.44,0,0,0-.76.27,11.54,11.54,0,0,0-1.48.76,2.63,2.63,0,0,1,1.31-1.15A2.36,2.36,0,0,1,141,265.93Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M124.62,259.24c5.24-.29-5.11.54-5.14-.72s5.14-3.1,6.24-2.9.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.07-5.55.06-5.55.06,7.11,1,4.7,1.82-3.91,2.35-5.15,2-1.38-3.43-1.38-3.43-1.07,3.94-3.55,3-2.66-2.69-2.45-2.79A17.21,17.21,0,0,1,124.62,259.24Z"
                fill="#2f6840"
              />
              <path
                d="M124,258.84c5.23-.3-5.12.54-5.15-.72s5.14-3.11,6.24-2.91.32,2.66.32,2.66,1.46-3.28,3.46-2.55,4.28,4.21,3.13,4.08-5.55.05-5.55.05,7.11,1,4.7,1.83-3.9,2.34-5.15,2-1.37-3.43-1.37-3.43-1.08,3.95-3.55,3-2.67-2.69-2.46-2.8A17,17,0,0,1,124,258.84Z"
                fill="#3ba525"
              />
              <path
                d="M124.92,258.8a2.56,2.56,0,0,0-1-1.1c-.38-.32-.83-.54-1.26-.88a2.75,2.75,0,0,1,1.52.54,2.23,2.23,0,0,1,.55.63A1.16,1.16,0,0,1,124.92,258.8Z"
                fill="#2f6840"
              />
              <path
                d="M129,257.86c-.31.05-.59.06-.86.12a4.49,4.49,0,0,0-.8.21,12.68,12.68,0,0,0-1.59.62,2.89,2.89,0,0,1,1.46-1A2.51,2.51,0,0,1,129,257.86Z"
                fill="#2f6840"
              />
              <path
                d="M127.41,261.66a2.3,2.3,0,0,0-.78-1.17c-.34-.34-.75-.6-1.15-1a2.57,2.57,0,0,1,1.44.65,2,2,0,0,1,.47.67A1.13,1.13,0,0,1,127.41,261.66Z"
                fill="#2f6840"
              />
              <path
                d="M125.09,259.35c-.29.07-.56.1-.82.18a4.89,4.89,0,0,0-.76.27,10.47,10.47,0,0,0-1.48.77,2.65,2.65,0,0,1,1.31-1.16A2.41,2.41,0,0,1,125.09,259.35Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M106,221.83s-1.53,5.14-4.41,6.43-7.79-1.33-6.75,1.32-5.1,4.91-7.9,4.59-9.56-5.89-9.78-8S106,221.83,106,221.83Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M105.63,217.87l.4,4-4.62,4.86-6.67.86-1.21,3.15s-4.28,3.15-7.67,1a26.65,26.65,0,0,1-6.29-6.42l-.4-4Z"
              fill="#ccae79"
            />
            <path
              d="M99.94,216l5.69,1.86-5,4.9-6.37.83-1.76,3.3s-6,2.91-7,.91-6.3-6.5-6.3-6.5l4.69-3.21Z"
              fill="#ffedc8"
            />
            <polygon
              points="100.63 222.77 101.41 226.69 94.74 227.55 94.26 223.6 100.63 222.77"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M87.17,228.51s-.64,3.76.39,3.85a16.16,16.16,0,0,1-8-7.09l-.4-4S85.71,228.72,87.17,228.51Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M91.4,227.38l-1.22.47s.75-.36.77,1.33A4.56,4.56,0,0,1,91.4,227.38Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M88.59,228.35c.13-.07-.25.07-1.55-1.1a8.39,8.39,0,0,1-1.89-2.47s3.14,3.09,2.54,3.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M102.71,220.74a25.35,25.35,0,0,0,.29,2.86s-.13-2.17-.7-2.46Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M92.28,217l-2.54.33c-.18,0,2-.27,2.67.94L92.27,217"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M102.76,216.93l-1.41-.46s.82.42.53.58-1.4.89-1.9.68-1.27.24-1.27.24Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M40.2,215.81s2.07,4.45,4.87,5.15,7-2.5,6.34.1,5.29,3.64,7.81,2.89,8-7,7.91-8.9S40.2,215.81,40.2,215.81Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M40.06,212.13l.14,3.68,4.85,3.68,6.21-.31,1.52,2.67s4.32,2.18,7.13-.35a26,26,0,0,0,4.92-6.91l-.14-3.68Z"
              fill="#ccae79"
            />
            <path
              d="M45,209.49l-4.95,2.64,5.2,3.65,5.93-.29,2,2.72s5.87,1.67,6.55-.32,4.92-7,4.92-7L60,208.75Z"
              fill="#ffedc8"
            />
            <polygon
              points="45.26 215.78 45.05 219.49 51.26 219.18 51.19 215.49 45.26 215.78"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M58.3,218.8s1.08,3.34.14,3.59a15.79,15.79,0,0,0,6.39-7.8l-.14-3.68S59.67,218.76,58.3,218.8Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M54.29,218.47l1.18.22s-.74-.2-.53,1.35A4,4,0,0,0,54.29,218.47Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M57,218.9c-.13-.05.23,0,1.27-1.27a8.18,8.18,0,0,0,1.4-2.56s-2.46,3.34-1.84,3.78Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M43.1,214.26a26,26,0,0,1,.1,2.67s-.16-2,.33-2.37Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M52.15,209.13l2.36-.11c.17,0-1.85.08-2.31,1.3l-.05-1.19"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M42.56,210.8l1.23-.66s-.69.52-.41.62,1.39.58,1.83.3a1.62,1.62,0,0,1,1.18,0Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M15.35,189.05l6.6,4.63a1.94,1.94,0,0,0,2,.15l15.85-8a2.58,2.58,0,0,0,.53-4h0a2,2,0,0,0-1.69-.58L16.2,184.58C14.2,184.88,13.64,187.84,15.35,189.05Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="27.07 170.51 18.13 172.66 10.26 179.49 23.45 185.47 39.61 177.99 27.07 170.51"
              fill="#ffedc8"
            />
            <polygon
              points="10.26 179.49 10.26 185.47 22.92 191.61 39.96 183.79 39.61 177.99 23.45 185.47 10.26 179.49"
              fill="#ccae79"
            />
            <polygon
              points="23.45 185.47 22.92 191.61 39.96 183.79 39.61 177.99 23.45 185.47"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M14,181.2a3,3,0,0,1,0,3.07c.6-1,.74-2.74,1-2.61Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M19.59,183.72a7.94,7.94,0,0,0,3.33-3.82l-2.4,4.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M30.12,182.38a2.78,2.78,0,0,1,1.32,2.42L31,182Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M36,175.86c-.17-.1-3.34.72-5.25,0a6.74,6.74,0,0,1-3.82.3s2.81-.31,3.82.77A20.51,20.51,0,0,1,36,175.86Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M295.06,311.66l6.6,4.63a1.94,1.94,0,0,0,2,.15l15.85-8a2.58,2.58,0,0,0,.53-4h0a2,2,0,0,0-1.69-.58l-22.45,3.38C293.91,307.49,293.35,310.45,295.06,311.66Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="306.78 293.12 297.84 295.27 289.97 302.1 303.16 308.08 319.32 300.6 306.78 293.12"
              fill="#ffedc8"
            />
            <polygon
              points="289.97 302.1 289.97 308.08 302.63 314.22 319.67 306.4 319.32 300.6 303.16 308.08 289.97 302.1"
              fill="#ccae79"
            />
            <polygon
              points="303.16 308.08 302.63 314.22 319.67 306.4 319.32 300.6 303.16 308.08"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M293.73,303.81a3,3,0,0,1,0,3.07c.6-1,.74-2.74,1-2.61Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M299.3,306.33a7.94,7.94,0,0,0,3.33-3.82l-2.39,4.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M309.83,305a2.78,2.78,0,0,1,1.32,2.42l-.39-2.84Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M315.74,298.47c-.17-.1-3.34.72-5.24,0a6.78,6.78,0,0,1-3.83.3s2.81-.31,3.83.77A20.38,20.38,0,0,1,315.74,298.47Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M4.16,212l5.4,3.79a1.57,1.57,0,0,0,1.64.13l13-6.55a2.12,2.12,0,0,0,.43-3.31h0a1.6,1.6,0,0,0-1.38-.46L4.86,208.37A2.06,2.06,0,0,0,4.16,212Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="13.74 196.88 6.43 198.63 0 204.22 10.78 209.1 23.99 202.99 13.74 196.88"
              fill="#ffedc8"
            />
            <polygon
              points="0 204.22 0 209.1 10.35 214.12 24.28 207.73 23.99 202.99 10.78 209.1 0 204.22"
              fill="#ccae79"
            />
            <polygon
              points="10.78 209.1 10.35 214.12 24.28 207.73 23.99 202.99 10.78 209.1"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M3.08,205.61a2.44,2.44,0,0,1,0,2.51c.49-.79.6-2.24.82-2.13Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M7.63,207.67a6.55,6.55,0,0,0,2.72-3.12l-2,3.47Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M16.24,206.58a2.25,2.25,0,0,1,1.07,2L17,206.23Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M21.06,201.25c-.13-.09-2.72.59-4.28,0a5.49,5.49,0,0,1-3.13.24s2.3-.25,3.13.64A16.21,16.21,0,0,1,21.06,201.25Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M22.2,229.73l5.4,3.78a1.57,1.57,0,0,0,1.64.13l13-6.55a2.12,2.12,0,0,0,.43-3.31h0a1.6,1.6,0,0,0-1.38-.46L22.9,226.08C21.26,226.32,20.8,228.74,22.2,229.73Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="31.78 214.58 24.48 216.33 18.04 221.92 28.82 226.81 42.03 220.69 31.78 214.58"
              fill="#ffedc8"
            />
            <polygon
              points="18.04 221.92 18.04 226.81 28.39 231.82 42.32 225.43 42.03 220.69 28.82 226.81 18.04 221.92"
              fill="#ccae79"
            />
            <polygon
              points="28.82 226.81 28.39 231.82 42.32 225.43 42.03 220.69 28.82 226.81"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M21.12,223.31a2.44,2.44,0,0,1,0,2.51c.49-.78.6-2.23.82-2.13Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M25.67,225.38a6.54,6.54,0,0,0,2.72-3.13l-2,3.47Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M34.28,224.28a2.26,2.26,0,0,1,1.07,2L35,223.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M39.1,219c-.13-.08-2.72.59-4.28,0a5.49,5.49,0,0,1-3.13.24s2.3-.25,3.13.64A16.65,16.65,0,0,1,39.1,219Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M41.07,236.16l3,2.11a.88.88,0,0,0,.91.07l7.22-3.65a1.18,1.18,0,0,0,.24-1.84h0a.9.9,0,0,0-.77-.26l-10.22,1.53A1.16,1.16,0,0,0,41.07,236.16Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="46.41 227.72 42.34 228.7 38.76 231.81 44.76 234.53 52.12 231.13 46.41 227.72"
              fill="#ffedc8"
            />
            <polygon
              points="38.76 231.81 38.76 234.53 44.52 237.32 52.28 233.76 52.12 231.13 44.76 234.53 38.76 231.81"
              fill="#ccae79"
            />
            <polygon
              points="44.76 234.53 44.52 237.32 52.28 233.76 52.12 231.13 44.76 234.53"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M40.47,232.59a1.34,1.34,0,0,1,0,1.39c.27-.43.34-1.24.46-1.18Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M43,233.74A3.6,3.6,0,0,0,44.52,232l-1.09,1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M47.8,233.13a1.26,1.26,0,0,1,.6,1.1l-.18-1.3Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M50.49,230.16a6.44,6.44,0,0,1-2.39,0,3,3,0,0,1-1.74.13s1.28-.14,1.74.36A9.11,9.11,0,0,1,50.49,230.16Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M390,332.07l3,2.11a.9.9,0,0,0,.92.07l7.21-3.64a1.19,1.19,0,0,0,.24-1.85h0a.93.93,0,0,0-.77-.26L390.41,330A1.14,1.14,0,0,0,390,332.07Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="395.36 323.64 391.29 324.61 387.71 327.73 393.71 330.45 401.07 327.04 395.36 323.64"
              fill="#ffedc8"
            />
            <polygon
              points="387.71 327.73 387.71 330.45 393.47 333.24 401.23 329.68 401.07 327.04 393.71 330.45 387.71 327.73"
              fill="#ccae79"
            />
            <polygon
              points="393.71 330.45 393.47 333.24 401.23 329.68 401.07 327.04 393.71 330.45"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M389.42,328.5a1.35,1.35,0,0,1,0,1.4c.27-.44.34-1.25.46-1.19Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M392,329.65a3.61,3.61,0,0,0,1.51-1.74l-1.09,1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M396.75,329a1.26,1.26,0,0,1,.6,1.1l-.18-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M399.44,326.07a6.44,6.44,0,0,1-2.39,0,3.1,3.1,0,0,1-1.74.14s1.28-.14,1.74.35A9.18,9.18,0,0,1,399.44,326.07Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M130,258.18l3,2.11a.88.88,0,0,0,.91.07l7.22-3.64a1.19,1.19,0,0,0,.24-1.85h0a.93.93,0,0,0-.77-.26l-10.22,1.54A1.15,1.15,0,0,0,130,258.18Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="135.37 249.75 131.3 250.72 127.71 253.83 133.72 256.56 141.07 253.15 135.37 249.75"
              fill="#ffedc8"
            />
            <polygon
              points="127.71 253.83 127.71 256.56 133.48 259.35 141.23 255.79 141.07 253.15 133.72 256.56 127.71 253.83"
              fill="#ccae79"
            />
            <polygon
              points="133.72 256.56 133.48 259.35 141.23 255.79 141.07 253.15 133.72 256.56"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M129.43,254.61a1.38,1.38,0,0,1,0,1.4c.27-.44.33-1.25.46-1.19Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M132,255.76a3.65,3.65,0,0,0,1.52-1.74L132.39,256Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M136.76,255.15a1.24,1.24,0,0,1,.59,1.1l-.17-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M139.44,252.18a6.37,6.37,0,0,1-2.38,0,3.1,3.1,0,0,1-1.74.14s1.27-.14,1.74.35A9.06,9.06,0,0,1,139.44,252.18Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M135.25,246.48l3,2.11a.88.88,0,0,0,.91.07l7.22-3.65a1.18,1.18,0,0,0,.24-1.84h0a.9.9,0,0,0-.77-.26l-10.22,1.53A1.16,1.16,0,0,0,135.25,246.48Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="140.59 238.04 136.52 239.02 132.94 242.13 138.94 244.85 146.3 241.45 140.59 238.04"
              fill="#ffedc8"
            />
            <polygon
              points="132.94 242.13 132.94 244.85 138.7 247.64 146.46 244.09 146.3 241.45 138.94 244.85 132.94 242.13"
              fill="#ccae79"
            />
            <polygon
              points="138.94 244.85 138.7 247.64 146.46 244.09 146.3 241.45 138.94 244.85"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M134.65,242.91a1.34,1.34,0,0,1,0,1.39c.27-.43.34-1.24.46-1.18Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M137.19,244.06a3.61,3.61,0,0,0,1.51-1.74l-1.09,1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M142,243.45a1.26,1.26,0,0,1,.6,1.09l-.18-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M144.67,240.47a6,6,0,0,1-2.39,0,3,3,0,0,1-1.74.14s1.28-.14,1.74.35A9.56,9.56,0,0,1,144.67,240.47Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M114,251.83l3,2.11a.88.88,0,0,0,.91.07l7.22-3.64a1.19,1.19,0,0,0,.24-1.85h0a.93.93,0,0,0-.77-.26l-10.22,1.54A1.15,1.15,0,0,0,114,251.83Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="119.31 243.4 115.24 244.37 111.66 247.49 117.66 250.21 125.02 246.8 119.31 243.4"
              fill="#ffedc8"
            />
            <polygon
              points="111.66 247.49 111.66 250.21 117.42 253 125.18 249.44 125.02 246.8 117.66 250.21 111.66 247.49"
              fill="#ccae79"
            />
            <polygon
              points="117.66 250.21 117.42 253 125.18 249.44 125.02 246.8 117.66 250.21"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M113.37,248.26a1.35,1.35,0,0,1,0,1.4c.27-.44.34-1.25.46-1.19Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M115.9,249.41a3.6,3.6,0,0,0,1.52-1.74l-1.09,1.93Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M120.7,248.8a1.26,1.26,0,0,1,.6,1.1l-.18-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M123.39,245.83a6.44,6.44,0,0,1-2.39,0,3.1,3.1,0,0,1-1.74.14s1.28-.14,1.74.35A9.11,9.11,0,0,1,123.39,245.83Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M62.17,235l4.45,3.13a1.33,1.33,0,0,0,1.36.1l10.69-5.4a1.75,1.75,0,0,0,.35-2.73h0a1.36,1.36,0,0,0-1.14-.38L62.75,232A1.7,1.7,0,0,0,62.17,235Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="70.07 222.53 64.05 223.97 58.74 228.59 67.64 232.62 78.53 227.57 70.07 222.53"
              fill="#ffedc8"
            />
            <polygon
              points="58.74 228.59 58.74 232.62 67.28 236.75 78.77 231.48 78.53 227.57 67.64 232.62 58.74 228.59"
              fill="#ccae79"
            />
            <polygon
              points="67.64 232.62 67.28 236.75 78.77 231.48 78.53 227.57 67.64 232.62"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M61.28,229.74a2,2,0,0,1,0,2.06c.4-.64.49-1.84.68-1.76Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M65,231.44a5.39,5.39,0,0,0,2.25-2.58l-1.62,2.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M72.13,230.53a1.87,1.87,0,0,1,.89,1.63l-.26-1.91Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M76.12,226.13c-.12-.06-2.25.49-3.54,0a4.5,4.5,0,0,1-2.58.21s1.89-.21,2.58.52A13.77,13.77,0,0,1,76.12,226.13Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <g>
          <g>
            <g>
              <path
                d="M421.53,131.65c4.23-.24-4.13.44-4.15-.58s4.15-2.51,5-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,421.53,131.65Z"
                fill="#2f6840"
              />
              <path
                d="M421.05,131.32c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,421.05,131.32Z"
                fill="#3ba525"
              />
              <path
                d="M421.77,131.3a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A1,1,0,0,1,421.77,131.3Z"
                fill="#2f6840"
              />
              <path
                d="M425.09,130.54c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,425.09,130.54Z"
                fill="#2f6840"
              />
              <path
                d="M423.79,133.6a1.9,1.9,0,0,0-.63-.94c-.28-.28-.61-.48-.93-.77a2.08,2.08,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.91.91,0,0,1,423.79,133.6Z"
                fill="#2f6840"
              />
              <path
                d="M421.91,131.74a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.14,2.14,0,0,1,1.06-.93A1.91,1.91,0,0,1,421.91,131.74Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M419,140c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,419,140Z"
                fill="#2f6840"
              />
              <path
                d="M418.51,139.66c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.06,3.46,3.39,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63S419,140.5,419,140.5s-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,418.51,139.66Z"
                fill="#3ba525"
              />
              <path
                d="M419.23,139.64a2,2,0,0,0-.76-.9c-.31-.25-.68-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,419.23,139.64Z"
                fill="#2f6840"
              />
              <path
                d="M422.55,138.88c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.33,2.33,0,0,1,1.18-.83A2,2,0,0,1,422.55,138.88Z"
                fill="#2f6840"
              />
              <path
                d="M421.24,141.94a1.77,1.77,0,0,0-.63-.94c-.27-.28-.6-.48-.92-.77a2.08,2.08,0,0,1,1.16.52,1.75,1.75,0,0,1,.38.54A.86.86,0,0,1,421.24,141.94Z"
                fill="#2f6840"
              />
              <path
                d="M419.37,140.08a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.1,2.1,0,0,1,1.06-.93A1.91,1.91,0,0,1,419.37,140.08Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M413.88,135.26c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.25,2.15.25,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.15,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.85,13.85,0,0,1,413.88,135.26Z"
                fill="#2f6840"
              />
              <path
                d="M413.4,134.93c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.54,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77S413,139,411,138.2s-2.16-2.17-2-2.26A13.76,13.76,0,0,1,413.4,134.93Z"
                fill="#3ba525"
              />
              <path
                d="M414.11,134.9a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A.9.9,0,0,1,414.11,134.9Z"
                fill="#2f6840"
              />
              <path
                d="M417.44,134.14c-.25,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2.07,2.07,0,0,1,417.44,134.14Z"
                fill="#2f6840"
              />
              <path
                d="M416.13,137.21a1.82,1.82,0,0,0-.63-1c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.74,1.74,0,0,1,.39.54A.94.94,0,0,1,416.13,137.21Z"
                fill="#2f6840"
              />
              <path
                d="M414.26,135.34c-.24.06-.46.08-.67.15a3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.19,2.19,0,0,1,1.07-.94A2,2,0,0,1,414.26,135.34Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M405.91,132c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.85,13.85,0,0,1,405.91,132Z"
                fill="#2f6840"
              />
              <path
                d="M405.42,131.71c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.86,2.44-2.16-2.17-2-2.26A13.75,13.75,0,0,1,405.42,131.71Z"
                fill="#3ba525"
              />
              <path
                d="M406.14,131.68a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.9.9,0,0,1,406.14,131.68Z"
                fill="#2f6840"
              />
              <path
                d="M409.47,130.92c-.25,0-.47,0-.7.09a4.29,4.29,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,409.47,130.92Z"
                fill="#2f6840"
              />
              <path
                d="M408.16,134a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,408.16,134Z"
                fill="#2f6840"
              />
              <path
                d="M406.29,132.12a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,406.29,132.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M420,146.83c4.23-.23-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,420,146.83Z"
                fill="#2f6840"
              />
              <path
                d="M419.47,146.51c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.66,13.66,0,0,1,419.47,146.51Z"
                fill="#3ba525"
              />
              <path
                d="M420.19,146.48a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A1,1,0,0,1,420.19,146.48Z"
                fill="#2f6840"
              />
              <path
                d="M423.52,145.72c-.25,0-.47,0-.7.09a3.35,3.35,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,423.52,145.72Z"
                fill="#2f6840"
              />
              <path
                d="M422.21,148.79a1.82,1.82,0,0,0-.63-.95c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.89.89,0,0,1,422.21,148.79Z"
                fill="#2f6840"
              />
              <path
                d="M420.34,146.92a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,8.48,8.48,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,420.34,146.92Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M407.1,141.51c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.14.25,2.14,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,407.1,141.51Z"
                fill="#2f6840"
              />
              <path
                d="M406.62,141.18c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,406.62,141.18Z"
                fill="#3ba525"
              />
              <path
                d="M407.34,141.16a2,2,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.71,1.71,0,0,1,.45.51A1,1,0,0,1,407.34,141.16Z"
                fill="#2f6840"
              />
              <path
                d="M410.66,140.4a6.81,6.81,0,0,0-.69.09,3.66,3.66,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,410.66,140.4Z"
                fill="#2f6840"
              />
              <path
                d="M409.35,143.46a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.92-.78a2.11,2.11,0,0,1,1.15.53,1.53,1.53,0,0,1,.39.54A.86.86,0,0,1,409.35,143.46Z"
                fill="#2f6840"
              />
              <path
                d="M407.48,141.6c-.23.05-.45.08-.67.15a4,4,0,0,0-.61.21,10.56,10.56,0,0,0-1.2.62,2.17,2.17,0,0,1,1.07-.93A1.86,1.86,0,0,1,407.48,141.6Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M394.7,127c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,394.7,127Z"
                fill="#2f6840"
              />
              <path
                d="M394.22,126.71c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,394.22,126.71Z"
                fill="#3ba525"
              />
              <path
                d="M394.94,126.69a2,2,0,0,0-.76-.9c-.31-.25-.68-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,394.94,126.69Z"
                fill="#2f6840"
              />
              <path
                d="M398.26,125.93c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.33,2.33,0,0,1,1.18-.83A2,2,0,0,1,398.26,125.93Z"
                fill="#2f6840"
              />
              <path
                d="M397,129a1.77,1.77,0,0,0-.63-.94c-.27-.28-.6-.48-.92-.77a2.08,2.08,0,0,1,1.16.52,1.75,1.75,0,0,1,.38.54A.86.86,0,0,1,397,129Z"
                fill="#2f6840"
              />
              <path
                d="M395.08,127.13a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.1,2.1,0,0,1,1.06-.93A1.91,1.91,0,0,1,395.08,127.13Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M392.16,135.38c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,392.16,135.38Z"
                fill="#2f6840"
              />
              <path
                d="M391.68,135.05c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,391.68,135.05Z"
                fill="#3ba525"
              />
              <path
                d="M392.4,135a2,2,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,392.4,135Z"
                fill="#2f6840"
              />
              <path
                d="M395.72,134.27c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13.1,13.1,0,0,0-1.29.5,2.4,2.4,0,0,1,1.19-.83A2,2,0,0,1,395.72,134.27Z"
                fill="#2f6840"
              />
              <path
                d="M394.41,137.33a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.63,1.63,0,0,1,.39.54A.86.86,0,0,1,394.41,137.33Z"
                fill="#2f6840"
              />
              <path
                d="M392.54,135.47a6.38,6.38,0,0,0-.66.15,3,3,0,0,0-.62.22,9.05,9.05,0,0,0-1.2.61,2.17,2.17,0,0,1,1.07-.93A1.91,1.91,0,0,1,392.54,135.47Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M387.05,130.65c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.85,13.85,0,0,1,387.05,130.65Z"
                fill="#2f6840"
              />
              <path
                d="M386.56,130.32c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A13.75,13.75,0,0,1,386.56,130.32Z"
                fill="#3ba525"
              />
              <path
                d="M387.28,130.29a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.9.9,0,0,1,387.28,130.29Z"
                fill="#2f6840"
              />
              <path
                d="M390.61,129.53c-.25,0-.47,0-.7.09a4.29,4.29,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2.07,2.07,0,0,1,390.61,129.53Z"
                fill="#2f6840"
              />
              <path
                d="M389.3,132.6a1.82,1.82,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.56,1.56,0,0,1,.38.54A.89.89,0,0,1,389.3,132.6Z"
                fill="#2f6840"
              />
              <path
                d="M387.43,130.73c-.24.06-.46.08-.67.15a3.16,3.16,0,0,0-.61.22,8.57,8.57,0,0,0-1.2.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,387.43,130.73Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M379.08,127.43c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.76,13.76,0,0,1,379.08,127.43Z"
                fill="#2f6840"
              />
              <path
                d="M378.59,127.1c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.66,13.66,0,0,1,378.59,127.1Z"
                fill="#3ba525"
              />
              <path
                d="M379.31,127.07a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A1,1,0,0,1,379.31,127.07Z"
                fill="#2f6840"
              />
              <path
                d="M382.64,126.31c-.25,0-.47,0-.7.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,382.64,126.31Z"
                fill="#2f6840"
              />
              <path
                d="M381.33,129.38a1.82,1.82,0,0,0-.63-.95c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.89.89,0,0,1,381.33,129.38Z"
                fill="#2f6840"
              />
              <path
                d="M379.46,127.51a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,9.69,9.69,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,379.46,127.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M393.13,142.22c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,393.13,142.22Z"
                fill="#2f6840"
              />
              <path
                d="M392.64,141.9c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.66,13.66,0,0,1,392.64,141.9Z"
                fill="#3ba525"
              />
              <path
                d="M393.36,141.87a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.15,2.15,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,393.36,141.87Z"
                fill="#2f6840"
              />
              <path
                d="M396.68,141.11c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,396.68,141.11Z"
                fill="#2f6840"
              />
              <path
                d="M395.38,144.18a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.93-.77A2.05,2.05,0,0,1,395,143a1.47,1.47,0,0,1,.38.54A.94.94,0,0,1,395.38,144.18Z"
                fill="#2f6840"
              />
              <path
                d="M393.51,142.31a6,6,0,0,0-.67.15,3.52,3.52,0,0,0-.62.22,9,9,0,0,0-1.19.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,393.51,142.31Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M380.27,136.9c4.23-.24-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.14.25,2.14,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49.05-4.49.05,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,380.27,136.9Z"
                fill="#2f6840"
              />
              <path
                d="M379.79,136.57c4.22-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,379.79,136.57Z"
                fill="#3ba525"
              />
              <path
                d="M380.51,136.55a2.07,2.07,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.71,1.71,0,0,1,.45.51A1,1,0,0,1,380.51,136.55Z"
                fill="#2f6840"
              />
              <path
                d="M383.83,135.79a6.81,6.81,0,0,0-.69.09,3.66,3.66,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,383.83,135.79Z"
                fill="#2f6840"
              />
              <path
                d="M382.52,138.85a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.93-.78a2.1,2.1,0,0,1,1.16.53,1.53,1.53,0,0,1,.39.54A.91.91,0,0,1,382.52,138.85Z"
                fill="#2f6840"
              />
              <path
                d="M380.65,137a6.58,6.58,0,0,0-.67.15,4,4,0,0,0-.61.21,10.56,10.56,0,0,0-1.2.62,2.17,2.17,0,0,1,1.07-.93A1.86,1.86,0,0,1,380.65,137Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M367.57,125c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.25,2.15.25,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.66,13.66,0,0,1,367.57,125Z"
                fill="#2f6840"
              />
              <path
                d="M367.09,124.69c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,367.09,124.69Z"
                fill="#3ba525"
              />
              <path
                d="M367.81,124.66a2.12,2.12,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,367.81,124.66Z"
                fill="#2f6840"
              />
              <path
                d="M371.13,123.9a6.81,6.81,0,0,0-.69.09,4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,371.13,123.9Z"
                fill="#2f6840"
              />
              <path
                d="M369.82,127a1.82,1.82,0,0,0-.63-1c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,369.82,127Z"
                fill="#2f6840"
              />
              <path
                d="M368,125.1c-.23.05-.45.08-.67.15a3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.22,2.22,0,0,1,1.07-.93A1.91,1.91,0,0,1,368,125.1Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M365,133.36c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.85,13.85,0,0,1,365,133.36Z"
                fill="#2f6840"
              />
              <path
                d="M364.55,133c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.64-1.11-2.78-1.11-2.78-.88,3.19-2.87,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,364.55,133Z"
                fill="#3ba525"
              />
              <path
                d="M365.26,133a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A.9.9,0,0,1,365.26,133Z"
                fill="#2f6840"
              />
              <path
                d="M368.59,132.24a6.81,6.81,0,0,0-.69.09,4.42,4.42,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,368.59,132.24Z"
                fill="#2f6840"
              />
              <path
                d="M367.28,135.31a1.82,1.82,0,0,0-.63-.95c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,367.28,135.31Z"
                fill="#2f6840"
              />
              <path
                d="M365.41,133.44a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,365.41,133.44Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M359.91,128.62c4.23-.24-4.13.43-4.15-.58s4.15-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.86,2.43-2.16-2.17-2-2.26A13.75,13.75,0,0,1,359.91,128.62Z"
                fill="#2f6840"
              />
              <path
                d="M359.43,128.29c4.23-.24-4.13.44-4.16-.58s4.16-2.52,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A14,14,0,0,1,359.43,128.29Z"
                fill="#3ba525"
              />
              <path
                d="M360.15,128.26a2.08,2.08,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,360.15,128.26Z"
                fill="#2f6840"
              />
              <path
                d="M363.47,127.5c-.24,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,363.47,127.5Z"
                fill="#2f6840"
              />
              <path
                d="M362.17,130.57a1.86,1.86,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,362.17,130.57Z"
                fill="#2f6840"
              />
              <path
                d="M360.3,128.7c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,360.3,128.7Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M351.94,125.4c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.66,13.66,0,0,1,351.94,125.4Z"
                fill="#2f6840"
              />
              <path
                d="M351.46,125.07c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A13.66,13.66,0,0,1,351.46,125.07Z"
                fill="#3ba525"
              />
              <path
                d="M352.18,125a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,352.18,125Z"
                fill="#2f6840"
              />
              <path
                d="M355.5,124.28c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,355.5,124.28Z"
                fill="#2f6840"
              />
              <path
                d="M354.2,127.35a1.82,1.82,0,0,0-.63-.95c-.28-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,354.2,127.35Z"
                fill="#2f6840"
              />
              <path
                d="M352.33,125.48c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,352.33,125.48Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M366,140.2c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63S366.5,141,366.5,141s-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.66,13.66,0,0,1,366,140.2Z"
                fill="#2f6840"
              />
              <path
                d="M365.51,139.87c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64S366,140.7,366,140.7s-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.66,13.66,0,0,1,365.51,139.87Z"
                fill="#3ba525"
              />
              <path
                d="M366.23,139.84a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A1,1,0,0,1,366.23,139.84Z"
                fill="#2f6840"
              />
              <path
                d="M369.55,139.08c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,369.55,139.08Z"
                fill="#2f6840"
              />
              <path
                d="M368.24,142.15a1.8,1.8,0,0,0-.62-1c-.28-.27-.61-.48-.93-.77a2.08,2.08,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.89.89,0,0,1,368.24,142.15Z"
                fill="#2f6840"
              />
              <path
                d="M366.37,140.28a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,366.37,140.28Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M353.14,134.87c4.23-.23-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,353.14,134.87Z"
                fill="#2f6840"
              />
              <path
                d="M352.65,134.55c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.66,13.66,0,0,1,352.65,134.55Z"
                fill="#3ba525"
              />
              <path
                d="M353.37,134.52a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A1,1,0,0,1,353.37,134.52Z"
                fill="#2f6840"
              />
              <path
                d="M356.7,133.76a7,7,0,0,0-.7.09,4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,356.7,133.76Z"
                fill="#2f6840"
              />
              <path
                d="M355.39,136.83a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.94.94,0,0,1,355.39,136.83Z"
                fill="#2f6840"
              />
              <path
                d="M353.52,135a6,6,0,0,0-.67.15,3.52,3.52,0,0,0-.62.22,10.33,10.33,0,0,0-1.19.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,353.52,135Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M340.57,127.42c4.22-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.79-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.86,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,340.57,127.42Z"
                fill="#2f6840"
              />
              <path
                d="M340.08,127.1c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.76.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.66,13.66,0,0,1,340.08,127.1Z"
                fill="#3ba525"
              />
              <path
                d="M340.8,127.07a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.17,2.17,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,340.8,127.07Z"
                fill="#2f6840"
              />
              <path
                d="M344.12,126.31c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,344.12,126.31Z"
                fill="#2f6840"
              />
              <path
                d="M342.82,129.37a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.91.91,0,0,1,342.82,129.37Z"
                fill="#2f6840"
              />
              <path
                d="M341,127.51a6,6,0,0,0-.67.15,3.52,3.52,0,0,0-.62.22,9,9,0,0,0-1.19.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,341,127.51Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M338,135.76c4.23-.24-4.13.44-4.15-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.79-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,338,135.76Z"
                fill="#2f6840"
              />
              <path
                d="M337.54,135.43c4.23-.23-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,337.54,135.43Z"
                fill="#3ba525"
              />
              <path
                d="M338.26,135.41a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,338.26,135.41Z"
                fill="#2f6840"
              />
              <path
                d="M341.58,134.65c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,341.58,134.65Z"
                fill="#2f6840"
              />
              <path
                d="M340.28,137.71a1.83,1.83,0,0,0-.63-.94c-.28-.28-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.91.91,0,0,1,340.28,137.71Z"
                fill="#2f6840"
              />
              <path
                d="M338.41,135.85a6,6,0,0,0-.67.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.14,2.14,0,0,1,1.06-.93A1.94,1.94,0,0,1,338.41,135.85Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M332.91,131c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.66,13.66,0,0,1,332.91,131Z"
                fill="#2f6840"
              />
              <path
                d="M332.43,130.7c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A13.76,13.76,0,0,1,332.43,130.7Z"
                fill="#3ba525"
              />
              <path
                d="M333.15,130.67a2,2,0,0,0-.77-.89c-.3-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,333.15,130.67Z"
                fill="#2f6840"
              />
              <path
                d="M336.47,129.91c-.25,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,336.47,129.91Z"
                fill="#2f6840"
              />
              <path
                d="M335.16,133a1.82,1.82,0,0,0-.63-.95c-.27-.27-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.74,1.74,0,0,1,.39.54A.89.89,0,0,1,335.16,133Z"
                fill="#2f6840"
              />
              <path
                d="M333.29,131.11c-.23.06-.45.08-.67.15a3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.19,2.19,0,0,1,1.07-.94A2,2,0,0,1,333.29,131.11Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M324.94,127.81c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.66,13.66,0,0,1,324.94,127.81Z"
                fill="#2f6840"
              />
              <path
                d="M324.46,127.48c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,324.46,127.48Z"
                fill="#3ba525"
              />
              <path
                d="M325.18,127.45a2.06,2.06,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,325.18,127.45Z"
                fill="#2f6840"
              />
              <path
                d="M328.5,126.69a6.81,6.81,0,0,0-.69.09,4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,328.5,126.69Z"
                fill="#2f6840"
              />
              <path
                d="M327.19,129.76a1.82,1.82,0,0,0-.63-.95c-.27-.27-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.63,1.63,0,0,1,.39.54A.89.89,0,0,1,327.19,129.76Z"
                fill="#2f6840"
              />
              <path
                d="M325.32,127.89c-.23,0-.45.08-.67.15a3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.22,2.22,0,0,1,1.07-.93A1.91,1.91,0,0,1,325.32,127.89Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M339,142.6c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,339,142.6Z"
                fill="#2f6840"
              />
              <path
                d="M338.51,142.28c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.79-2.06,3.46,3.4,2.54,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.76,13.76,0,0,1,338.51,142.28Z"
                fill="#3ba525"
              />
              <path
                d="M339.23,142.25a2.12,2.12,0,0,0-.77-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,339.23,142.25Z"
                fill="#2f6840"
              />
              <path
                d="M342.55,141.49a6.81,6.81,0,0,0-.69.09,3.66,3.66,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,342.55,141.49Z"
                fill="#2f6840"
              />
              <path
                d="M341.24,144.56a1.82,1.82,0,0,0-.63-.95c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,341.24,144.56Z"
                fill="#2f6840"
              />
              <path
                d="M339.37,142.69a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,9.05,9.05,0,0,0-1.2.61,2.17,2.17,0,0,1,1.07-.93A1.91,1.91,0,0,1,339.37,142.69Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M326.13,137.28c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5-2.34.25,2.14.25,2.14,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.76.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,326.13,137.28Z"
                fill="#2f6840"
              />
              <path
                d="M325.65,137c4.23-.24-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,325.65,137Z"
                fill="#3ba525"
              />
              <path
                d="M326.37,136.93a2,2,0,0,0-.76-.9c-.31-.25-.68-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.71,1.71,0,0,1,.45.51A1,1,0,0,1,326.37,136.93Z"
                fill="#2f6840"
              />
              <path
                d="M329.69,136.17c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.33,2.33,0,0,1,1.18-.83A2,2,0,0,1,329.69,136.17Z"
                fill="#2f6840"
              />
              <path
                d="M328.38,139.23a1.77,1.77,0,0,0-.63-.94c-.27-.28-.6-.48-.92-.78A2.17,2.17,0,0,1,328,138a1.75,1.75,0,0,1,.38.54A.86.86,0,0,1,328.38,139.23Z"
                fill="#2f6840"
              />
              <path
                d="M326.51,137.37a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.1,2.1,0,0,1,1.06-.93A1.91,1.91,0,0,1,326.51,137.37Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M315,135.86c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.66,13.66,0,0,1,315,135.86Z"
                fill="#2f6840"
              />
              <path
                d="M314.5,135.53c4.23-.24-4.14.43-4.16-.58s4.16-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A13.85,13.85,0,0,1,314.5,135.53Z"
                fill="#3ba525"
              />
              <path
                d="M315.22,135.5a2,2,0,0,0-.77-.89c-.3-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,315.22,135.5Z"
                fill="#2f6840"
              />
              <path
                d="M318.54,134.74c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13.1,13.1,0,0,0-1.29.5,2.32,2.32,0,0,1,1.19-.82A2,2,0,0,1,318.54,134.74Z"
                fill="#2f6840"
              />
              <path
                d="M317.23,137.81a1.82,1.82,0,0,0-.63-.95c-.27-.27-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.74,1.74,0,0,1,.39.54A.89.89,0,0,1,317.23,137.81Z"
                fill="#2f6840"
              />
              <path
                d="M315.36,135.94c-.23.06-.45.08-.66.15a3,3,0,0,0-.62.22,9.15,9.15,0,0,0-1.2.62A2.19,2.19,0,0,1,314,136,2,2,0,0,1,315.36,135.94Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M312.44,144.2c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64S313,145,313,145s-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.66,13.66,0,0,1,312.44,144.2Z"
                fill="#2f6840"
              />
              <path
                d="M312,143.87c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A13.76,13.76,0,0,1,312,143.87Z"
                fill="#3ba525"
              />
              <path
                d="M312.68,143.84a2,2,0,0,0-.77-.89c-.3-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,312.68,143.84Z"
                fill="#2f6840"
              />
              <path
                d="M316,143.08c-.25,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,316,143.08Z"
                fill="#2f6840"
              />
              <path
                d="M314.69,146.15a1.82,1.82,0,0,0-.63-1c-.27-.27-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.74,1.74,0,0,1,.39.54A.89.89,0,0,1,314.69,146.15Z"
                fill="#2f6840"
              />
              <path
                d="M312.82,144.28c-.23.06-.45.08-.67.15a3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.19,2.19,0,0,1,1.07-.94A2,2,0,0,1,312.82,144.28Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M307.33,139.46c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.43-2.16-2.17-2-2.26A14.39,14.39,0,0,1,307.33,139.46Z"
                fill="#2f6840"
              />
              <path
                d="M306.84,139.13c4.23-.24-4.13.44-4.15-.58s4.15-2.51,5-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.43-2.15-2.17-2-2.26A14.29,14.29,0,0,1,306.84,139.13Z"
                fill="#3ba525"
              />
              <path
                d="M307.56,139.1a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.14,2.14,0,0,1,1.23.44,1.81,1.81,0,0,1,.45.5A1,1,0,0,1,307.56,139.1Z"
                fill="#2f6840"
              />
              <path
                d="M310.89,138.34c-.25,0-.47,0-.7.1a3.63,3.63,0,0,0-.65.16,11,11,0,0,0-1.28.51,2.31,2.31,0,0,1,1.18-.83A2,2,0,0,1,310.89,138.34Z"
                fill="#2f6840"
              />
              <path
                d="M309.58,141.41a1.9,1.9,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.51,1.51,0,0,1,.38.55A.91.91,0,0,1,309.58,141.41Z"
                fill="#2f6840"
              />
              <path
                d="M307.71,139.54c-.24.06-.46.09-.67.15a4,4,0,0,0-.61.22,8.57,8.57,0,0,0-1.2.62,2.14,2.14,0,0,1,1.06-.93A1.94,1.94,0,0,1,307.71,139.54Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M299.36,136.24c4.22-.24-4.14.44-4.16-.58s4.15-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A14.07,14.07,0,0,1,299.36,136.24Z"
                fill="#2f6840"
              />
              <path
                d="M298.87,135.91c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A14,14,0,0,1,298.87,135.91Z"
                fill="#3ba525"
              />
              <path
                d="M299.59,135.88a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.15,2.15,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.92.92,0,0,1,299.59,135.88Z"
                fill="#2f6840"
              />
              <path
                d="M302.91,135.12c-.24,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,302.91,135.12Z"
                fill="#2f6840"
              />
              <path
                d="M301.61,138.19a1.86,1.86,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.56,1.56,0,0,1,.38.54A.94.94,0,0,1,301.61,138.19Z"
                fill="#2f6840"
              />
              <path
                d="M299.74,136.32c-.24.06-.46.09-.67.15a3.52,3.52,0,0,0-.62.22,9.06,9.06,0,0,0-1.19.62,2.14,2.14,0,0,1,1.06-.93A1.94,1.94,0,0,1,299.74,136.32Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M313.41,151c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.88,3.18-2.87,2.43-2.16-2.17-2-2.26A13.76,13.76,0,0,1,313.41,151Z"
                fill="#2f6840"
              />
              <path
                d="M312.92,150.71c4.23-.24-4.13.44-4.16-.58s4.16-2.52,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.76.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A14,14,0,0,1,312.92,150.71Z"
                fill="#3ba525"
              />
              <path
                d="M313.64,150.68a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.17,2.17,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,313.64,150.68Z"
                fill="#2f6840"
              />
              <path
                d="M317,149.92c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,317,149.92Z"
                fill="#2f6840"
              />
              <path
                d="M315.66,153a1.86,1.86,0,0,0-.63-1c-.27-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,315.66,153Z"
                fill="#2f6840"
              />
              <path
                d="M313.79,151.12c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,9.06,9.06,0,0,0-1.19.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,313.79,151.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M300.55,145.72c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.15,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.85,13.85,0,0,1,300.55,145.72Z"
                fill="#2f6840"
              />
              <path
                d="M300.07,145.39c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.86,2.43-2.16-2.17-2-2.26A13.76,13.76,0,0,1,300.07,145.39Z"
                fill="#3ba525"
              />
              <path
                d="M300.78,145.36a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.9.9,0,0,1,300.78,145.36Z"
                fill="#2f6840"
              />
              <path
                d="M304.11,144.6c-.25,0-.47,0-.7.09a4.64,4.64,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2.07,2.07,0,0,1,304.11,144.6Z"
                fill="#2f6840"
              />
              <path
                d="M302.8,147.67a1.82,1.82,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.74,1.74,0,0,1,.39.54A.94.94,0,0,1,302.8,147.67Z"
                fill="#2f6840"
              />
              <path
                d="M300.93,145.8c-.24.06-.46.08-.67.15a3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,300.93,145.8Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M291.27,149c4.23-.24-4.13.44-4.15-.58s4.15-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A13.75,13.75,0,0,1,291.27,149Z"
                fill="#2f6840"
              />
              <path
                d="M290.79,148.71c4.23-.24-4.13.44-4.16-.58s4.16-2.52,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A14,14,0,0,1,290.79,148.71Z"
                fill="#3ba525"
              />
              <path
                d="M291.51,148.68a2.08,2.08,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.91.91,0,0,1,291.51,148.68Z"
                fill="#2f6840"
              />
              <path
                d="M294.83,147.92c-.24,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,294.83,147.92Z"
                fill="#2f6840"
              />
              <path
                d="M293.53,151a1.86,1.86,0,0,0-.63-1c-.28-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,293.53,151Z"
                fill="#2f6840"
              />
              <path
                d="M291.66,149.12c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,291.66,149.12Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M288.73,157.38c4.23-.24-4.13.43-4.15-.58s4.15-2.52,5-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A13.66,13.66,0,0,1,288.73,157.38Z"
                fill="#2f6840"
              />
              <path
                d="M288.25,157.05c4.23-.24-4.14.44-4.16-.58s4.16-2.52,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A14,14,0,0,1,288.25,157.05Z"
                fill="#3ba525"
              />
              <path
                d="M289,157a2.08,2.08,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A1,1,0,0,1,289,157Z"
                fill="#2f6840"
              />
              <path
                d="M292.29,156.26c-.24,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,292.29,156.26Z"
                fill="#2f6840"
              />
              <path
                d="M291,159.33a1.92,1.92,0,0,0-.63-1c-.28-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,291,159.33Z"
                fill="#2f6840"
              />
              <path
                d="M289.11,157.46c-.23.06-.45.08-.66.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,289.11,157.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M283.62,152.64c4.23-.24-4.14.44-4.16-.58s4.16-2.51,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.47-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.43-2.16-2.17-2-2.26A14.29,14.29,0,0,1,283.62,152.64Z"
                fill="#2f6840"
              />
              <path
                d="M283.14,152.31c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49.05-4.49.05,5.75.82,3.8,1.47-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.27A14.39,14.39,0,0,1,283.14,152.31Z"
                fill="#3ba525"
              />
              <path
                d="M283.86,152.28a2,2,0,0,0-.77-.89c-.3-.25-.67-.44-1-.7a2.21,2.21,0,0,1,1.23.43,1.67,1.67,0,0,1,.45.5A1,1,0,0,1,283.86,152.28Z"
                fill="#2f6840"
              />
              <path
                d="M287.18,151.53a6.81,6.81,0,0,0-.69.09,3,3,0,0,0-.65.17,10.36,10.36,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,287.18,151.53Z"
                fill="#2f6840"
              />
              <path
                d="M285.87,154.59a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.49-.92-.78a2,2,0,0,1,1.15.52,1.67,1.67,0,0,1,.39.55A.86.86,0,0,1,285.87,154.59Z"
                fill="#2f6840"
              />
              <path
                d="M284,152.72c-.23.06-.45.09-.67.16a3.14,3.14,0,0,0-.61.21,10.56,10.56,0,0,0-1.2.62,2.17,2.17,0,0,1,1.07-.93A1.91,1.91,0,0,1,284,152.72Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M275.65,149.42c4.23-.24-4.14.44-4.16-.58s4.16-2.51,5.05-2.35.25,2.15.25,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.15,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.43-2.16-2.17-2-2.26A14.49,14.49,0,0,1,275.65,149.42Z"
                fill="#2f6840"
              />
              <path
                d="M275.17,149.09c4.22-.24-4.14.44-4.16-.58s4.15-2.51,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.43-2.16-2.17-2-2.26A14.39,14.39,0,0,1,275.17,149.09Z"
                fill="#3ba525"
              />
              <path
                d="M275.89,149.06a2.1,2.1,0,0,0-.77-.89c-.31-.26-.67-.44-1-.71a2.14,2.14,0,0,1,1.23.44,1.67,1.67,0,0,1,.45.5A1,1,0,0,1,275.89,149.06Z"
                fill="#2f6840"
              />
              <path
                d="M279.21,148.3c-.25,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,10.45,10.45,0,0,0-1.29.51,2.31,2.31,0,0,1,1.18-.83A2,2,0,0,1,279.21,148.3Z"
                fill="#2f6840"
              />
              <path
                d="M277.9,151.37a1.9,1.9,0,0,0-.63-1c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.67,1.67,0,0,1,.39.55A.91.91,0,0,1,277.9,151.37Z"
                fill="#2f6840"
              />
              <path
                d="M276,149.5c-.24.06-.45.09-.67.15a4,4,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.12,2.12,0,0,1,1.07-.93A1.91,1.91,0,0,1,276,149.5Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M289.7,164.22c4.23-.24-4.14.44-4.16-.58s4.16-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.15,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A14.16,14.16,0,0,1,289.7,164.22Z"
                fill="#2f6840"
              />
              <path
                d="M289.22,163.89c4.22-.24-4.14.44-4.16-.58s4.15-2.51,5-2.35.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.86,2.43-2.16-2.17-2-2.26A14.39,14.39,0,0,1,289.22,163.89Z"
                fill="#3ba525"
              />
              <path
                d="M289.93,163.86a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.91.91,0,0,1,289.93,163.86Z"
                fill="#2f6840"
              />
              <path
                d="M293.26,163.1c-.25,0-.47.05-.7.1a3.53,3.53,0,0,0-.64.16,10.45,10.45,0,0,0-1.29.51,2.25,2.25,0,0,1,1.18-.83A2,2,0,0,1,293.26,163.1Z"
                fill="#2f6840"
              />
              <path
                d="M292,166.17a1.86,1.86,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.67,1.67,0,0,1,.39.55A.91.91,0,0,1,292,166.17Z"
                fill="#2f6840"
              />
              <path
                d="M290.08,164.3c-.24.06-.46.09-.67.15a3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.14,2.14,0,0,1,1.06-.93A1.94,1.94,0,0,1,290.08,164.3Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M276.84,158.9c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A13.66,13.66,0,0,1,276.84,158.9Z"
                fill="#2f6840"
              />
              <path
                d="M276.36,158.57c4.23-.24-4.14.44-4.16-.58s4.16-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.15,1.9-4.16,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A14.16,14.16,0,0,1,276.36,158.57Z"
                fill="#3ba525"
              />
              <path
                d="M277.08,158.54a2,2,0,0,0-.77-.89c-.3-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,277.08,158.54Z"
                fill="#2f6840"
              />
              <path
                d="M280.4,157.78c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13.1,13.1,0,0,0-1.29.5,2.32,2.32,0,0,1,1.19-.82A2,2,0,0,1,280.4,157.78Z"
                fill="#2f6840"
              />
              <path
                d="M279.09,160.85a1.86,1.86,0,0,0-.63-.95c-.27-.27-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.74,1.74,0,0,1,.39.54A.89.89,0,0,1,279.09,160.85Z"
                fill="#2f6840"
              />
              <path
                d="M277.22,159c-.23.06-.45.08-.66.15a3,3,0,0,0-.62.22,9.15,9.15,0,0,0-1.2.62,2.19,2.19,0,0,1,1.07-.94A2,2,0,0,1,277.22,159Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M267,160.9c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,267,160.9Z"
                fill="#2f6840"
              />
              <path
                d="M266.55,160.57c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,266.55,160.57Z"
                fill="#3ba525"
              />
              <path
                d="M267.27,160.55a2,2,0,0,0-.76-.9c-.31-.25-.68-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,267.27,160.55Z"
                fill="#2f6840"
              />
              <path
                d="M270.59,159.79c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.33,2.33,0,0,1,1.18-.83A2,2,0,0,1,270.59,159.79Z"
                fill="#2f6840"
              />
              <path
                d="M269.28,162.85a1.77,1.77,0,0,0-.63-.94c-.27-.28-.6-.48-.92-.77a2.08,2.08,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.86.86,0,0,1,269.28,162.85Z"
                fill="#2f6840"
              />
              <path
                d="M267.41,161a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61A2.1,2.1,0,0,1,266,161,1.91,1.91,0,0,1,267.41,161Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M264.49,169.24c4.23-.24-4.13.44-4.16-.58s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.76.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,264.49,169.24Z"
                fill="#2f6840"
              />
              <path
                d="M264,168.91c4.23-.23-4.14.44-4.16-.58s4.16-2.51,5-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A14,14,0,0,1,264,168.91Z"
                fill="#3ba525"
              />
              <path
                d="M264.73,168.89a2,2,0,0,0-.76-.9c-.31-.25-.68-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.71,1.71,0,0,1,.45.51A1,1,0,0,1,264.73,168.89Z"
                fill="#2f6840"
              />
              <path
                d="M268.05,168.13c-.24,0-.47,0-.69.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.33,2.33,0,0,1,1.18-.83A2,2,0,0,1,268.05,168.13Z"
                fill="#2f6840"
              />
              <path
                d="M266.74,171.19a1.77,1.77,0,0,0-.63-.94c-.27-.28-.6-.48-.92-.78a2.17,2.17,0,0,1,1.16.53,1.75,1.75,0,0,1,.38.54A.86.86,0,0,1,266.74,171.19Z"
                fill="#2f6840"
              />
              <path
                d="M264.87,169.33a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.38,8.38,0,0,0-1.19.61,2.1,2.1,0,0,1,1.06-.93A1.91,1.91,0,0,1,264.87,169.33Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M259.38,164.51c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.85,13.85,0,0,1,259.38,164.51Z"
                fill="#2f6840"
              />
              <path
                d="M258.9,164.18c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64S259.4,165,259.4,165s-.87,3.19-2.86,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,258.9,164.18Z"
                fill="#3ba525"
              />
              <path
                d="M259.61,164.15a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.9.9,0,0,1,259.61,164.15Z"
                fill="#2f6840"
              />
              <path
                d="M262.94,163.39c-.25,0-.47,0-.7.09a4.29,4.29,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,262.94,163.39Z"
                fill="#2f6840"
              />
              <path
                d="M261.63,166.46a1.82,1.82,0,0,0-.63-1c-.27-.27-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,261.63,166.46Z"
                fill="#2f6840"
              />
              <path
                d="M259.76,164.59a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,9.15,9.15,0,0,0-1.2.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,259.76,164.59Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M251.41,161.29c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.85,13.85,0,0,1,251.41,161.29Z"
                fill="#2f6840"
              />
              <path
                d="M250.92,161c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.75,13.75,0,0,1,250.92,161Z"
                fill="#3ba525"
              />
              <path
                d="M251.64,160.93a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A.9.9,0,0,1,251.64,160.93Z"
                fill="#2f6840"
              />
              <path
                d="M255,160.17c-.25,0-.47,0-.7.09a4.29,4.29,0,0,0-.64.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,255,160.17Z"
                fill="#2f6840"
              />
              <path
                d="M253.66,163.24a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.89.89,0,0,1,253.66,163.24Z"
                fill="#2f6840"
              />
              <path
                d="M251.79,161.37a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,9.69,9.69,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,251.79,161.37Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M265.46,176.08c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,265.46,176.08Z"
                fill="#2f6840"
              />
              <path
                d="M265,175.75c4.23-.23-4.13.44-4.15-.58s4.15-2.51,5-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.18-2-2.26A13.84,13.84,0,0,1,265,175.75Z"
                fill="#3ba525"
              />
              <path
                d="M265.69,175.73a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A1,1,0,0,1,265.69,175.73Z"
                fill="#2f6840"
              />
              <path
                d="M269,175c-.25,0-.47,0-.7.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,269,175Z"
                fill="#2f6840"
              />
              <path
                d="M267.71,178a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.91.91,0,0,1,267.71,178Z"
                fill="#2f6840"
              />
              <path
                d="M265.84,176.17a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,8.48,8.48,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,265.84,176.17Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M252.6,170.76c4.23-.24-4.14.44-4.16-.58s4.16-2.51,5.05-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.47-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.84,13.84,0,0,1,252.6,170.76Z"
                fill="#2f6840"
              />
              <path
                d="M252.12,170.43c4.23-.24-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.07,3.46,3.4,2.53,3.3-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,252.12,170.43Z"
                fill="#3ba525"
              />
              <path
                d="M252.84,170.41a2,2,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.71,1.71,0,0,1,.45.51A1,1,0,0,1,252.84,170.41Z"
                fill="#2f6840"
              />
              <path
                d="M256.16,169.65a6.81,6.81,0,0,0-.69.09,3.66,3.66,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.35,2.35,0,0,1,1.19-.83A2,2,0,0,1,256.16,169.65Z"
                fill="#2f6840"
              />
              <path
                d="M254.85,172.71a1.83,1.83,0,0,0-.63-.94c-.27-.28-.61-.48-.92-.78a2.11,2.11,0,0,1,1.15.53,1.53,1.53,0,0,1,.39.54A.86.86,0,0,1,254.85,172.71Z"
                fill="#2f6840"
              />
              <path
                d="M253,170.85c-.23.05-.45.08-.67.15a3.14,3.14,0,0,0-.61.21,10.56,10.56,0,0,0-1.2.62,2.17,2.17,0,0,1,1.07-.93A1.86,1.86,0,0,1,253,170.85Z"
                fill="#2f6840"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M240.23,161.2c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.81,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.66,13.66,0,0,1,240.23,161.2Z"
                fill="#2f6840"
              />
              <path
                d="M239.75,160.87c4.23-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.8,1.48-3.16,1.9-4.16,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,239.75,160.87Z"
                fill="#3ba525"
              />
              <path
                d="M240.47,160.84a2.06,2.06,0,0,0-.77-.9c-.3-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A1,1,0,0,1,240.47,160.84Z"
                fill="#2f6840"
              />
              <path
                d="M243.79,160.08a6.81,6.81,0,0,0-.69.09,4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,243.79,160.08Z"
                fill="#2f6840"
              />
              <path
                d="M242.48,163.15a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.92-.77a2,2,0,0,1,1.15.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,242.48,163.15Z"
                fill="#2f6840"
              />
              <path
                d="M240.61,161.28c-.23.05-.45.08-.67.15a3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.22,2.22,0,0,1,1.07-.93A1.91,1.91,0,0,1,240.61,161.28Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M237.69,169.54c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.18-2.66,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.15,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.85,13.85,0,0,1,237.69,169.54Z"
                fill="#2f6840"
              />
              <path
                d="M237.21,169.21c4.22-.24-4.14.43-4.16-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.54,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.64-1.11-2.78-1.11-2.78-.88,3.19-2.87,2.44-2.16-2.17-2-2.26A13.76,13.76,0,0,1,237.21,169.21Z"
                fill="#3ba525"
              />
              <path
                d="M237.92,169.18a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,1.84,1.84,0,0,1,.45.51A.9.9,0,0,1,237.92,169.18Z"
                fill="#2f6840"
              />
              <path
                d="M241.25,168.42a6.81,6.81,0,0,0-.69.09,4.77,4.77,0,0,0-.65.17,12.2,12.2,0,0,0-1.29.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,241.25,168.42Z"
                fill="#2f6840"
              />
              <path
                d="M239.94,171.49a1.82,1.82,0,0,0-.63-1c-.27-.28-.61-.48-.93-.77a2,2,0,0,1,1.16.52,1.63,1.63,0,0,1,.39.54A.94.94,0,0,1,239.94,171.49Z"
                fill="#2f6840"
              />
              <path
                d="M238.07,169.62a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,10.44,10.44,0,0,0-1.2.61,2.17,2.17,0,0,1,1.07-.93A1.91,1.91,0,0,1,238.07,169.62Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M232.58,164.8c4.22-.24-4.14.43-4.16-.58s4.15-2.52,5-2.35.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.86,2.43-2.16-2.17-2-2.26A13.76,13.76,0,0,1,232.58,164.8Z"
                fill="#2f6840"
              />
              <path
                d="M232.09,164.47c4.23-.24-4.13.44-4.16-.58s4.16-2.52,5-2.35.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.15-2.17-2-2.26A14,14,0,0,1,232.09,164.47Z"
                fill="#3ba525"
              />
              <path
                d="M232.81,164.44a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.17,2.17,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,232.81,164.44Z"
                fill="#2f6840"
              />
              <path
                d="M236.13,163.68c-.24,0-.47,0-.69.1a3.63,3.63,0,0,0-.65.16,13,13,0,0,0-1.28.5,2.29,2.29,0,0,1,1.18-.82A2,2,0,0,1,236.13,163.68Z"
                fill="#2f6840"
              />
              <path
                d="M234.83,166.75a1.86,1.86,0,0,0-.63-.95c-.27-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,234.83,166.75Z"
                fill="#2f6840"
              />
              <path
                d="M233,164.88c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.21,2.21,0,0,1,1.06-.94A2,2,0,0,1,233,164.88Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M224.6,161.58c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.65,2.79-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.83,3.8,1.48-3.16,1.9-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.75,13.75,0,0,1,224.6,161.58Z"
                fill="#2f6840"
              />
              <path
                d="M224.12,161.25c4.23-.24-4.13.43-4.16-.59s4.16-2.51,5-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.77-1.11-2.77-.87,3.18-2.87,2.43-2.16-2.17-2-2.26A13.66,13.66,0,0,1,224.12,161.25Z"
                fill="#3ba525"
              />
              <path
                d="M224.84,161.22a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A.9.9,0,0,1,224.84,161.22Z"
                fill="#2f6840"
              />
              <path
                d="M228.16,160.46c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,228.16,160.46Z"
                fill="#2f6840"
              />
              <path
                d="M226.86,163.53a1.82,1.82,0,0,0-.63-.95c-.28-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.71,1.71,0,0,1,.38.54A.94.94,0,0,1,226.86,163.53Z"
                fill="#2f6840"
              />
              <path
                d="M225,161.66c-.24.06-.46.08-.67.15a3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,225,161.66Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M238.65,176.38c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.15-2.17-2-2.26A13.66,13.66,0,0,1,238.65,176.38Z"
                fill="#2f6840"
              />
              <path
                d="M238.17,176.05c4.23-.24-4.14.43-4.16-.59s4.16-2.51,5.05-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.49,0-4.49,0,5.75.83,3.81,1.48-3.16,1.9-4.17,1.64-1.11-2.78-1.11-2.78-.87,3.19-2.87,2.44-2.16-2.17-2-2.26A13.66,13.66,0,0,1,238.17,176.05Z"
                fill="#3ba525"
              />
              <path
                d="M238.89,176a2,2,0,0,0-.76-.89c-.31-.26-.67-.44-1-.71a2.2,2.2,0,0,1,1.22.43,1.69,1.69,0,0,1,.45.51A1,1,0,0,1,238.89,176Z"
                fill="#2f6840"
              />
              <path
                d="M242.21,175.26c-.24,0-.47,0-.69.09a4.77,4.77,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,242.21,175.26Z"
                fill="#2f6840"
              />
              <path
                d="M240.91,178.33a1.88,1.88,0,0,0-.63-1c-.28-.27-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.6,1.6,0,0,1,.38.54A.94.94,0,0,1,240.91,178.33Z"
                fill="#2f6840"
              />
              <path
                d="M239,176.46a6.38,6.38,0,0,0-.66.15,3.52,3.52,0,0,0-.62.22,8.47,8.47,0,0,0-1.19.62,2.16,2.16,0,0,1,1.06-.94A2,2,0,0,1,239,176.46Z"
                fill="#2f6840"
              />
            </g>
            <g>
              <path
                d="M225.8,171.05c4.23-.23-4.14.44-4.16-.58s4.15-2.51,5-2.34.26,2.15.26,2.15,1.18-2.66,2.8-2.06,3.46,3.39,2.53,3.29-4.49,0-4.49,0,5.75.82,3.8,1.48-3.16,1.89-4.16,1.63-1.11-2.77-1.11-2.77-.87,3.19-2.87,2.44-2.16-2.18-2-2.26A13.94,13.94,0,0,1,225.8,171.05Z"
                fill="#2f6840"
              />
              <path
                d="M225.31,170.73c4.23-.24-4.13.43-4.15-.59s4.15-2.51,5-2.34.25,2.15.25,2.15,1.19-2.65,2.8-2.06,3.46,3.4,2.53,3.29-4.48,0-4.48,0,5.75.82,3.8,1.48-3.16,1.89-4.17,1.63-1.11-2.77-1.11-2.77S225,174.75,223,174s-2.15-2.18-2-2.26A13.66,13.66,0,0,1,225.31,170.73Z"
                fill="#3ba525"
              />
              <path
                d="M226,170.7a2,2,0,0,0-.76-.9c-.31-.25-.67-.43-1-.7a2.21,2.21,0,0,1,1.23.43,2,2,0,0,1,.45.51A1,1,0,0,1,226,170.7Z"
                fill="#2f6840"
              />
              <path
                d="M229.36,169.94c-.25,0-.47,0-.7.09a3.66,3.66,0,0,0-.65.17,13,13,0,0,0-1.28.5,2.37,2.37,0,0,1,1.18-.83A2,2,0,0,1,229.36,169.94Z"
                fill="#2f6840"
              />
              <path
                d="M228.05,173a1.82,1.82,0,0,0-.63-.95c-.27-.28-.61-.48-.93-.77a2.05,2.05,0,0,1,1.16.52,1.47,1.47,0,0,1,.38.54A.94.94,0,0,1,228.05,173Z"
                fill="#2f6840"
              />
              <path
                d="M226.18,171.14a6,6,0,0,0-.67.15,3.16,3.16,0,0,0-.61.22,8.48,8.48,0,0,0-1.2.61,2.19,2.19,0,0,1,1.06-.93A1.94,1.94,0,0,1,226.18,171.14Z"
                fill="#2f6840"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M254.8,164.16s.54,3.24,1.74,4.16,3.35-.51,2.85,1.09,2.07,3.24,3.27,3.16,4.21-3.25,4.35-4.52S254.8,164.16,254.8,164.16Z"
            fill="#131b8c"
            opacity="0.63"
          />
          <g>
            <path
              d="M255.06,161.73l-.26,2.43,1.86,3.19,2.83.81.45,2s1.75,2.13,3.25.93a14.39,14.39,0,0,0,2.83-3.71l.26-2.42Z"
              fill="#ccae79"
            />
            <path
              d="M257.52,160.81l-2.46.92,2,3.23,2.7.78.68,2.11s2.5,2,3,.85a21.57,21.57,0,0,1,2.84-3.75l-1.93-2.18Z"
              fill="#ffedc8"
            />
            <polygon
              points="257.08 164.96 256.66 167.35 259.49 168.16 259.78 165.74 257.08 164.96"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M262.7,169.06s.19,2.36-.25,2.37a8.28,8.28,0,0,0,3.57-4.06l.26-2.42S263.32,169.25,262.7,169.06Z"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M260.92,168.19l.51.34s-.31-.25-.36.79A4.09,4.09,0,0,0,260.92,168.19Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M262.1,168.91c-.06,0,.1.05.68-.62a5.19,5.19,0,0,0,.86-1.44s-1.41,1.77-1.16,2.17Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M256.24,163.62s-.07,1-.19,1.76c0,0,.1-1.34.35-1.49Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M260.77,161.75l1.08.3c.08,0-.84-.24-1.16.48l.09-.78"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M256.3,161.27l.61-.23s-.36.23-.24.34.58.6.8.5.54.19.54.19Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M368.78,124.66l2,1.84a.49.49,0,0,0,.62.06l4.84-3.18a1.21,1.21,0,0,0,.17-1.6h0a.55.55,0,0,0-.52-.23L369,122.89C368.43,123,368.26,124.19,368.78,124.66Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="372.37 117.31 369.63 118.16 367.23 120.87 371.26 123.25 376.2 120.28 372.37 117.31"
              fill="#ffedc8"
            />
            <polygon
              points="367.23 120.87 367.23 123.25 371.1 125.68 376.31 122.58 376.2 120.28 371.26 123.25 367.23 120.87"
              fill="#ccae79"
            />
            <polygon
              points="371.26 123.25 371.1 125.68 376.31 122.58 376.2 120.28 371.26 123.25"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M368.38,121.55a1.52,1.52,0,0,1,0,1.22c.18-.38.22-1.09.31-1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M370.08,122.55a3,3,0,0,0,1-1.52l-.73,1.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M373.3,122a1.15,1.15,0,0,1,.4,1l-.12-1.13Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M375.11,119.43c-.05,0-1,.29-1.61,0a1.6,1.6,0,0,1-1.17.12s.86-.12,1.17.31A5.12,5.12,0,0,1,375.11,119.43Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M373.05,146.49l2,2a.45.45,0,0,0,.62.07l4.85-3.54a1.49,1.49,0,0,0,.16-1.79h0a.5.5,0,0,0-.52-.26l-6.86,1.5C372.69,144.65,372.52,146,373.05,146.49Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="376.63 138.29 373.9 139.24 371.49 142.27 375.52 144.91 380.46 141.6 376.63 138.29"
              fill="#ffedc8"
            />
            <polygon
              points="371.49 142.27 371.49 144.91 375.36 147.63 380.57 144.17 380.46 141.6 375.52 144.91 371.49 142.27"
              fill="#ccae79"
            />
            <polygon
              points="375.52 144.91 375.36 147.63 380.57 144.17 380.46 141.6 375.52 144.91"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M372.64,143a1.82,1.82,0,0,1,0,1.36c.18-.43.23-1.21.31-1.16Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M374.34,144.14a3.29,3.29,0,0,0,1-1.69l-.73,1.88Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M377.56,143.54a1.39,1.39,0,0,1,.41,1.07l-.12-1.25Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M379.37,140.66c-.05,0-1,.32-1.6,0a1.46,1.46,0,0,1-1.17.13s.85-.14,1.17.34A4.65,4.65,0,0,1,379.37,140.66Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M327.93,144.86l4.23,2.85a1.28,1.28,0,0,0,1.28.1l10.15-4.93a1.56,1.56,0,0,0,.34-2.49h0a1.36,1.36,0,0,0-1.08-.35l-14.38,2.08A1.52,1.52,0,0,0,327.93,144.86Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="335.43 133.47 329.71 134.79 324.67 138.99 333.12 142.67 343.46 138.07 335.43 133.47"
              fill="#ffedc8"
            />
            <polygon
              points="324.67 138.99 324.67 142.67 332.78 146.44 343.69 141.63 343.46 138.07 333.12 142.67 324.67 138.99"
              fill="#ccae79"
            />
            <polygon
              points="333.12 142.67 332.78 146.44 343.69 141.63 343.46 138.07 333.12 142.67"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M327.08,140a1.78,1.78,0,0,1,0,1.89c.38-.59.47-1.68.65-1.61Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M330.64,141.59a4.94,4.94,0,0,0,2.14-2.35l-1.54,2.61Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M337.39,140.77a1.71,1.71,0,0,1,.84,1.48l-.25-1.74Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M341.17,136.76c-.11-.06-2.14.44-3.36,0a4.51,4.51,0,0,1-2.45.18s1.8-.19,2.45.48A13.56,13.56,0,0,1,341.17,136.76Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M352.56,138l2.94,3a.63.63,0,0,0,.89.1l7.05-5.15a2.14,2.14,0,0,0,.24-2.61h0a.74.74,0,0,0-.75-.36l-10,2.17C352.05,135.33,351.8,137.24,352.56,138Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="357.78 126.08 353.8 127.46 350.3 131.87 356.17 135.71 363.35 130.9 357.78 126.08"
              fill="#ffedc8"
            />
            <polygon
              points="350.3 131.87 350.3 135.71 355.93 139.66 363.51 134.63 363.35 130.9 356.17 135.71 350.3 131.87"
              fill="#ccae79"
            />
            <polygon
              points="356.17 135.71 355.93 139.66 363.51 134.63 363.35 130.9 356.17 135.71"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M352,133a2.65,2.65,0,0,1,0,2c.27-.62.33-1.76.45-1.68Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M354.45,134.59a4.77,4.77,0,0,0,1.48-2.46l-1.06,2.73Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M359.13,133.73a2,2,0,0,1,.59,1.55l-.18-1.83Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M361.76,129.52c-.07-.06-1.48.47-2.33,0a2.13,2.13,0,0,1-1.7.2s1.25-.2,1.7.5A6.61,6.61,0,0,1,361.76,129.52Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M235.25,173.42l2,2.05a.45.45,0,0,0,.62.07l4.85-3.54a1.5,1.5,0,0,0,.16-1.8h0a.51.51,0,0,0-.52-.25l-6.86,1.5C234.9,171.58,234.72,172.89,235.25,173.42Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="238.83 165.22 236.1 166.17 233.69 169.19 237.72 171.84 242.66 168.53 238.83 165.22"
              fill="#ffedc8"
            />
            <polygon
              points="233.69 169.19 233.69 171.84 237.56 174.55 242.77 171.09 242.66 168.53 237.72 171.84 233.69 169.19"
              fill="#ccae79"
            />
            <polygon
              points="237.72 171.84 237.56 174.55 242.77 171.09 242.66 168.53 237.72 171.84"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M234.84,170a1.82,1.82,0,0,1,0,1.36c.18-.43.23-1.21.31-1.16Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M236.54,171.07a3.29,3.29,0,0,0,1-1.7l-.73,1.88Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M239.76,170.47a1.39,1.39,0,0,1,.41,1.07l-.12-1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M241.57,167.59c0-.05-1,.32-1.6,0a1.46,1.46,0,0,1-1.17.13s.85-.14,1.17.34A4.65,4.65,0,0,1,241.57,167.59Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M244.92,167.33l2,2a.44.44,0,0,0,.61.07l4.85-3.55a1.46,1.46,0,0,0,.16-1.79h0a.5.5,0,0,0-.51-.25l-6.87,1.49C244.57,165.49,244.4,166.8,244.92,167.33Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="248.5 159.13 245.77 160.08 243.36 163.1 247.4 165.75 252.34 162.44 248.5 159.13"
              fill="#ffedc8"
            />
            <polygon
              points="243.36 163.1 243.36 165.75 247.24 168.46 252.45 165 252.34 162.44 247.4 165.75 243.36 163.1"
              fill="#ccae79"
            />
            <polygon
              points="247.4 165.75 247.24 168.46 252.45 165 252.34 162.44 247.4 165.75"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M244.52,163.86a1.87,1.87,0,0,1,0,1.36c.18-.43.22-1.22.3-1.16Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M246.22,165a3.29,3.29,0,0,0,1-1.69l-.74,1.88Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M249.44,164.38a1.34,1.34,0,0,1,.4,1.07l-.12-1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M251.24,161.49c-.05,0-1,.32-1.6,0a1.44,1.44,0,0,1-1.17.14s.86-.14,1.17.34A4.51,4.51,0,0,1,251.24,161.49Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M248.09,176.09l2,2a.44.44,0,0,0,.61.07l4.85-3.55a1.47,1.47,0,0,0,.16-1.79h0a.51.51,0,0,0-.52-.25l-6.86,1.49C247.74,174.25,247.57,175.56,248.09,176.09Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="251.67 167.89 248.94 168.84 246.53 171.86 250.57 174.51 255.51 171.2 251.67 167.89"
              fill="#ffedc8"
            />
            <polygon
              points="246.53 171.86 246.53 174.51 250.4 177.22 255.61 173.76 255.51 171.2 250.57 174.51 246.53 171.86"
              fill="#ccae79"
            />
            <polygon
              points="250.57 174.51 250.4 177.22 255.61 173.76 255.51 171.2 250.57 174.51"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M247.68,172.62a1.82,1.82,0,0,1,0,1.36c.19-.43.23-1.22.31-1.16Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M249.39,173.73a3.32,3.32,0,0,0,1-1.69l-.73,1.88Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M252.61,173.14a1.38,1.38,0,0,1,.4,1.07l-.12-1.26Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M254.41,170.25s-1,.32-1.6,0a1.44,1.44,0,0,1-1.17.14s.86-.14,1.17.34A4.51,4.51,0,0,1,254.41,170.25Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M281.15,162.46l2.25,2.29a.5.5,0,0,0,.69.07l5.39-3.94a1.64,1.64,0,0,0,.18-2h0a.55.55,0,0,0-.57-.28l-7.65,1.66C280.76,160.41,280.57,161.87,281.15,162.46Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="285.14 153.33 282.1 154.39 279.42 157.76 283.91 160.7 289.42 157.02 285.14 153.33"
              fill="#ffedc8"
            />
            <polygon
              points="279.42 157.76 279.42 160.7 283.73 163.72 289.53 159.87 289.42 157.02 283.91 160.7 279.42 157.76"
              fill="#ccae79"
            />
            <polygon
              points="283.91 160.7 283.73 163.72 289.53 159.87 289.42 157.02 283.91 160.7"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M280.7,158.6a2,2,0,0,1,0,1.51c.21-.47.25-1.35.35-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M282.6,159.84a3.66,3.66,0,0,0,1.13-1.88l-.81,2.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M286.19,159.18a1.51,1.51,0,0,1,.44,1.19l-.13-1.4Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M288.2,156c-.06-.05-1.14.36-1.79,0a1.58,1.58,0,0,1-1.3.15s.95-.15,1.3.38A5.26,5.26,0,0,1,288.2,156Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M312.54,137.67l2.25,2.29a.49.49,0,0,0,.68.07l5.4-3.94a1.64,1.64,0,0,0,.18-2h0a.56.56,0,0,0-.57-.28l-7.65,1.66C312.15,135.62,312,137.08,312.54,137.67Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="316.53 128.54 313.49 129.6 310.81 132.97 315.3 135.91 320.8 132.23 316.53 128.54"
              fill="#ffedc8"
            />
            <polygon
              points="310.81 132.97 310.81 135.91 315.12 138.94 320.92 135.08 320.8 132.23 315.3 135.91 310.81 132.97"
              fill="#ccae79"
            />
            <polygon
              points="315.3 135.91 315.12 138.94 320.92 135.08 320.8 132.23 315.3 135.91"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M312.09,133.81a2,2,0,0,1,0,1.51c.2-.47.25-1.35.34-1.29Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M314,135.05a3.62,3.62,0,0,0,1.14-1.88l-.82,2.09Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M317.57,134.39a1.5,1.5,0,0,1,.45,1.19l-.13-1.4Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M319.58,131.17c-.05,0-1.13.36-1.78,0a1.58,1.58,0,0,1-1.3.15s.95-.15,1.3.38A5.23,5.23,0,0,1,319.58,131.17Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M294.52,146.12l1.12,1.14a.25.25,0,0,0,.34,0l2.68-2a.81.81,0,0,0,.09-1h0a.28.28,0,0,0-.28-.14l-3.81.83C294.32,145.1,294.23,145.83,294.52,146.12Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="296.5 141.58 294.99 142.1 293.65 143.78 295.89 145.25 298.63 143.41 296.5 141.58"
              fill="#ffedc8"
            />
            <polygon
              points="293.65 143.78 293.65 145.25 295.8 146.75 298.69 144.83 298.63 143.41 295.89 145.25 293.65 143.78"
              fill="#ccae79"
            />
            <polygon
              points="295.89 145.25 295.8 146.75 298.69 144.83 298.63 143.41 295.89 145.25"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M294.29,144.2a1,1,0,0,1,0,.75c.1-.24.13-.67.17-.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M295.24,144.82a1.81,1.81,0,0,0,.56-.94l-.41,1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M297,144.49a.74.74,0,0,1,.22.59l-.06-.7Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M298,142.89s-.56.18-.89,0a.78.78,0,0,1-.64.07s.47-.07.64.19A2.59,2.59,0,0,1,298,142.89Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M296.27,138.9l1.12,1.13a.24.24,0,0,0,.34,0l2.69-2a.83.83,0,0,0,.09-1h0a.29.29,0,0,0-.29-.14l-3.8.83C296.08,137.87,296,138.6,296.27,138.9Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="298.26 134.35 296.75 134.88 295.41 136.55 297.65 138.02 300.39 136.19 298.26 134.35"
              fill="#ffedc8"
            />
            <polygon
              points="295.41 136.55 295.41 138.02 297.56 139.53 300.44 137.61 300.39 136.19 297.65 138.02 295.41 136.55"
              fill="#ccae79"
            />
            <polygon
              points="297.65 138.02 297.56 139.53 300.44 137.61 300.39 136.19 297.65 138.02"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M296.05,137a1,1,0,0,1,0,.75c.1-.23.12-.67.17-.64Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M297,137.59a1.85,1.85,0,0,0,.57-.94l-.41,1Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M298.78,137.26a.76.76,0,0,1,.22.59l-.07-.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M535.47,115.59s-.57.18-.89,0a.83.83,0,0,1-.65.08s.47-.08.65.19A2.63,2.63,0,0,1,535.47,115.59Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M285.83,144l1.5,1.52a.34.34,0,0,0,.46.06L291.4,143a1.11,1.11,0,0,0,.12-1.34h0a.39.39,0,0,0-.39-.19L286,142.57C285.57,142.67,285.44,143.64,285.83,144Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="288.5 137.93 286.46 138.64 284.67 140.89 287.67 142.86 291.35 140.4 288.5 137.93"
              fill="#ffedc8"
            />
            <polygon
              points="284.67 140.89 284.67 142.86 287.55 144.88 291.43 142.31 291.35 140.4 287.67 142.86 284.67 140.89"
              fill="#ccae79"
            />
            <polygon
              points="287.67 142.86 287.55 144.88 291.43 142.31 291.35 140.4 287.67 142.86"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M285.53,141.45a1.41,1.41,0,0,1,0,1c.13-.31.16-.9.23-.86Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M286.79,142.28a2.44,2.44,0,0,0,.76-1.26l-.54,1.4Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M289.19,141.84a1,1,0,0,1,.3.8l-.09-.94Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M290.54,139.69s-.76.24-1.2,0a1.06,1.06,0,0,1-.87.1s.64-.1.87.26A3.45,3.45,0,0,1,290.54,139.69Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M384.15,127.41l2.71,2.76a.61.61,0,0,0,.83.09l6.51-4.76a2,2,0,0,0,.22-2.41h0a.71.71,0,0,0-.7-.34l-9.22,2C383.68,124.94,383.45,126.7,384.15,127.41Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="388.96 116.4 385.29 117.67 382.06 121.74 387.48 125.29 394.12 120.84 388.96 116.4"
              fill="#ffedc8"
            />
            <polygon
              points="382.06 121.74 382.06 125.29 387.26 128.94 394.26 124.29 394.12 120.84 387.48 125.29 382.06 121.74"
              fill="#ccae79"
            />
            <polygon
              points="387.48 125.29 387.26 128.94 394.26 124.29 394.12 120.84 387.48 125.29"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M383.61,122.75a2.48,2.48,0,0,1,0,1.83c.24-.58.3-1.63.41-1.56Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M385.89,124.25a4.4,4.4,0,0,0,1.37-2.27l-1,2.52Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M390.22,123.45a1.82,1.82,0,0,1,.54,1.44l-.16-1.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M392.64,119.58c-.06-.06-1.37.43-2.15,0a1.93,1.93,0,0,1-1.57.17s1.15-.18,1.57.47A6,6,0,0,1,392.64,119.58Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M403.83,134.58l2.71,2.76a.6.6,0,0,0,.82.09l6.51-4.76a2,2,0,0,0,.22-2.41h0a.68.68,0,0,0-.69-.34l-9.22,2C403.36,132.11,403.12,133.87,403.83,134.58Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="408.64 123.57 404.97 124.84 401.74 128.91 407.15 132.46 413.79 128.01 408.64 123.57"
              fill="#ffedc8"
            />
            <polygon
              points="401.74 128.91 401.74 132.46 406.94 136.1 413.93 131.46 413.79 128.01 407.15 132.46 401.74 128.91"
              fill="#ccae79"
            />
            <polygon
              points="407.15 132.46 406.94 136.1 413.93 131.46 413.79 128.01 407.15 132.46"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M403.28,129.92a2.46,2.46,0,0,1,0,1.82c.25-.57.3-1.62.42-1.55Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M405.57,131.42a4.4,4.4,0,0,0,1.37-2.27l-1,2.52Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M409.89,130.62a1.82,1.82,0,0,1,.54,1.44l-.16-1.69Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M412.32,126.74c-.07,0-1.37.44-2.15,0a1.91,1.91,0,0,1-1.57.18s1.15-.18,1.57.46A6.26,6.26,0,0,1,412.32,126.74Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
        <g>
          <path
            d="M389.82,140.3l1.85,1.87a.4.4,0,0,0,.56.07l4.44-3.25a1.35,1.35,0,0,0,.15-1.64h0a.45.45,0,0,0-.48-.23l-6.29,1.37C389.49,138.61,389.34,139.81,389.82,140.3Z"
            fill="#111160"
            opacity="0.68"
          />
          <g>
            <polygon
              points="393.1 132.78 390.6 133.65 388.39 136.42 392.09 138.85 396.61 135.82 393.1 132.78"
              fill="#ffedc8"
            />
            <polygon
              points="388.39 136.42 388.39 138.85 391.94 141.33 396.71 138.16 396.61 135.82 392.09 138.85 388.39 136.42"
              fill="#ccae79"
            />
            <polygon
              points="392.09 138.85 391.94 141.33 396.71 138.16 396.61 135.82 392.09 138.85"
              fill="#0416bf"
              opacity="0.14"
            />
            <path
              d="M389.45,137.12a1.67,1.67,0,0,1,0,1.24c.16-.39.2-1.11.28-1.06Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M391,138.14a3.06,3.06,0,0,0,.94-1.55l-.67,1.72Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M394,137.6a1.21,1.21,0,0,1,.36,1l-.11-1.15Z"
              fill="#996537"
              opacity="0.51"
            />
            <path
              d="M395.61,135c-.05,0-.94.29-1.47,0a1.34,1.34,0,0,1-1.07.12s.79-.12,1.07.32A4.17,4.17,0,0,1,395.61,135Z"
              fill="#996537"
              opacity="0.51"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1037.66,34.48l2.7,1.67a.86.86,0,0,0,.82.06l6.49-2.9a.88.88,0,0,0,.22-1.47h0a.86.86,0,0,0-.69-.2L1038,32.86A.88.88,0,0,0,1037.66,34.48Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1042.45 27.76 1038.8 28.54 1035.57 31.02 1040.97 33.18 1047.59 30.47 1042.45 27.76"
            fill="#ffedc8"
          />
          <polygon
            points="1035.57 31.02 1035.57 33.18 1040.76 35.4 1047.73 32.57 1047.59 30.47 1040.97 33.18 1035.57 31.02"
            fill="#ccae79"
          />
          <polygon
            points="1040.97 33.18 1040.76 35.4 1047.73 32.57 1047.59 30.47 1040.97 33.18"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1037.12,31.63a1,1,0,0,1,0,1.12c.24-.35.3-1,.41-.95Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1039.39,32.55a3.08,3.08,0,0,0,1.37-1.39l-1,1.54Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1043.71,32.06a1,1,0,0,1,.53.88l-.16-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1046.12,29.7a6.56,6.56,0,0,1-2.14,0,3.12,3.12,0,0,1-1.57.11s1.15-.11,1.57.28A8.93,8.93,0,0,1,1046.12,29.7Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1055.56,24.33l2.7,1.68a.9.9,0,0,0,.83,0l6.48-2.9a.88.88,0,0,0,.22-1.47h0a.86.86,0,0,0-.69-.2l-9.19,1.22A.88.88,0,0,0,1055.56,24.33Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1060.36 17.62 1056.7 18.39 1053.48 20.87 1058.88 23.03 1065.49 20.32 1060.36 17.62"
            fill="#ffedc8"
          />
          <polygon
            points="1053.48 20.87 1053.48 23.03 1058.66 25.25 1065.63 22.42 1065.49 20.32 1058.88 23.03 1053.48 20.87"
            fill="#ccae79"
          />
          <polygon
            points="1058.88 23.03 1058.66 25.25 1065.63 22.42 1065.49 20.32 1058.88 23.03"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1055,21.49a1,1,0,0,1,0,1.11c.24-.35.3-1,.41-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1057.3,22.4a3.09,3.09,0,0,0,1.36-1.38l-1,1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1061.61,21.91a1,1,0,0,1,.54.88l-.16-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1064,19.55a6.34,6.34,0,0,1-2.15,0,3.13,3.13,0,0,1-1.57.11s1.15-.11,1.57.28A9.54,9.54,0,0,1,1064,19.55Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              d="M889.3,3.42c4.42-.25-4.33.46-4.36-.61S889.29.18,890.22.36s.27,2.25.27,2.25,1.24-2.78,2.93-2.16S897,4,896.07,3.9s-4.7,0-4.7,0,6,.86,4,1.55S892,7.47,891,7.2s-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,889.3,3.42Z"
              fill="#2f6840"
            />
            <path
              d="M888.79,3.08c4.43-.25-4.33.45-4.35-.61S888.79-.16,889.72,0s.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72S889.32,4,889.32,4s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,888.79,3.08Z"
              fill="#3ba525"
            />
            <path
              d="M889.54,3.05a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,889.54,3.05Z"
              fill="#2f6840"
            />
            <path
              d="M893,2.25c-.26,0-.49,0-.72.1a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,893,2.25Z"
              fill="#2f6840"
            />
            <path
              d="M891.65,5.46a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,891.65,5.46Z"
              fill="#2f6840"
            />
            <path
              d="M889.69,3.51c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,889.69,3.51Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M886.64,12.15c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,886.64,12.15Z"
              fill="#2f6840"
            />
            <path
              d="M886.13,11.81c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,886.13,11.81Z"
              fill="#3ba525"
            />
            <path
              d="M886.88,11.78a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,886.88,11.78Z"
              fill="#2f6840"
            />
            <path
              d="M890.36,11c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,890.36,11Z"
              fill="#2f6840"
            />
            <path
              d="M889,14.19a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,889,14.19Z"
              fill="#2f6840"
            />
            <path
              d="M887,12.24c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,887,12.24Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M881.28,7.19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55S884,11.24,883,11s-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,881.28,7.19Z"
              fill="#2f6840"
            />
            <path
              d="M880.78,6.85c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.46S882,6,882,6s1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55S876.05,8,876.23,7.91A14.65,14.65,0,0,1,880.78,6.85Z"
              fill="#3ba525"
            />
            <path
              d="M881.53,6.82a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73A2.26,2.26,0,0,1,881,5.6a1.85,1.85,0,0,1,.47.53A1,1,0,0,1,881.53,6.82Z"
              fill="#2f6840"
            />
            <path
              d="M885,6c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52A2.38,2.38,0,0,1,883.5,6,2.12,2.12,0,0,1,885,6Z"
              fill="#2f6840"
            />
            <path
              d="M883.64,9.23a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,883.64,9.23Z"
              fill="#2f6840"
            />
            <path
              d="M881.68,7.28c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,881.68,7.28Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M872.94,3.82c4.43-.25-4.33.46-4.35-.61S872.94.58,873.87.76s.27,2.25.27,2.25S875.37.23,877.06.85s3.63,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55S868.21,5,868.39,4.88A14.65,14.65,0,0,1,872.94,3.82Z"
              fill="#2f6840"
            />
            <path
              d="M872.44,3.48c4.42-.25-4.33.45-4.36-.61S872.43.24,873.36.41s.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71S873,4.35,873,4.35s-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,872.44,3.48Z"
              fill="#3ba525"
            />
            <path
              d="M873.19,3.45a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,873.19,3.45Z"
              fill="#2f6840"
            />
            <path
              d="M876.67,2.65c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,876.67,2.65Z"
              fill="#2f6840"
            />
            <path
              d="M875.3,5.86a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,875.3,5.86Z"
              fill="#2f6840"
            />
            <path
              d="M873.34,3.91c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,873.34,3.91Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M887.65,19.31c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,887.65,19.31Z"
              fill="#2f6840"
            />
            <path
              d="M887.14,19c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,887.14,19Z"
              fill="#3ba525"
            />
            <path
              d="M887.89,18.94a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,887.89,18.94Z"
              fill="#2f6840"
            />
            <path
              d="M891.37,18.14c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,891.37,18.14Z"
              fill="#2f6840"
            />
            <path
              d="M890,21.35a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,890,21.35Z"
              fill="#2f6840"
            />
            <path
              d="M888,19.4c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,888,19.4Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M874.19,13.74c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,874.19,13.74Z"
              fill="#2f6840"
            />
            <path
              d="M873.68,13.4c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,873.68,13.4Z"
              fill="#3ba525"
            />
            <path
              d="M874.44,13.37a2.17,2.17,0,0,0-.8-.94c-.32-.26-.71-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,874.44,13.37Z"
              fill="#2f6840"
            />
            <path
              d="M877.91,12.57c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,877.91,12.57Z"
              fill="#2f6840"
            />
            <path
              d="M876.55,15.78a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,876.55,15.78Z"
              fill="#2f6840"
            />
            <path
              d="M874.59,13.83c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.43,9.43,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,874.59,13.83Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M917.63,6.36c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S925.37,7,924.4,6.83s-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,917.63,6.36Z"
              fill="#2f6840"
            />
            <path
              d="M917.12,6c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,917.12,6Z"
              fill="#3ba525"
            />
            <path
              d="M917.87,6a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,917.87,6Z"
              fill="#2f6840"
            />
            <path
              d="M921.35,5.19c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.18A11.31,11.31,0,0,0,918.6,6a2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,921.35,5.19Z"
              fill="#2f6840"
            />
            <path
              d="M920,8.4a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,920,8.4Z"
              fill="#2f6840"
            />
            <path
              d="M918,6.45c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2.07,2.07,0,0,1,918,6.45Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M915,15.09c4.42-.25-4.33.46-4.36-.61S915,11.85,915.89,12s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71S915.5,16,915.5,16s-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,915,15.09Z"
              fill="#2f6840"
            />
            <path
              d="M914.46,14.75c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,914.46,14.75Z"
              fill="#3ba525"
            />
            <path
              d="M915.21,14.72a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.25,2.25,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,915.21,14.72Z"
              fill="#2f6840"
            />
            <path
              d="M918.69,13.92c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,918.69,13.92Z"
              fill="#2f6840"
            />
            <path
              d="M917.32,17.13a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,917.32,17.13Z"
              fill="#2f6840"
            />
            <path
              d="M915.37,15.18a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,915.37,15.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M909.61,10.13c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,909.61,10.13Z"
              fill="#2f6840"
            />
            <path
              d="M909.11,9.79c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46S910.3,9,910.3,9s1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,909.11,9.79Z"
              fill="#3ba525"
            />
            <path
              d="M909.86,9.76a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,909.86,9.76Z"
              fill="#2f6840"
            />
            <path
              d="M913.34,9c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,913.34,9Z"
              fill="#2f6840"
            />
            <path
              d="M912,12.17a1.9,1.9,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,912,12.17Z"
              fill="#2f6840"
            />
            <path
              d="M910,10.22c-.24.06-.47.09-.69.16a3,3,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,910,10.22Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M901.27,6.76c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S909,7.35,908,7.23s-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,901.27,6.76Z"
              fill="#2f6840"
            />
            <path
              d="M900.77,6.42c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46S902,5.6,902,5.6s1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S896,7.57,896.22,7.48A14.56,14.56,0,0,1,900.77,6.42Z"
              fill="#3ba525"
            />
            <path
              d="M901.52,6.39a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,901.52,6.39Z"
              fill="#2f6840"
            />
            <path
              d="M905,5.59c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,905,5.59Z"
              fill="#2f6840"
            />
            <path
              d="M903.63,8.8a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,903.63,8.8Z"
              fill="#2f6840"
            />
            <path
              d="M901.67,6.85c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,901.67,6.85Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M916,22.25c4.42-.25-4.33.46-4.36-.61S916,19,916.9,19.19s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,916,22.25Z"
              fill="#2f6840"
            />
            <path
              d="M915.47,21.91c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,915.47,21.91Z"
              fill="#3ba525"
            />
            <path
              d="M916.22,21.88a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.46-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,916.22,21.88Z"
              fill="#2f6840"
            />
            <path
              d="M919.7,21.08c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,919.7,21.08Z"
              fill="#2f6840"
            />
            <path
              d="M918.33,24.29a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,918.33,24.29Z"
              fill="#2f6840"
            />
            <path
              d="M916.38,22.34a6.56,6.56,0,0,0-.7.16,3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.29,2.29,0,0,1,1.12-1A2,2,0,0,1,916.38,22.34Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M902.52,16.68c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,902.52,16.68Z"
              fill="#2f6840"
            />
            <path
              d="M902,16.34c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,902,16.34Z"
              fill="#3ba525"
            />
            <path
              d="M902.77,16.31a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.94.94,0,0,1,902.77,16.31Z"
              fill="#2f6840"
            />
            <path
              d="M906.24,15.51c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,906.24,15.51Z"
              fill="#2f6840"
            />
            <path
              d="M904.88,18.72a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,904.88,18.72Z"
              fill="#2f6840"
            />
            <path
              d="M902.92,16.77c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,902.92,16.77Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M945.71,11.17c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,945.71,11.17Z"
              fill="#2f6840"
            />
            <path
              d="M945.2,10.83c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.91-1.17-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,945.2,10.83Z"
              fill="#3ba525"
            />
            <path
              d="M946,10.8a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,946,10.8Z"
              fill="#2f6840"
            />
            <path
              d="M949.43,10c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.12,2.12,0,0,1,949.43,10Z"
              fill="#2f6840"
            />
            <path
              d="M948.06,13.21a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,948.06,13.21Z"
              fill="#2f6840"
            />
            <path
              d="M946.1,11.26c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,946.1,11.26Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M943.05,19.9c4.42-.25-4.33.46-4.36-.61S943,16.66,944,16.84s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,943.05,19.9Z"
              fill="#2f6840"
            />
            <path
              d="M942.54,19.56c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25S945,16,946.66,16.59s3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,942.54,19.56Z"
              fill="#3ba525"
            />
            <path
              d="M943.29,19.53a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,943.29,19.53Z"
              fill="#2f6840"
            />
            <path
              d="M946.77,18.73c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,946.77,18.73Z"
              fill="#2f6840"
            />
            <path
              d="M945.4,21.94a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.24,2.24,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,945.4,21.94Z"
              fill="#2f6840"
            />
            <path
              d="M943.45,20c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65A2.36,2.36,0,0,1,942,20,2.07,2.07,0,0,1,943.45,20Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M937.69,14.94c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S933,16.09,933.15,16A14.55,14.55,0,0,1,937.69,14.94Z"
              fill="#2f6840"
            />
            <path
              d="M937.19,14.6c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,937.19,14.6Z"
              fill="#3ba525"
            />
            <path
              d="M937.94,14.57a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,937.94,14.57Z"
              fill="#2f6840"
            />
            <path
              d="M941.42,13.78c-.26,0-.49,0-.73.09a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,941.42,13.78Z"
              fill="#2f6840"
            />
            <path
              d="M940.05,17a1.94,1.94,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,940.05,17Z"
              fill="#2f6840"
            />
            <path
              d="M938.09,15c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,938.09,15Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M929.35,11.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25S931.79,8,933.47,8.6s3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,929.35,11.57Z"
              fill="#2f6840"
            />
            <path
              d="M928.85,11.23c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,928.85,11.23Z"
              fill="#3ba525"
            />
            <path
              d="M929.6,11.2a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74A2.29,2.29,0,0,1,929,10a1.88,1.88,0,0,1,.48.53A1,1,0,0,1,929.6,11.2Z"
              fill="#2f6840"
            />
            <path
              d="M933.08,10.4c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.13,2.13,0,0,1,933.08,10.4Z"
              fill="#2f6840"
            />
            <path
              d="M931.71,13.61a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,931.71,13.61Z"
              fill="#2f6840"
            />
            <path
              d="M929.75,11.66c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,929.75,11.66Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M944.06,27.06c4.42-.25-4.33.46-4.36-.61S944.05,23.82,945,24s.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,944.06,27.06Z"
              fill="#2f6840"
            />
            <path
              d="M943.55,26.72c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,943.55,26.72Z"
              fill="#3ba525"
            />
            <path
              d="M944.3,26.69a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.06-.74a2.27,2.27,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,944.3,26.69Z"
              fill="#2f6840"
            />
            <path
              d="M947.78,25.89c-.26,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,947.78,25.89Z"
              fill="#2f6840"
            />
            <path
              d="M946.41,29.1a1.9,1.9,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.27,2.27,0,0,1,1.22.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,946.41,29.1Z"
              fill="#2f6840"
            />
            <path
              d="M944.45,27.15c-.24.06-.47.09-.69.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,944.45,27.15Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M930.6,21.49c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,930.6,21.49Z"
              fill="#2f6840"
            />
            <path
              d="M930.09,21.15c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,930.09,21.15Z"
              fill="#3ba525"
            />
            <path
              d="M930.85,21.12a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,930.85,21.12Z"
              fill="#2f6840"
            />
            <path
              d="M934.32,20.32c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,934.32,20.32Z"
              fill="#2f6840"
            />
            <path
              d="M933,23.53a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,933,23.53Z"
              fill="#2f6840"
            />
            <path
              d="M931,21.58c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,931,21.58Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M973.63,16.84c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S968.9,18,969.08,17.9A14.65,14.65,0,0,1,973.63,16.84Z"
              fill="#2f6840"
            />
            <path
              d="M973.12,16.5c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,973.12,16.5Z"
              fill="#3ba525"
            />
            <path
              d="M973.88,16.47a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,973.88,16.47Z"
              fill="#2f6840"
            />
            <path
              d="M977.35,15.67c-.25,0-.49.05-.72.1A4,4,0,0,0,976,16a11.87,11.87,0,0,0-1.34.52,2.39,2.39,0,0,1,1.23-.86A2.12,2.12,0,0,1,977.35,15.67Z"
              fill="#2f6840"
            />
            <path
              d="M976,18.88a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,976,18.88Z"
              fill="#2f6840"
            />
            <path
              d="M974,16.93c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10,10,0,0,0-1.26.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,974,16.93Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M971,25.57c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,971,25.57Z"
              fill="#2f6840"
            />
            <path
              d="M970.46,25.23c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71S971,26.1,971,26.1s-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,970.46,25.23Z"
              fill="#3ba525"
            />
            <path
              d="M971.22,25.2a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,971.22,25.2Z"
              fill="#2f6840"
            />
            <path
              d="M974.69,24.4c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,974.69,24.4Z"
              fill="#2f6840"
            />
            <path
              d="M973.33,27.61a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,973.33,27.61Z"
              fill="#2f6840"
            />
            <path
              d="M971.37,25.66c-.25.06-.48.09-.7.16A3.45,3.45,0,0,0,970,26a9.33,9.33,0,0,0-1.25.65,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,971.37,25.66Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M965.62,20.61c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,965.62,20.61Z"
              fill="#2f6840"
            />
            <path
              d="M965.11,20.27c4.43-.25-4.33.46-4.35-.61S965.11,17,966,17.2s.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,965.11,20.27Z"
              fill="#3ba525"
            />
            <path
              d="M965.86,20.24a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,965.86,20.24Z"
              fill="#2f6840"
            />
            <path
              d="M969.34,19.45c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,969.34,19.45Z"
              fill="#2f6840"
            />
            <path
              d="M968,22.66a1.93,1.93,0,0,0-.65-1c-.29-.28-.64-.5-1-.8a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,968,22.66Z"
              fill="#2f6840"
            />
            <path
              d="M966,20.7c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,966,20.7Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M957.27,17.24c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55S960,21.29,959,21s-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,957.27,17.24Z"
              fill="#2f6840"
            />
            <path
              d="M956.77,16.9c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S952,18.05,952.22,18A14.65,14.65,0,0,1,956.77,16.9Z"
              fill="#3ba525"
            />
            <path
              d="M957.52,16.87a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,957.52,16.87Z"
              fill="#2f6840"
            />
            <path
              d="M961,16.07c-.26,0-.49.05-.72.1a3.57,3.57,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,961,16.07Z"
              fill="#2f6840"
            />
            <path
              d="M959.63,19.28a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,959.63,19.28Z"
              fill="#2f6840"
            />
            <path
              d="M957.67,17.33c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.36,2.36,0,0,1,1.11-1A2,2,0,0,1,957.67,17.33Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M972,32.73c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.37,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,972,32.73Z"
              fill="#2f6840"
            />
            <path
              d="M971.47,32.39c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,971.47,32.39Z"
              fill="#3ba525"
            />
            <path
              d="M972.23,32.36a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,972.23,32.36Z"
              fill="#2f6840"
            />
            <path
              d="M975.7,31.56c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,975.7,31.56Z"
              fill="#2f6840"
            />
            <path
              d="M974.34,34.77a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,974.34,34.77Z"
              fill="#2f6840"
            />
            <path
              d="M972.38,32.82c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,972.38,32.82Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M958.52,27.16c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,958.52,27.16Z"
              fill="#2f6840"
            />
            <path
              d="M958,26.82c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,958,26.82Z"
              fill="#3ba525"
            />
            <path
              d="M958.77,26.79a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.35,2.35,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,958.77,26.79Z"
              fill="#2f6840"
            />
            <path
              d="M962.25,26c-.26,0-.49.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,962.25,26Z"
              fill="#2f6840"
            />
            <path
              d="M960.88,29.2a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,960.88,29.2Z"
              fill="#2f6840"
            />
            <path
              d="M958.92,27.25c-.24.06-.47.09-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,958.92,27.25Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1001.4,23.2c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.27-2.07-2.37A14.86,14.86,0,0,1,1001.4,23.2Z"
              fill="#2f6840"
            />
            <path
              d="M1000.9,22.86c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1000.9,22.86Z"
              fill="#3ba525"
            />
            <path
              d="M1001.65,22.83a2,2,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1001.65,22.83Z"
              fill="#2f6840"
            />
            <path
              d="M1005.13,22c-.26,0-.5,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1005.13,22Z"
              fill="#2f6840"
            />
            <path
              d="M1003.76,25.25a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1003.76,25.25Z"
              fill="#2f6840"
            />
            <path
              d="M1001.8,23.29c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1001.8,23.29Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M998.74,31.93c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55S994,33.08,994.2,33A14.55,14.55,0,0,1,998.74,31.93Z"
              fill="#2f6840"
            />
            <path
              d="M998.24,31.59c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.24.27,2.24,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,998.24,31.59Z"
              fill="#3ba525"
            />
            <path
              d="M999,31.56a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,999,31.56Z"
              fill="#2f6840"
            />
            <path
              d="M1002.47,30.77c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1002.47,30.77Z"
              fill="#2f6840"
            />
            <path
              d="M1001.1,34a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1001.1,34Z"
              fill="#2f6840"
            />
            <path
              d="M999.14,32c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,999.14,32Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M993.39,27c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,993.39,27Z"
              fill="#2f6840"
            />
            <path
              d="M992.88,26.63c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25S995.32,23,997,23.66s3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,992.88,26.63Z"
              fill="#3ba525"
            />
            <path
              d="M993.64,26.6a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,993.64,26.6Z"
              fill="#2f6840"
            />
            <path
              d="M997.12,25.81a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,10.33,10.33,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,997.12,25.81Z"
              fill="#2f6840"
            />
            <path
              d="M995.75,29a1.94,1.94,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,995.75,29Z"
              fill="#2f6840"
            />
            <path
              d="M993.79,27.06c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,10.56,10.56,0,0,0-1.25.64,2.2,2.2,0,0,1,1.11-1A2,2,0,0,1,993.79,27.06Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M985.05,23.6c4.42-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,985.05,23.6Z"
              fill="#2f6840"
            />
            <path
              d="M984.54,23.26c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,984.54,23.26Z"
              fill="#3ba525"
            />
            <path
              d="M985.3,23.23a2.24,2.24,0,0,0-.8-.94c-.33-.26-.71-.45-1.07-.73a2.28,2.28,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,985.3,23.23Z"
              fill="#2f6840"
            />
            <path
              d="M988.77,22.44c-.25,0-.49,0-.72.09a4,4,0,0,0-.68.18,12.79,12.79,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.07,2.07,0,0,1,988.77,22.44Z"
              fill="#2f6840"
            />
            <path
              d="M987.4,25.65a1.86,1.86,0,0,0-.65-1c-.29-.29-.64-.51-1-.81a2.16,2.16,0,0,1,1.21.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,987.4,25.65Z"
              fill="#2f6840"
            />
            <path
              d="M985.45,23.69c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,985.45,23.69Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M999.75,39.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,999.75,39.09Z"
              fill="#2f6840"
            />
            <path
              d="M999.25,38.75c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,999.25,38.75Z"
              fill="#3ba525"
            />
            <path
              d="M1000,38.72a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1000,38.72Z"
              fill="#2f6840"
            />
            <path
              d="M1003.48,37.93c-.26,0-.49,0-.73.09a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.07,2.07,0,0,1,1003.48,37.93Z"
              fill="#2f6840"
            />
            <path
              d="M1002.11,41.14a1.88,1.88,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.92.92,0,0,1,1002.11,41.14Z"
              fill="#2f6840"
            />
            <path
              d="M1000.15,39.18c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1000.15,39.18Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M986.3,33.52c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16S994,34.11,993.07,34s-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,986.3,33.52Z"
              fill="#2f6840"
            />
            <path
              d="M985.79,33.18c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,985.79,33.18Z"
              fill="#3ba525"
            />
            <path
              d="M986.54,33.15a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.06-.73a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,986.54,33.15Z"
              fill="#2f6840"
            />
            <path
              d="M990,32.36c-.26,0-.49,0-.72.09a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,990,32.36Z"
              fill="#2f6840"
            />
            <path
              d="M988.65,35.57a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.18,2.18,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A1,1,0,0,1,988.65,35.57Z"
              fill="#2f6840"
            />
            <path
              d="M986.69,33.61c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,986.69,33.61Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1029.62,24.64c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1029.62,24.64Z"
              fill="#2f6840"
            />
            <path
              d="M1029.12,24.3c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1029.12,24.3Z"
              fill="#3ba525"
            />
            <path
              d="M1029.87,24.27a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1029.87,24.27Z"
              fill="#2f6840"
            />
            <path
              d="M1033.35,23.47c-.26,0-.49.05-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1033.35,23.47Z"
              fill="#2f6840"
            />
            <path
              d="M1032,26.68a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1032,26.68Z"
              fill="#2f6840"
            />
            <path
              d="M1030,24.73c-.24.06-.47.09-.7.16a2.87,2.87,0,0,0-.64.23,8.71,8.71,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1030,24.73Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1027,33.37c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1027,33.37Z"
              fill="#2f6840"
            />
            <path
              d="M1026.46,33c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1026.46,33Z"
              fill="#3ba525"
            />
            <path
              d="M1027.21,33a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1027.21,33Z"
              fill="#2f6840"
            />
            <path
              d="M1030.69,32.2c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1030.69,32.2Z"
              fill="#2f6840"
            />
            <path
              d="M1029.32,35.41a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1029.32,35.41Z"
              fill="#2f6840"
            />
            <path
              d="M1027.36,33.46c-.24.06-.47.09-.69.16a3.55,3.55,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1027.36,33.46Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1021.61,28.41c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1021.61,28.41Z"
              fill="#2f6840"
            />
            <path
              d="M1021.11,28.07c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1021.11,28.07Z"
              fill="#3ba525"
            />
            <path
              d="M1021.86,28a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1021.86,28Z"
              fill="#2f6840"
            />
            <path
              d="M1025.34,27.24c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.38,2.38,0,0,1,1.24-.86A2.12,2.12,0,0,1,1025.34,27.24Z"
              fill="#2f6840"
            />
            <path
              d="M1024,30.45a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.8a2.13,2.13,0,0,1,1.21.54,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1024,30.45Z"
              fill="#2f6840"
            />
            <path
              d="M1022,28.5c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,9.24,9.24,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1022,28.5Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1013.27,25c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1013.27,25Z"
              fill="#2f6840"
            />
            <path
              d="M1012.76,24.7c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1012.76,24.7Z"
              fill="#3ba525"
            />
            <path
              d="M1013.52,24.67a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1013.52,24.67Z"
              fill="#2f6840"
            />
            <path
              d="M1017,23.87c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.12,2.12,0,0,1,1017,23.87Z"
              fill="#2f6840"
            />
            <path
              d="M1015.63,27.08a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1015.63,27.08Z"
              fill="#2f6840"
            />
            <path
              d="M1013.67,25.13c-.25.06-.48.09-.7.16a3.45,3.45,0,0,0-.64.22,10.08,10.08,0,0,0-1.26.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1013.67,25.13Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1028,40.53c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1028,40.53Z"
              fill="#2f6840"
            />
            <path
              d="M1027.47,40.19c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1027.47,40.19Z"
              fill="#3ba525"
            />
            <path
              d="M1028.22,40.16a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.29.46,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1028.22,40.16Z"
              fill="#2f6840"
            />
            <path
              d="M1031.7,39.36c-.26,0-.49,0-.73.1a3.67,3.67,0,0,0-.67.18,11.31,11.31,0,0,0-1.35.52,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1031.7,39.36Z"
              fill="#2f6840"
            />
            <path
              d="M1030.33,42.57a1.9,1.9,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.81,1.81,0,0,1,.41.57A.94.94,0,0,1,1030.33,42.57Z"
              fill="#2f6840"
            />
            <path
              d="M1028.37,40.62c-.24.06-.47.09-.69.16a3.31,3.31,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1028.37,40.62Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1014.52,35c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1014.52,35Z"
              fill="#2f6840"
            />
            <path
              d="M1014,34.62c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1014,34.62Z"
              fill="#3ba525"
            />
            <path
              d="M1014.76,34.59a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.22,2.22,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1014.76,34.59Z"
              fill="#2f6840"
            />
            <path
              d="M1018.24,33.79c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1018.24,33.79Z"
              fill="#2f6840"
            />
            <path
              d="M1016.87,37a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1016.87,37Z"
              fill="#2f6840"
            />
            <path
              d="M1014.92,35.05c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1014.92,35.05Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1056.37,15.6c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1056.37,15.6Z"
              fill="#2f6840"
            />
            <path
              d="M1055.86,15.25c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.55,14.55,0,0,1,1055.86,15.25Z"
              fill="#3ba525"
            />
            <path
              d="M1056.62,15.22a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74A2.28,2.28,0,0,1,1056,14a1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1056.62,15.22Z"
              fill="#2f6840"
            />
            <path
              d="M1060.1,14.43c-.26,0-.5,0-.73.1a3.22,3.22,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.1,2.1,0,0,1,1060.1,14.43Z"
              fill="#2f6840"
            />
            <path
              d="M1058.73,17.64a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.6,1.6,0,0,1,.4.56A.92.92,0,0,1,1058.73,17.64Z"
              fill="#2f6840"
            />
            <path
              d="M1056.77,15.68c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1056.77,15.68Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1053.71,24.33c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1053.71,24.33Z"
              fill="#2f6840"
            />
            <path
              d="M1053.21,24c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1053.21,24Z"
              fill="#3ba525"
            />
            <path
              d="M1054,24a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1054,24Z"
              fill="#2f6840"
            />
            <path
              d="M1057.44,23.16a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1057.44,23.16Z"
              fill="#2f6840"
            />
            <path
              d="M1056.07,26.37a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1056.07,26.37Z"
              fill="#2f6840"
            />
            <path
              d="M1054.11,24.41c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1054.11,24.41Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1048.36,19.37c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1048.36,19.37Z"
              fill="#2f6840"
            />
            <path
              d="M1047.85,19c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1047.85,19Z"
              fill="#3ba525"
            />
            <path
              d="M1048.61,19a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1048.61,19Z"
              fill="#2f6840"
            />
            <path
              d="M1052.08,18.2c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.41,2.41,0,0,1,1.23-.87A2.07,2.07,0,0,1,1052.08,18.2Z"
              fill="#2f6840"
            />
            <path
              d="M1050.72,21.41a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.1,2.1,0,0,1,1.21.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1050.72,21.41Z"
              fill="#2f6840"
            />
            <path
              d="M1048.76,19.45c-.25.06-.48.09-.7.16a4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1048.76,19.45Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1040,16c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1040,16Z"
              fill="#2f6840"
            />
            <path
              d="M1039.51,15.65c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1039.51,15.65Z"
              fill="#3ba525"
            />
            <path
              d="M1040.26,15.62a2.13,2.13,0,0,0-.79-.93c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A1,1,0,0,1,1040.26,15.62Z"
              fill="#2f6840"
            />
            <path
              d="M1043.74,14.83a5.43,5.43,0,0,0-.72.1,3.22,3.22,0,0,0-.68.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1043.74,14.83Z"
              fill="#2f6840"
            />
            <path
              d="M1042.37,18a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.15,2.15,0,0,1,1.22.54,1.9,1.9,0,0,1,.4.57A1,1,0,0,1,1042.37,18Z"
              fill="#2f6840"
            />
            <path
              d="M1040.42,16.08c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1040.42,16.08Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1054.72,31.49c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1054.72,31.49Z"
              fill="#2f6840"
            />
            <path
              d="M1054.22,31.14c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1054.22,31.14Z"
              fill="#3ba525"
            />
            <path
              d="M1055,31.11a2.15,2.15,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1055,31.11Z"
              fill="#2f6840"
            />
            <path
              d="M1058.45,30.32a5.36,5.36,0,0,0-.73.1,3.22,3.22,0,0,0-.68.17,12,12,0,0,0-1.34.53,2.4,2.4,0,0,1,1.24-.87A2.07,2.07,0,0,1,1058.45,30.32Z"
              fill="#2f6840"
            />
            <path
              d="M1057.08,33.53a2,2,0,0,0-.66-1c-.29-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.73,1.73,0,0,1,.4.57A.92.92,0,0,1,1057.08,33.53Z"
              fill="#2f6840"
            />
            <path
              d="M1055.12,31.57c-.25.06-.48.09-.7.16a3.48,3.48,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1055.12,31.57Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1041.26,25.92c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.27-2.07-2.36A14.55,14.55,0,0,1,1041.26,25.92Z"
              fill="#2f6840"
            />
            <path
              d="M1040.76,25.57c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1040.76,25.57Z"
              fill="#3ba525"
            />
            <path
              d="M1041.51,25.54a2.08,2.08,0,0,0-.8-.93c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1041.51,25.54Z"
              fill="#2f6840"
            />
            <path
              d="M1045,24.75a5.58,5.58,0,0,0-.73.1,3,3,0,0,0-.67.17,11.41,11.41,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1045,24.75Z"
              fill="#2f6840"
            />
            <path
              d="M1043.62,28a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.93,1.93,0,0,1,.41.57A1,1,0,0,1,1043.62,28Z"
              fill="#2f6840"
            />
            <path
              d="M1041.66,26c-.24.06-.47.09-.69.16a4.14,4.14,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1041.66,26Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1082.66,5.77c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1082.66,5.77Z"
              fill="#2f6840"
            />
            <path
              d="M1082.15,5.43c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1082.15,5.43Z"
              fill="#3ba525"
            />
            <path
              d="M1082.9,5.4a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.73a2.26,2.26,0,0,1,1.28.45,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1082.9,5.4Z"
              fill="#2f6840"
            />
            <path
              d="M1086.38,4.6c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.46,2.46,0,0,1,1.24-.86A2.12,2.12,0,0,1,1086.38,4.6Z"
              fill="#2f6840"
            />
            <path
              d="M1085,7.81a1.9,1.9,0,0,0-.66-1c-.28-.28-.63-.5-1-.8a2.15,2.15,0,0,1,1.22.54,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1085,7.81Z"
              fill="#2f6840"
            />
            <path
              d="M1083.06,5.86c-.25.06-.48.09-.7.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.27,2.27,0,0,1,1.12-1A2,2,0,0,1,1083.06,5.86Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1080,14.5c4.42-.25-4.33.46-4.35-.61s4.34-2.63,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1080,14.5Z"
              fill="#2f6840"
            />
            <path
              d="M1079.49,14.16c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71S1080,15,1080,15s-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1079.49,14.16Z"
              fill="#3ba525"
            />
            <path
              d="M1080.24,14.13a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1080.24,14.13Z"
              fill="#2f6840"
            />
            <path
              d="M1083.72,13.33c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1083.72,13.33Z"
              fill="#2f6840"
            />
            <path
              d="M1082.35,16.54a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1082.35,16.54Z"
              fill="#2f6840"
            />
            <path
              d="M1080.4,14.59c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1080.4,14.59Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1074.65,9.54c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1074.65,9.54Z"
              fill="#2f6840"
            />
            <path
              d="M1074.14,9.2c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1074.14,9.2Z"
              fill="#3ba525"
            />
            <path
              d="M1074.89,9.17a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.34,2.34,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1074.89,9.17Z"
              fill="#2f6840"
            />
            <path
              d="M1078.37,8.38c-.26,0-.49,0-.72.09a3.77,3.77,0,0,0-.68.18,11.31,11.31,0,0,0-1.35.52,2.42,2.42,0,0,1,1.24-.86A2.07,2.07,0,0,1,1078.37,8.38Z"
              fill="#2f6840"
            />
            <path
              d="M1077,11.59a1.82,1.82,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.13,2.13,0,0,1,1.21.54,1.81,1.81,0,0,1,.41.57A1,1,0,0,1,1077,11.59Z"
              fill="#2f6840"
            />
            <path
              d="M1075,9.63c-.24.06-.47.09-.69.16a3.15,3.15,0,0,0-.65.23,9.87,9.87,0,0,0-1.25.64,2.29,2.29,0,0,1,1.11-1A2,2,0,0,1,1075,9.63Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1066.3,6.17c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1066.3,6.17Z"
              fill="#2f6840"
            />
            <path
              d="M1065.8,5.83c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46S1067,5,1067,5s1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1065.8,5.83Z"
              fill="#3ba525"
            />
            <path
              d="M1066.55,5.8a2.11,2.11,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.26,2.26,0,0,1,1.29.45,1.85,1.85,0,0,1,.47.53A1,1,0,0,1,1066.55,5.8Z"
              fill="#2f6840"
            />
            <path
              d="M1070,5c-.26,0-.49,0-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1070,5Z"
              fill="#2f6840"
            />
            <path
              d="M1068.66,8.21a2,2,0,0,0-.66-1c-.28-.28-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.89.89,0,0,1,1068.66,8.21Z"
              fill="#2f6840"
            />
            <path
              d="M1066.7,6.26c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.24,2.24,0,0,1,1.11-1A2,2,0,0,1,1066.7,6.26Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1081,21.66c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1081,21.66Z"
              fill="#2f6840"
            />
            <path
              d="M1080.5,21.32c4.43-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.92,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1080.5,21.32Z"
              fill="#3ba525"
            />
            <path
              d="M1081.25,21.29a2.15,2.15,0,0,0-.79-.94c-.33-.26-.71-.45-1.07-.74a2.29,2.29,0,0,1,1.28.46,1.71,1.71,0,0,1,.47.53A.93.93,0,0,1,1081.25,21.29Z"
              fill="#2f6840"
            />
            <path
              d="M1084.73,20.49c-.25,0-.49.05-.72.1a4,4,0,0,0-.68.18,12,12,0,0,0-1.35.52,2.54,2.54,0,0,1,1.24-.87A2.12,2.12,0,0,1,1084.73,20.49Z"
              fill="#2f6840"
            />
            <path
              d="M1083.36,23.7a1.94,1.94,0,0,0-.65-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.78,1.78,0,0,1,.4.57A.94.94,0,0,1,1083.36,23.7Z"
              fill="#2f6840"
            />
            <path
              d="M1081.41,21.75c-.25.06-.48.09-.7.16a3.83,3.83,0,0,0-.65.22,10,10,0,0,0-1.25.65,2.34,2.34,0,0,1,1.12-1A2,2,0,0,1,1081.41,21.75Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1067.55,16.09c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1067.55,16.09Z"
              fill="#2f6840"
            />
            <path
              d="M1067,15.75c4.43-.25-4.32.45-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.31,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.55,14.55,0,0,1,1067,15.75Z"
              fill="#3ba525"
            />
            <path
              d="M1067.8,15.72a2.17,2.17,0,0,0-.8-.94c-.32-.26-.7-.45-1.07-.73a2.21,2.21,0,0,1,1.28.45,1.88,1.88,0,0,1,.48.53A1,1,0,0,1,1067.8,15.72Z"
              fill="#2f6840"
            />
            <path
              d="M1071.28,14.92c-.26,0-.5.05-.73.1a4,4,0,0,0-.68.18,11.87,11.87,0,0,0-1.34.52,2.47,2.47,0,0,1,1.23-.87A2.15,2.15,0,0,1,1071.28,14.92Z"
              fill="#2f6840"
            />
            <path
              d="M1069.91,18.13a2,2,0,0,0-.66-1c-.29-.28-.64-.5-1-.81a2.24,2.24,0,0,1,1.21.55,1.64,1.64,0,0,1,.4.57A.94.94,0,0,1,1069.91,18.13Z"
              fill="#2f6840"
            />
            <path
              d="M1068,16.18c-.25.06-.48.09-.7.16a2.87,2.87,0,0,0-.64.23,8.22,8.22,0,0,0-1.25.64,2.27,2.27,0,0,1,1.11-1A2,2,0,0,1,1068,16.18Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1104,18.21c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1104,18.21Z"
              fill="#2f6840"
            />
            <path
              d="M1103.47,17.87c4.43-.26-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.34,14.34,0,0,1,1103.47,17.87Z"
              fill="#3ba525"
            />
            <path
              d="M1104.22,17.84a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1104.22,17.84Z"
              fill="#2f6840"
            />
            <path
              d="M1107.7,17c-.26,0-.49.05-.72.1a4.83,4.83,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1107.7,17Z"
              fill="#2f6840"
            />
            <path
              d="M1106.33,20.25a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1106.33,20.25Z"
              fill="#2f6840"
            />
            <path
              d="M1104.37,18.3a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1104.37,18.3Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1101.32,26.94c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1101.32,26.94Z"
              fill="#2f6840"
            />
            <path
              d="M1100.81,26.59c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1100.81,26.59Z"
              fill="#3ba525"
            />
            <path
              d="M1101.56,26.57a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1101.56,26.57Z"
              fill="#2f6840"
            />
            <path
              d="M1105,25.77c-.26,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1105,25.77Z"
              fill="#2f6840"
            />
            <path
              d="M1103.67,29a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1103.67,29Z"
              fill="#2f6840"
            />
            <path
              d="M1101.71,27a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1101.71,27Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1096,22c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1096,22Z"
              fill="#2f6840"
            />
            <path
              d="M1095.46,21.64c4.42-.25-4.33.45-4.35-.61s4.34-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1095.46,21.64Z"
              fill="#3ba525"
            />
            <path
              d="M1096.21,21.61a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1096.21,21.61Z"
              fill="#2f6840"
            />
            <path
              d="M1099.69,20.81c-.26,0-.49.05-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.12,2.12,0,0,1,1099.69,20.81Z"
              fill="#2f6840"
            />
            <path
              d="M1098.32,24a1.92,1.92,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.21,2.21,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1098.32,24Z"
              fill="#2f6840"
            />
            <path
              d="M1096.36,22.07c-.24.06-.47.08-.7.16a3.45,3.45,0,0,0-.64.22,9.33,9.33,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1096.36,22.07Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1087.62,18.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.23-2.77,2.92-2.15,3.63,3.56,2.65,3.44-4.69.05-4.69.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1087.62,18.61Z"
              fill="#2f6840"
            />
            <path
              d="M1087.12,18.26c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1087.12,18.26Z"
              fill="#3ba525"
            />
            <path
              d="M1087.87,18.24a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2.2,2.2,0,0,1,.48.53A1,1,0,0,1,1087.87,18.24Z"
              fill="#2f6840"
            />
            <path
              d="M1091.35,17.44c-.26,0-.5,0-.73.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.1,2.1,0,0,1,1091.35,17.44Z"
              fill="#2f6840"
            />
            <path
              d="M1090,20.65a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1090,20.65Z"
              fill="#2f6840"
            />
            <path
              d="M1088,18.7a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1088,18.7Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1102.33,34.1c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1102.33,34.1Z"
              fill="#2f6840"
            />
            <path
              d="M1101.82,33.75c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.26,2.25.26,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A15,15,0,0,1,1101.82,33.75Z"
              fill="#3ba525"
            />
            <path
              d="M1102.57,33.73a2.06,2.06,0,0,0-.8-.94c-.32-.27-.7-.46-1.06-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1102.57,33.73Z"
              fill="#2f6840"
            />
            <path
              d="M1106.05,32.93c-.26,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.07,2.07,0,0,1,1106.05,32.93Z"
              fill="#2f6840"
            />
            <path
              d="M1104.68,36.14a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.13,2.13,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1104.68,36.14Z"
              fill="#2f6840"
            />
            <path
              d="M1102.72,34.19a7,7,0,0,0-.69.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1102.72,34.19Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1088.87,28.53c4.42-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1088.87,28.53Z"
              fill="#2f6840"
            />
            <path
              d="M1088.36,28.18c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.64,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1088.36,28.18Z"
              fill="#3ba525"
            />
            <path
              d="M1089.12,28.16a2.12,2.12,0,0,0-.8-.94c-.32-.27-.71-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1089.12,28.16Z"
              fill="#2f6840"
            />
            <path
              d="M1092.59,27.36c-.25,0-.49,0-.72.1a5.2,5.2,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1092.59,27.36Z"
              fill="#2f6840"
            />
            <path
              d="M1091.23,30.57a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1091.23,30.57Z"
              fill="#2f6840"
            />
            <path
              d="M1089.27,28.62a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.43,9.43,0,0,0-1.26.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1089.27,28.62Z"
              fill="#2f6840"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M1131.24,22.07c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.26-2.28-2.08-2.37A14.56,14.56,0,0,1,1131.24,22.07Z"
              fill="#2f6840"
            />
            <path
              d="M1130.73,21.72c4.43-.25-4.33.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.62,3.56,2.65,3.45-4.69,0-4.69,0,6,.87,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.37A15,15,0,0,1,1130.73,21.72Z"
              fill="#3ba525"
            />
            <path
              d="M1131.48,21.7a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,2,2,0,0,1,.47.53A1,1,0,0,1,1131.48,21.7Z"
              fill="#2f6840"
            />
            <path
              d="M1135,20.9c-.25,0-.49.05-.72.1a5.2,5.2,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1135,20.9Z"
              fill="#2f6840"
            />
            <path
              d="M1133.59,24.11a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.5-1-.81a2.17,2.17,0,0,1,1.22.55,1.68,1.68,0,0,1,.4.57A.94.94,0,0,1,1133.59,24.11Z"
              fill="#2f6840"
            />
            <path
              d="M1131.64,22.16a6.61,6.61,0,0,0-.7.15,5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2,2,0,0,1,1131.64,22.16Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1128.58,30.8c4.42-.25-4.33.46-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1128.58,30.8Z"
              fill="#2f6840"
            />
            <path
              d="M1128.07,30.45c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1128.07,30.45Z"
              fill="#3ba525"
            />
            <path
              d="M1128.82,30.43a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1128.82,30.43Z"
              fill="#2f6840"
            />
            <path
              d="M1132.3,29.63c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.48,2.48,0,0,1,1.24-.87A2.07,2.07,0,0,1,1132.3,29.63Z"
              fill="#2f6840"
            />
            <path
              d="M1130.93,32.84a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1130.93,32.84Z"
              fill="#2f6840"
            />
            <path
              d="M1129,30.88c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.24,2.24,0,0,1,1.12-1A2,2,0,0,1,1129,30.88Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1123.22,25.84c4.43-.25-4.32.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.44-4.7.05-4.7.05,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.91,3.33-3,2.55-2.25-2.28-2.07-2.37A14.55,14.55,0,0,1,1123.22,25.84Z"
              fill="#2f6840"
            />
            <path
              d="M1122.72,25.5c4.42-.25-4.33.45-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1122.72,25.5Z"
              fill="#3ba525"
            />
            <path
              d="M1123.47,25.47a2.11,2.11,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2,2,0,0,1,.47.54A1,1,0,0,1,1123.47,25.47Z"
              fill="#2f6840"
            />
            <path
              d="M1127,24.67c-.26,0-.49,0-.73.1a4.69,4.69,0,0,0-.67.17,13.44,13.44,0,0,0-1.35.53,2.5,2.5,0,0,1,1.24-.87A2.12,2.12,0,0,1,1127,24.67Z"
              fill="#2f6840"
            />
            <path
              d="M1125.58,27.88a1.86,1.86,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.14,2.14,0,0,1,1.21.55,1.7,1.7,0,0,1,.41.57A.94.94,0,0,1,1125.58,27.88Z"
              fill="#2f6840"
            />
            <path
              d="M1123.62,25.93a7,7,0,0,0-.69.16,3.31,3.31,0,0,0-.65.22A10,10,0,0,0,1121,27a2.31,2.31,0,0,1,1.11-1A2,2,0,0,1,1123.62,25.93Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1114.88,22.47c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.92-2.15,3.63,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.16-2.9-1.16-2.9-.92,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1114.88,22.47Z"
              fill="#2f6840"
            />
            <path
              d="M1114.38,22.12c4.42-.25-4.33.46-4.36-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.3,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.87,14.87,0,0,1,1114.38,22.12Z"
              fill="#3ba525"
            />
            <path
              d="M1115.13,22.1a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.34,2.34,0,0,1,1.29.45,2.18,2.18,0,0,1,.47.53A1,1,0,0,1,1115.13,22.1Z"
              fill="#2f6840"
            />
            <path
              d="M1118.61,21.3c-.26,0-.5,0-.73.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.45,2.45,0,0,1,1.24-.87A2.07,2.07,0,0,1,1118.61,21.3Z"
              fill="#2f6840"
            />
            <path
              d="M1117.24,24.51a2,2,0,0,0-.66-1c-.28-.29-.64-.5-1-.81a2.08,2.08,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.89.89,0,0,1,1117.24,24.51Z"
              fill="#2f6840"
            />
            <path
              d="M1115.28,22.56a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.22,2.22,0,0,1,1.11-1A2,2,0,0,1,1115.28,22.56Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1129.59,38c4.42-.25-4.33.45-4.36-.61s4.35-2.63,5.28-2.46.27,2.25.27,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.7,0-4.7,0,6,.87,4,1.55-3.3,2-4.36,1.72-1.16-2.91-1.16-2.91-.91,3.34-3,2.55-2.26-2.27-2.08-2.36A14.56,14.56,0,0,1,1129.59,38Z"
              fill="#2f6840"
            />
            <path
              d="M1129.08,37.61c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.45.27,2.25.27,2.25,1.23-2.78,2.92-2.16,3.63,3.56,2.65,3.45-4.69,0-4.69,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.17-2.9-1.17-2.9-.91,3.34-3,2.55-2.26-2.28-2.08-2.37A14.65,14.65,0,0,1,1129.08,37.61Z"
              fill="#3ba525"
            />
            <path
              d="M1129.83,37.59a2.1,2.1,0,0,0-.79-.94c-.33-.27-.71-.46-1.07-.74a2.34,2.34,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1129.83,37.59Z"
              fill="#2f6840"
            />
            <path
              d="M1133.31,36.79c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,13.44,13.44,0,0,0-1.35.53,2.44,2.44,0,0,1,1.24-.87A2.07,2.07,0,0,1,1133.31,36.79Z"
              fill="#2f6840"
            />
            <path
              d="M1131.94,40a1.86,1.86,0,0,0-.66-1c-.28-.29-.63-.51-1-.81a2.1,2.1,0,0,1,1.22.55,1.74,1.74,0,0,1,.4.56A1,1,0,0,1,1131.94,40Z"
              fill="#2f6840"
            />
            <path
              d="M1130,38c-.25.06-.48.09-.7.16a5,5,0,0,0-.65.23,10,10,0,0,0-1.25.65,2.26,2.26,0,0,1,1.11-1A2.07,2.07,0,0,1,1130,38Z"
              fill="#2f6840"
            />
          </g>
          <g>
            <path
              d="M1116.13,32.39c4.43-.25-4.33.46-4.35-.61s4.35-2.63,5.28-2.46.26,2.25.26,2.25,1.24-2.77,2.93-2.15,3.62,3.55,2.65,3.44-4.69,0-4.69,0,6,.86,4,1.54-3.31,2-4.36,1.72-1.17-2.9-1.17-2.9-.91,3.33-3,2.54-2.26-2.27-2.08-2.36A14.65,14.65,0,0,1,1116.13,32.39Z"
              fill="#2f6840"
            />
            <path
              d="M1115.62,32c4.43-.25-4.32.46-4.35-.61s4.35-2.62,5.28-2.45.27,2.25.27,2.25,1.24-2.78,2.93-2.16,3.62,3.56,2.65,3.45-4.7,0-4.7,0,6,.86,4,1.55-3.31,2-4.36,1.71-1.16-2.9-1.16-2.9-.91,3.34-3,2.55-2.25-2.28-2.07-2.37A14.86,14.86,0,0,1,1115.62,32Z"
              fill="#3ba525"
            />
            <path
              d="M1116.38,32a2.12,2.12,0,0,0-.8-.94c-.32-.27-.7-.46-1.07-.74a2.28,2.28,0,0,1,1.28.45,1.83,1.83,0,0,1,.47.53A1,1,0,0,1,1116.38,32Z"
              fill="#2f6840"
            />
            <path
              d="M1119.85,31.22c-.25,0-.49,0-.72.1a4,4,0,0,0-.68.17,14.29,14.29,0,0,0-1.34.53,2.47,2.47,0,0,1,1.23-.87A2.07,2.07,0,0,1,1119.85,31.22Z"
              fill="#2f6840"
            />
            <path
              d="M1118.49,34.43a2,2,0,0,0-.66-1c-.29-.29-.64-.5-1-.81a2.1,2.1,0,0,1,1.21.55,1.55,1.55,0,0,1,.4.57A.94.94,0,0,1,1118.49,34.43Z"
              fill="#2f6840"
            />
            <path
              d="M1116.53,32.48a6.61,6.61,0,0,0-.7.15,4.41,4.41,0,0,0-.64.23,9.33,9.33,0,0,0-1.25.65,2.18,2.18,0,0,1,1.11-1A2,2,0,0,1,1116.53,32.48Z"
              fill="#2f6840"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M1103.57,33.85l1.84,1.14a.59.59,0,0,0,.56,0l4.41-2a.59.59,0,0,0,.15-1h0a.55.55,0,0,0-.47-.14l-6.25.83A.59.59,0,0,0,1103.57,33.85Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1106.83 29.3 1104.35 29.82 1102.16 31.5 1105.83 32.98 1110.32 31.14 1106.83 29.3"
            fill="#ffedc8"
          />
          <polygon
            points="1102.16 31.5 1102.16 32.98 1105.68 34.48 1110.42 32.56 1110.32 31.14 1105.83 32.98 1102.16 31.5"
            fill="#ccae79"
          />
          <polygon
            points="1105.83 32.98 1105.68 34.48 1110.42 32.56 1110.32 31.14 1105.83 32.98"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1103.21,31.92a.69.69,0,0,1,0,.76c.16-.24.2-.67.28-.64Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1104.75,32.55a2.15,2.15,0,0,0,.93-.95l-.67,1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1107.68,32.22a.67.67,0,0,1,.37.59l-.11-.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1109.33,30.61a4.2,4.2,0,0,1-1.46,0,2.1,2.1,0,0,1-1.07.07s.78-.07,1.07.19A6.41,6.41,0,0,1,1109.33,30.61Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M976.27,24.42l1.84,1.14a.61.61,0,0,0,.56,0l4.4-2a.6.6,0,0,0,.15-1h0a.61.61,0,0,0-.47-.14l-6.24.83A.6.6,0,0,0,976.27,24.42Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="979.53 19.86 977.04 20.39 974.85 22.07 978.52 23.54 983.02 21.7 979.53 19.86"
            fill="#ffedc8"
          />
          <polygon
            points="974.85 22.07 974.85 23.54 978.38 25.05 983.12 23.13 983.02 21.7 978.52 23.54 974.85 22.07"
            fill="#ccae79"
          />
          <polygon
            points="978.52 23.54 978.38 25.05 983.12 23.13 983.02 21.7 978.52 23.54"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M975.9,22.49a.65.65,0,0,1,0,.75c.17-.23.21-.67.28-.64Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M977.45,23.11a2.08,2.08,0,0,0,.93-.94l-.67,1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M980.38,22.78a.69.69,0,0,1,.37.59l-.11-.69Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M982,21.17a4.19,4.19,0,0,1-1.46,0,2,2,0,0,1-1.06.08s.78-.08,1.06.19A6.61,6.61,0,0,1,982,21.17Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M927.29,23.43l1.83,1.14a.62.62,0,0,0,.56,0l4.41-2a.59.59,0,0,0,.15-1h0a.55.55,0,0,0-.47-.14l-6.25.83A.6.6,0,0,0,927.29,23.43Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="930.55 18.86 928.06 19.39 925.87 21.07 929.54 22.55 934.03 20.71 930.55 18.86"
            fill="#ffedc8"
          />
          <polygon
            points="925.87 21.07 925.87 22.55 929.39 24.05 934.13 22.13 934.03 20.71 929.54 22.55 925.87 21.07"
            fill="#ccae79"
          />
          <polygon
            points="929.54 22.55 929.39 24.05 934.13 22.13 934.03 20.71 929.54 22.55"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M926.92,21.5a.65.65,0,0,1,0,.75c.16-.24.2-.67.28-.64Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M928.47,22.12a2.09,2.09,0,0,0,.92-.94l-.66,1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M931.4,21.79a.67.67,0,0,1,.36.59l-.11-.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M933,20.18a4.2,4.2,0,0,1-1.46,0,2.06,2.06,0,0,1-1.06.07s.78-.07,1.06.2A6,6,0,0,1,933,20.18Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1079.93,17.12l4,2.49a1.29,1.29,0,0,0,1.22.08l9.62-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.3,1.3,0,0,0-1-.3l-13.64,1.81A1.3,1.3,0,0,0,1079.93,17.12Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1087.05 7.17 1081.62 8.32 1076.84 11.99 1084.85 15.2 1094.66 11.18 1087.05 7.17"
            fill="#ffedc8"
          />
          <polygon
            points="1076.84 11.99 1076.84 15.2 1084.53 18.5 1094.87 14.3 1094.66 11.18 1084.85 15.2 1076.84 11.99"
            fill="#ccae79"
          />
          <polygon
            points="1084.85 15.2 1084.53 18.5 1094.87 14.3 1094.66 11.18 1084.85 15.2"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1079.12,12.91a1.43,1.43,0,0,1,0,1.64c.37-.51.45-1.47.62-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1082.5,14.26a4.6,4.6,0,0,0,2-2l-1.46,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1088.9,13.54a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1092.49,10a9.72,9.72,0,0,1-3.19,0,4.65,4.65,0,0,1-2.32.16s1.7-.17,2.32.41A13.73,13.73,0,0,1,1092.49,10Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M894.68,20.33l4,2.49a1.29,1.29,0,0,0,1.22.08l9.63-4.3a1.3,1.3,0,0,0,.32-2.17h0a1.27,1.27,0,0,0-1-.31l-13.64,1.81A1.3,1.3,0,0,0,894.68,20.33Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="901.79 10.38 896.37 11.53 891.59 15.2 899.6 18.41 909.41 14.39 901.79 10.38"
            fill="#ffedc8"
          />
          <polygon
            points="891.59 15.2 891.59 18.41 899.27 21.71 909.62 17.51 909.41 14.39 899.6 18.41 891.59 15.2"
            fill="#ccae79"
          />
          <polygon
            points="899.6 18.41 899.27 21.71 909.62 17.51 909.41 14.39 899.6 18.41"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M893.87,16.12a1.44,1.44,0,0,1,0,1.65c.36-.52.45-1.47.61-1.41Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M897.25,17.47a4.56,4.56,0,0,0,2-2l-1.45,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M903.65,16.75a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M907.23,13.25a9.65,9.65,0,0,1-3.18,0,4.64,4.64,0,0,1-2.32.16s1.7-.17,2.32.42A13.32,13.32,0,0,1,907.23,13.25Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M955,30.72l4,2.49a1.29,1.29,0,0,0,1.22.08l9.63-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.32,1.32,0,0,0-1-.3l-13.63,1.81A1.31,1.31,0,0,0,955,30.72Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="962.11 20.77 956.68 21.92 951.9 25.59 959.91 28.8 969.72 24.78 962.11 20.77"
            fill="#ffedc8"
          />
          <polygon
            points="951.9 25.59 951.9 28.8 959.59 32.1 969.94 27.9 969.72 24.78 959.91 28.8 951.9 25.59"
            fill="#ccae79"
          />
          <polygon
            points="959.91 28.8 959.59 32.1 969.94 27.9 969.72 24.78 959.91 28.8"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M954.19,26.51a1.44,1.44,0,0,1,0,1.65c.36-.52.44-1.47.61-1.41Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M957.57,27.86a4.56,4.56,0,0,0,2-2.05l-1.45,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M964,27.14a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M967.55,23.64a9.66,9.66,0,0,1-3.18,0,4.69,4.69,0,0,1-2.33.16s1.71-.17,2.33.41A13.59,13.59,0,0,1,967.55,23.64Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1086.2,34.47l3,1.85a1,1,0,0,0,.91.06l7.16-3.2a1,1,0,0,0,.24-1.62h0a1,1,0,0,0-.76-.23l-10.15,1.35A1,1,0,0,0,1086.2,34.47Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1091.5 27.05 1087.46 27.91 1083.9 30.65 1089.87 33.04 1097.17 30.05 1091.5 27.05"
            fill="#ffedc8"
          />
          <polygon
            points="1083.9 30.65 1083.9 33.04 1089.63 35.49 1097.33 32.36 1097.17 30.05 1089.87 33.04 1083.9 30.65"
            fill="#ccae79"
          />
          <polygon
            points="1089.87 33.04 1089.63 35.49 1097.33 32.36 1097.17 30.05 1089.87 33.04"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1085.6,31.33a1.07,1.07,0,0,1,0,1.23c.27-.39.34-1.1.46-1.05Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1088.12,32.34a3.45,3.45,0,0,0,1.51-1.53l-1.09,1.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1092.88,31.8a1.12,1.12,0,0,1,.6,1l-.18-1.14Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1095.55,29.19a7.07,7.07,0,0,1-2.37,0,3.41,3.41,0,0,1-1.73.12s1.27-.12,1.73.31A10.46,10.46,0,0,1,1095.55,29.19Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M987.05,39.19l3,1.86a1,1,0,0,0,.91.06l7.16-3.2a1,1,0,0,0,.24-1.62h0a.93.93,0,0,0-.76-.23l-10.15,1.35A1,1,0,0,0,987.05,39.19Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="992.35 31.78 988.31 32.64 984.75 35.37 990.72 37.76 998.02 34.77 992.35 31.78"
            fill="#ffedc8"
          />
          <polygon
            points="984.75 35.37 984.75 37.76 990.48 40.22 998.18 37.09 998.02 34.77 990.72 37.76 984.75 35.37"
            fill="#ccae79"
          />
          <polygon
            points="990.72 37.76 990.48 40.22 998.18 37.09 998.02 34.77 990.72 37.76"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M986.45,36.06a1.05,1.05,0,0,1,0,1.22c.27-.38.34-1.09.46-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M989,37.06a3.39,3.39,0,0,0,1.51-1.52l-1.09,1.69Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M993.73,36.53a1.12,1.12,0,0,1,.6,1l-.18-1.14Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M996.4,33.92a7.07,7.07,0,0,1-2.37,0,3.41,3.41,0,0,1-1.73.12s1.27-.12,1.73.31A10.46,10.46,0,0,1,996.4,33.92Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M886.14,9.86l3,1.86a1,1,0,0,0,.91.06l7.16-3.2A1,1,0,0,0,897.43,7h0a.92.92,0,0,0-.76-.23L886.52,8.08A1,1,0,0,0,886.14,9.86Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="891.43 2.45 887.39 3.31 883.83 6.04 889.8 8.44 897.1 5.44 891.43 2.45"
            fill="#ffedc8"
          />
          <polygon
            points="883.83 6.04 883.83 8.44 889.56 10.89 897.26 7.76 897.1 5.44 889.8 8.44 883.83 6.04"
            fill="#ccae79"
          />
          <polygon
            points="889.8 8.44 889.56 10.89 897.26 7.76 897.1 5.44 889.8 8.44"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M885.54,6.73a1.07,1.07,0,0,1,0,1.22c.27-.38.33-1.09.45-1Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M888.05,7.74a3.45,3.45,0,0,0,1.51-1.53l-1.08,1.7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M892.81,7.2a1.12,1.12,0,0,1,.6,1L893.23,7Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M895.48,4.59a7.06,7.06,0,0,1-2.37,0,3.37,3.37,0,0,1-1.72.12s1.26-.12,1.72.31A10.46,10.46,0,0,1,895.48,4.59Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1057.39,38.12l4,2.49a1.29,1.29,0,0,0,1.22.08l9.62-4.3a1.31,1.31,0,0,0,.32-2.18h0a1.3,1.3,0,0,0-1-.3l-13.63,1.81A1.3,1.3,0,0,0,1057.39,38.12Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1064.51 28.16 1059.08 29.32 1054.3 32.99 1062.31 36.2 1072.12 32.18 1064.51 28.16"
            fill="#ffedc8"
          />
          <polygon
            points="1054.3 32.99 1054.3 36.2 1061.99 39.49 1072.33 35.3 1072.12 32.18 1062.31 36.2 1054.3 32.99"
            fill="#ccae79"
          />
          <polygon
            points="1062.31 36.2 1061.99 39.49 1072.33 35.3 1072.12 32.18 1062.31 36.2"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1056.59,33.91a1.45,1.45,0,0,1,0,1.64c.36-.51.44-1.47.61-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1060,35.26a4.6,4.6,0,0,0,2-2l-1.46,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1066.36,34.54a1.48,1.48,0,0,1,.8,1.3l-.24-1.53Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1070,31a9.72,9.72,0,0,1-3.19,0,4.65,4.65,0,0,1-2.32.16s1.7-.17,2.32.41A13.73,13.73,0,0,1,1070,31Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1005.54,27.77l4,2.49a1.32,1.32,0,0,0,1.22.09L1020.4,26a1.3,1.3,0,0,0,.32-2.17h0a1.29,1.29,0,0,0-1-.31l-13.63,1.81A1.31,1.31,0,0,0,1005.54,27.77Z"
          fill="#111160"
          opacity="0.68"
        />
        <g>
          <polygon
            points="1012.66 17.82 1007.23 18.97 1002.45 22.64 1010.46 25.85 1020.27 21.84 1012.66 17.82"
            fill="#ffedc8"
          />
          <polygon
            points="1002.45 22.64 1002.45 25.85 1010.14 29.15 1020.49 24.95 1020.27 21.84 1010.46 25.85 1002.45 22.64"
            fill="#ccae79"
          />
          <polygon
            points="1010.46 25.85 1010.14 29.15 1020.49 24.95 1020.27 21.84 1010.46 25.85"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1004.74,23.56a1.44,1.44,0,0,1,0,1.65c.36-.52.44-1.47.61-1.4Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1008.12,24.91a4.56,4.56,0,0,0,2-2.05l-1.45,2.28Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1014.51,24.19a1.5,1.5,0,0,1,.8,1.3l-.24-1.52Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1018.1,20.69a9.38,9.38,0,0,1-3.18,0,4.55,4.55,0,0,1-2.33.16s1.71-.16,2.33.42A13.78,13.78,0,0,1,1018.1,20.69Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M1104.51,24.22s1.69,3.36,4,3.93,5.91-1.78,5.36.16,4.44,2.8,6.57,2.27,6.83-5.09,6.8-6.54S1104.51,24.22,1104.51,24.22Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M1104.43,21.47l.08,2.75,4,2.82,5.25-.14,1.25,2s3.63,1.69,6-.16a19.74,19.74,0,0,0,4.24-5.1l-.07-2.76Z"
            fill="#ccae79"
          />
          <path
            d="M1108.65,19.56l-4.22,1.91,4.35,2.8,5-.13,1.68,2.07s4.94,1.33,5.54-.15,4.25-5.16,4.25-5.16l-4-1.68Z"
            fill="#ffedc8"
          />
          <polygon
            points="1108.78 24.27 1108.56 27.04 1113.81 26.9 1113.8 24.14 1108.78 24.27"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1119.77,26.72s.87,2.51.08,2.68a12,12,0,0,0,5.49-5.74l-.07-2.76S1120.93,26.7,1119.77,26.72Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M1116.38,26.42l1,.18s-.62-.16-.47,1A2.74,2.74,0,0,0,1116.38,26.42Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1118.66,26.77c-.11,0,.2,0,1.09-.93a5.86,5.86,0,0,0,1.22-1.9s-2.13,2.47-1.6,2.81Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1107,23.11a15.82,15.82,0,0,1,.06,2s-.12-1.5.3-1.76Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1114.69,19.4l2,0c.14,0-1.57,0-2,.94l0-.89"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M1106.56,20.51l1-.47s-.59.37-.36.45,1.17.45,1.55.25a1.58,1.58,0,0,1,1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
      <g>
        <path
          d="M930.23,13.32s1.69,3.36,4,3.93,5.9-1.78,5.36.16,4.43,2.8,6.57,2.27,6.83-5.09,6.8-6.54S930.23,13.32,930.23,13.32Z"
          fill="#131b8c"
          opacity="0.63"
        />
        <g>
          <path
            d="M930.16,10.56l.07,2.76,4.06,2.82,5.25-.14,1.25,2s3.62,1.69,6-.16a19.74,19.74,0,0,0,4.24-5.1L951,10Z"
            fill="#ccae79"
          />
          <path
            d="M934.38,8.66l-4.22,1.9,4.35,2.81,5-.13,1.69,2.07s4.94,1.32,5.54-.15S951,10,951,10l-4-1.68Z"
            fill="#ffedc8"
          />
          <polygon
            points="934.5 13.37 934.29 16.14 939.54 16 939.52 13.24 934.5 13.37"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M945.5,15.82s.86,2.51.07,2.68a12.08,12.08,0,0,0,5.5-5.74L951,10S946.65,15.8,945.5,15.82Z"
            fill="#0416bf"
            opacity="0.14"
          />
          <path
            d="M942.11,15.51l1,.19s-.62-.16-.47,1A2.9,2.9,0,0,0,942.11,15.51Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M944.39,15.87c-.11,0,.19,0,1.08-.93A5.9,5.9,0,0,0,946.7,13s-2.13,2.47-1.61,2.81Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M932.7,12.21a16.74,16.74,0,0,1,0,2s-.11-1.5.31-1.76Z"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M940.42,8.5l2-.06c.15,0-1.57,0-2,1l0-.89"
            fill="#996537"
            opacity="0.51"
          />
          <path
            d="M932.28,9.61l1.05-.48s-.59.38-.35.46,1.17.45,1.54.25a1.53,1.53,0,0,1,1,0Z"
            fill="#996537"
            opacity="0.51"
          />
        </g>
      </g>
    </g>
  );
};

export default Trope1;
